module.exports = {
	"version": "2.0",
	"metadata": {
		"apiVersion": "2016-11-15",
		"endpointPrefix": "ec2",
		"protocol": "ec2",
		"serviceAbbreviation": "Amazon EC2",
		"serviceFullName": "Amazon Elastic Compute Cloud",
		"signatureVersion": "v4",
		"uid": "ec2-2016-11-15",
		"xmlNamespace": "http://ec2.amazonaws.com/doc/2016-11-15"
	},
	"operations": {
		"AcceptReservedInstancesExchangeQuote": {
			"input": {
				"type": "structure",
				"required": [
					"ReservedInstanceIds"
				],
				"members": {
					"DryRun": {
						"type": "boolean"
					},
					"ReservedInstanceIds": {
						"shape": "S3",
						"locationName": "ReservedInstanceId"
					},
					"TargetConfigurations": {
						"shape": "S5",
						"locationName": "TargetConfiguration"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"ExchangeId": {
						"locationName": "exchangeId"
					}
				}
			}
		},
		"AcceptVpcPeeringConnection": {
			"input": {
				"type": "structure",
				"members": {
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					},
					"VpcPeeringConnectionId": {
						"locationName": "vpcPeeringConnectionId"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"VpcPeeringConnection": {
						"shape": "Sb",
						"locationName": "vpcPeeringConnection"
					}
				}
			}
		},
		"AllocateAddress": {
			"input": {
				"type": "structure",
				"members": {
					"Domain": {},
					"Address": {},
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"PublicIp": {
						"locationName": "publicIp"
					},
					"AllocationId": {
						"locationName": "allocationId"
					},
					"Domain": {
						"locationName": "domain"
					}
				}
			}
		},
		"AllocateHosts": {
			"input": {
				"type": "structure",
				"required": [
					"AvailabilityZone",
					"InstanceType",
					"Quantity"
				],
				"members": {
					"AutoPlacement": {
						"locationName": "autoPlacement"
					},
					"AvailabilityZone": {
						"locationName": "availabilityZone"
					},
					"ClientToken": {
						"locationName": "clientToken"
					},
					"InstanceType": {
						"locationName": "instanceType"
					},
					"Quantity": {
						"locationName": "quantity",
						"type": "integer"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"HostIds": {
						"shape": "St",
						"locationName": "hostIdSet"
					}
				}
			}
		},
		"AssignIpv6Addresses": {
			"input": {
				"type": "structure",
				"required": [
					"NetworkInterfaceId"
				],
				"members": {
					"Ipv6AddressCount": {
						"locationName": "ipv6AddressCount",
						"type": "integer"
					},
					"Ipv6Addresses": {
						"shape": "Sv",
						"locationName": "ipv6Addresses"
					},
					"NetworkInterfaceId": {
						"locationName": "networkInterfaceId"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"AssignedIpv6Addresses": {
						"shape": "Sv",
						"locationName": "assignedIpv6Addresses"
					},
					"NetworkInterfaceId": {
						"locationName": "networkInterfaceId"
					}
				}
			}
		},
		"AssignPrivateIpAddresses": {
			"input": {
				"type": "structure",
				"required": [
					"NetworkInterfaceId"
				],
				"members": {
					"AllowReassignment": {
						"locationName": "allowReassignment",
						"type": "boolean"
					},
					"NetworkInterfaceId": {
						"locationName": "networkInterfaceId"
					},
					"PrivateIpAddresses": {
						"shape": "Sy",
						"locationName": "privateIpAddress"
					},
					"SecondaryPrivateIpAddressCount": {
						"locationName": "secondaryPrivateIpAddressCount",
						"type": "integer"
					}
				}
			}
		},
		"AssociateAddress": {
			"input": {
				"type": "structure",
				"members": {
					"AllocationId": {},
					"InstanceId": {},
					"PublicIp": {},
					"AllowReassociation": {
						"locationName": "allowReassociation",
						"type": "boolean"
					},
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					},
					"NetworkInterfaceId": {
						"locationName": "networkInterfaceId"
					},
					"PrivateIpAddress": {
						"locationName": "privateIpAddress"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"AssociationId": {
						"locationName": "associationId"
					}
				}
			}
		},
		"AssociateDhcpOptions": {
			"input": {
				"type": "structure",
				"required": [
					"DhcpOptionsId",
					"VpcId"
				],
				"members": {
					"DhcpOptionsId": {},
					"VpcId": {},
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					}
				}
			}
		},
		"AssociateIamInstanceProfile": {
			"input": {
				"type": "structure",
				"required": [
					"IamInstanceProfile",
					"InstanceId"
				],
				"members": {
					"IamInstanceProfile": {
						"shape": "S13"
					},
					"InstanceId": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"IamInstanceProfileAssociation": {
						"shape": "S15",
						"locationName": "iamInstanceProfileAssociation"
					}
				}
			}
		},
		"AssociateRouteTable": {
			"input": {
				"type": "structure",
				"required": [
					"RouteTableId",
					"SubnetId"
				],
				"members": {
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					},
					"RouteTableId": {
						"locationName": "routeTableId"
					},
					"SubnetId": {
						"locationName": "subnetId"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"AssociationId": {
						"locationName": "associationId"
					}
				}
			}
		},
		"AssociateSubnetCidrBlock": {
			"input": {
				"type": "structure",
				"required": [
					"Ipv6CidrBlock",
					"SubnetId"
				],
				"members": {
					"Ipv6CidrBlock": {
						"locationName": "ipv6CidrBlock"
					},
					"SubnetId": {
						"locationName": "subnetId"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Ipv6CidrBlockAssociation": {
						"shape": "S1c",
						"locationName": "ipv6CidrBlockAssociation"
					},
					"SubnetId": {
						"locationName": "subnetId"
					}
				}
			}
		},
		"AssociateVpcCidrBlock": {
			"input": {
				"type": "structure",
				"required": [
					"VpcId"
				],
				"members": {
					"AmazonProvidedIpv6CidrBlock": {
						"locationName": "amazonProvidedIpv6CidrBlock",
						"type": "boolean"
					},
					"CidrBlock": {},
					"VpcId": {
						"locationName": "vpcId"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Ipv6CidrBlockAssociation": {
						"shape": "S1h",
						"locationName": "ipv6CidrBlockAssociation"
					},
					"CidrBlockAssociation": {
						"shape": "S1k",
						"locationName": "cidrBlockAssociation"
					},
					"VpcId": {
						"locationName": "vpcId"
					}
				}
			}
		},
		"AttachClassicLinkVpc": {
			"input": {
				"type": "structure",
				"required": [
					"Groups",
					"InstanceId",
					"VpcId"
				],
				"members": {
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					},
					"Groups": {
						"shape": "S1m",
						"locationName": "SecurityGroupId"
					},
					"InstanceId": {
						"locationName": "instanceId"
					},
					"VpcId": {
						"locationName": "vpcId"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Return": {
						"locationName": "return",
						"type": "boolean"
					}
				}
			}
		},
		"AttachInternetGateway": {
			"input": {
				"type": "structure",
				"required": [
					"InternetGatewayId",
					"VpcId"
				],
				"members": {
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					},
					"InternetGatewayId": {
						"locationName": "internetGatewayId"
					},
					"VpcId": {
						"locationName": "vpcId"
					}
				}
			}
		},
		"AttachNetworkInterface": {
			"input": {
				"type": "structure",
				"required": [
					"DeviceIndex",
					"InstanceId",
					"NetworkInterfaceId"
				],
				"members": {
					"DeviceIndex": {
						"locationName": "deviceIndex",
						"type": "integer"
					},
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					},
					"InstanceId": {
						"locationName": "instanceId"
					},
					"NetworkInterfaceId": {
						"locationName": "networkInterfaceId"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"AttachmentId": {
						"locationName": "attachmentId"
					}
				}
			}
		},
		"AttachVolume": {
			"input": {
				"type": "structure",
				"required": [
					"Device",
					"InstanceId",
					"VolumeId"
				],
				"members": {
					"Device": {},
					"InstanceId": {},
					"VolumeId": {},
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					}
				}
			},
			"output": {
				"shape": "S1s"
			}
		},
		"AttachVpnGateway": {
			"input": {
				"type": "structure",
				"required": [
					"VpcId",
					"VpnGatewayId"
				],
				"members": {
					"VpcId": {},
					"VpnGatewayId": {},
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"VpcAttachment": {
						"shape": "S1w",
						"locationName": "attachment"
					}
				}
			}
		},
		"AuthorizeSecurityGroupEgress": {
			"input": {
				"type": "structure",
				"required": [
					"GroupId"
				],
				"members": {
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					},
					"GroupId": {
						"locationName": "groupId"
					},
					"IpPermissions": {
						"shape": "S1z",
						"locationName": "ipPermissions"
					},
					"CidrIp": {
						"locationName": "cidrIp"
					},
					"FromPort": {
						"locationName": "fromPort",
						"type": "integer"
					},
					"IpProtocol": {
						"locationName": "ipProtocol"
					},
					"ToPort": {
						"locationName": "toPort",
						"type": "integer"
					},
					"SourceSecurityGroupName": {
						"locationName": "sourceSecurityGroupName"
					},
					"SourceSecurityGroupOwnerId": {
						"locationName": "sourceSecurityGroupOwnerId"
					}
				}
			}
		},
		"AuthorizeSecurityGroupIngress": {
			"input": {
				"type": "structure",
				"members": {
					"CidrIp": {},
					"FromPort": {
						"type": "integer"
					},
					"GroupId": {},
					"GroupName": {},
					"IpPermissions": {
						"shape": "S1z"
					},
					"IpProtocol": {},
					"SourceSecurityGroupName": {},
					"SourceSecurityGroupOwnerId": {},
					"ToPort": {
						"type": "integer"
					},
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					}
				}
			}
		},
		"BundleInstance": {
			"input": {
				"type": "structure",
				"required": [
					"InstanceId",
					"Storage"
				],
				"members": {
					"InstanceId": {},
					"Storage": {
						"shape": "S2b"
					},
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"BundleTask": {
						"shape": "S2f",
						"locationName": "bundleInstanceTask"
					}
				}
			}
		},
		"CancelBundleTask": {
			"input": {
				"type": "structure",
				"required": [
					"BundleId"
				],
				"members": {
					"BundleId": {},
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"BundleTask": {
						"shape": "S2f",
						"locationName": "bundleInstanceTask"
					}
				}
			}
		},
		"CancelConversionTask": {
			"input": {
				"type": "structure",
				"required": [
					"ConversionTaskId"
				],
				"members": {
					"ConversionTaskId": {
						"locationName": "conversionTaskId"
					},
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					},
					"ReasonMessage": {
						"locationName": "reasonMessage"
					}
				}
			}
		},
		"CancelExportTask": {
			"input": {
				"type": "structure",
				"required": [
					"ExportTaskId"
				],
				"members": {
					"ExportTaskId": {
						"locationName": "exportTaskId"
					}
				}
			}
		},
		"CancelImportTask": {
			"input": {
				"type": "structure",
				"members": {
					"CancelReason": {},
					"DryRun": {
						"type": "boolean"
					},
					"ImportTaskId": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"ImportTaskId": {
						"locationName": "importTaskId"
					},
					"PreviousState": {
						"locationName": "previousState"
					},
					"State": {
						"locationName": "state"
					}
				}
			}
		},
		"CancelReservedInstancesListing": {
			"input": {
				"type": "structure",
				"required": [
					"ReservedInstancesListingId"
				],
				"members": {
					"ReservedInstancesListingId": {
						"locationName": "reservedInstancesListingId"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"ReservedInstancesListings": {
						"shape": "S2q",
						"locationName": "reservedInstancesListingsSet"
					}
				}
			}
		},
		"CancelSpotFleetRequests": {
			"input": {
				"type": "structure",
				"required": [
					"SpotFleetRequestIds",
					"TerminateInstances"
				],
				"members": {
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					},
					"SpotFleetRequestIds": {
						"shape": "S32",
						"locationName": "spotFleetRequestId"
					},
					"TerminateInstances": {
						"locationName": "terminateInstances",
						"type": "boolean"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"SuccessfulFleetRequests": {
						"locationName": "successfulFleetRequestSet",
						"type": "list",
						"member": {
							"locationName": "item",
							"type": "structure",
							"required": [
								"CurrentSpotFleetRequestState",
								"PreviousSpotFleetRequestState",
								"SpotFleetRequestId"
							],
							"members": {
								"CurrentSpotFleetRequestState": {
									"locationName": "currentSpotFleetRequestState"
								},
								"PreviousSpotFleetRequestState": {
									"locationName": "previousSpotFleetRequestState"
								},
								"SpotFleetRequestId": {
									"locationName": "spotFleetRequestId"
								}
							}
						}
					},
					"UnsuccessfulFleetRequests": {
						"locationName": "unsuccessfulFleetRequestSet",
						"type": "list",
						"member": {
							"locationName": "item",
							"type": "structure",
							"required": [
								"Error",
								"SpotFleetRequestId"
							],
							"members": {
								"Error": {
									"locationName": "error",
									"type": "structure",
									"required": [
										"Code",
										"Message"
									],
									"members": {
										"Code": {
											"locationName": "code"
										},
										"Message": {
											"locationName": "message"
										}
									}
								},
								"SpotFleetRequestId": {
									"locationName": "spotFleetRequestId"
								}
							}
						}
					}
				}
			}
		},
		"CancelSpotInstanceRequests": {
			"input": {
				"type": "structure",
				"required": [
					"SpotInstanceRequestIds"
				],
				"members": {
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					},
					"SpotInstanceRequestIds": {
						"shape": "S3c",
						"locationName": "SpotInstanceRequestId"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"CancelledSpotInstanceRequests": {
						"locationName": "spotInstanceRequestSet",
						"type": "list",
						"member": {
							"locationName": "item",
							"type": "structure",
							"members": {
								"SpotInstanceRequestId": {
									"locationName": "spotInstanceRequestId"
								},
								"State": {
									"locationName": "state"
								}
							}
						}
					}
				}
			}
		},
		"ConfirmProductInstance": {
			"input": {
				"type": "structure",
				"required": [
					"InstanceId",
					"ProductCode"
				],
				"members": {
					"InstanceId": {},
					"ProductCode": {},
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"OwnerId": {
						"locationName": "ownerId"
					},
					"Return": {
						"locationName": "return",
						"type": "boolean"
					}
				}
			}
		},
		"CopyImage": {
			"input": {
				"type": "structure",
				"required": [
					"Name",
					"SourceImageId",
					"SourceRegion"
				],
				"members": {
					"ClientToken": {},
					"Description": {},
					"Encrypted": {
						"locationName": "encrypted",
						"type": "boolean"
					},
					"KmsKeyId": {
						"locationName": "kmsKeyId"
					},
					"Name": {},
					"SourceImageId": {},
					"SourceRegion": {},
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"ImageId": {
						"locationName": "imageId"
					}
				}
			}
		},
		"CopySnapshot": {
			"input": {
				"type": "structure",
				"required": [
					"SourceRegion",
					"SourceSnapshotId"
				],
				"members": {
					"Description": {},
					"DestinationRegion": {
						"locationName": "destinationRegion"
					},
					"Encrypted": {
						"locationName": "encrypted",
						"type": "boolean"
					},
					"KmsKeyId": {
						"locationName": "kmsKeyId"
					},
					"PresignedUrl": {
						"locationName": "presignedUrl"
					},
					"SourceRegion": {},
					"SourceSnapshotId": {},
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"SnapshotId": {
						"locationName": "snapshotId"
					}
				}
			}
		},
		"CreateCustomerGateway": {
			"input": {
				"type": "structure",
				"required": [
					"BgpAsn",
					"PublicIp",
					"Type"
				],
				"members": {
					"BgpAsn": {
						"type": "integer"
					},
					"PublicIp": {
						"locationName": "IpAddress"
					},
					"Type": {},
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"CustomerGateway": {
						"shape": "S3q",
						"locationName": "customerGateway"
					}
				}
			}
		},
		"CreateDefaultVpc": {
			"input": {
				"type": "structure",
				"members": {
					"DryRun": {
						"type": "boolean"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Vpc": {
						"shape": "S3t",
						"locationName": "vpc"
					}
				}
			}
		},
		"CreateDhcpOptions": {
			"input": {
				"type": "structure",
				"required": [
					"DhcpConfigurations"
				],
				"members": {
					"DhcpConfigurations": {
						"locationName": "dhcpConfiguration",
						"type": "list",
						"member": {
							"locationName": "item",
							"type": "structure",
							"members": {
								"Key": {
									"locationName": "key"
								},
								"Values": {
									"shape": "S32",
									"locationName": "Value"
								}
							}
						}
					},
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"DhcpOptions": {
						"shape": "S42",
						"locationName": "dhcpOptions"
					}
				}
			}
		},
		"CreateEgressOnlyInternetGateway": {
			"input": {
				"type": "structure",
				"required": [
					"VpcId"
				],
				"members": {
					"ClientToken": {},
					"DryRun": {
						"type": "boolean"
					},
					"VpcId": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"ClientToken": {
						"locationName": "clientToken"
					},
					"EgressOnlyInternetGateway": {
						"shape": "S49",
						"locationName": "egressOnlyInternetGateway"
					}
				}
			}
		},
		"CreateFlowLogs": {
			"input": {
				"type": "structure",
				"required": [
					"DeliverLogsPermissionArn",
					"LogGroupName",
					"ResourceIds",
					"ResourceType",
					"TrafficType"
				],
				"members": {
					"ClientToken": {},
					"DeliverLogsPermissionArn": {},
					"LogGroupName": {},
					"ResourceIds": {
						"shape": "S32",
						"locationName": "ResourceId"
					},
					"ResourceType": {},
					"TrafficType": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"ClientToken": {
						"locationName": "clientToken"
					},
					"FlowLogIds": {
						"shape": "S32",
						"locationName": "flowLogIdSet"
					},
					"Unsuccessful": {
						"shape": "S4h",
						"locationName": "unsuccessful"
					}
				}
			}
		},
		"CreateFpgaImage": {
			"input": {
				"type": "structure",
				"required": [
					"InputStorageLocation"
				],
				"members": {
					"DryRun": {
						"type": "boolean"
					},
					"InputStorageLocation": {
						"shape": "S4l"
					},
					"LogsStorageLocation": {
						"shape": "S4l"
					},
					"Description": {},
					"Name": {},
					"ClientToken": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"FpgaImageId": {
						"locationName": "fpgaImageId"
					},
					"FpgaImageGlobalId": {
						"locationName": "fpgaImageGlobalId"
					}
				}
			}
		},
		"CreateImage": {
			"input": {
				"type": "structure",
				"required": [
					"InstanceId",
					"Name"
				],
				"members": {
					"BlockDeviceMappings": {
						"shape": "S4o",
						"locationName": "blockDeviceMapping"
					},
					"Description": {
						"locationName": "description"
					},
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					},
					"InstanceId": {
						"locationName": "instanceId"
					},
					"Name": {
						"locationName": "name"
					},
					"NoReboot": {
						"locationName": "noReboot",
						"type": "boolean"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"ImageId": {
						"locationName": "imageId"
					}
				}
			}
		},
		"CreateInstanceExportTask": {
			"input": {
				"type": "structure",
				"required": [
					"InstanceId"
				],
				"members": {
					"Description": {
						"locationName": "description"
					},
					"ExportToS3Task": {
						"locationName": "exportToS3",
						"type": "structure",
						"members": {
							"ContainerFormat": {
								"locationName": "containerFormat"
							},
							"DiskImageFormat": {
								"locationName": "diskImageFormat"
							},
							"S3Bucket": {
								"locationName": "s3Bucket"
							},
							"S3Prefix": {
								"locationName": "s3Prefix"
							}
						}
					},
					"InstanceId": {
						"locationName": "instanceId"
					},
					"TargetEnvironment": {
						"locationName": "targetEnvironment"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"ExportTask": {
						"shape": "S4z",
						"locationName": "exportTask"
					}
				}
			}
		},
		"CreateInternetGateway": {
			"input": {
				"type": "structure",
				"members": {
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"InternetGateway": {
						"shape": "S55",
						"locationName": "internetGateway"
					}
				}
			}
		},
		"CreateKeyPair": {
			"input": {
				"type": "structure",
				"required": [
					"KeyName"
				],
				"members": {
					"KeyName": {},
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"KeyFingerprint": {
						"locationName": "keyFingerprint"
					},
					"KeyMaterial": {
						"locationName": "keyMaterial"
					},
					"KeyName": {
						"locationName": "keyName"
					}
				}
			}
		},
		"CreateNatGateway": {
			"input": {
				"type": "structure",
				"required": [
					"AllocationId",
					"SubnetId"
				],
				"members": {
					"AllocationId": {},
					"ClientToken": {},
					"SubnetId": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"ClientToken": {
						"locationName": "clientToken"
					},
					"NatGateway": {
						"shape": "S5a",
						"locationName": "natGateway"
					}
				}
			}
		},
		"CreateNetworkAcl": {
			"input": {
				"type": "structure",
				"required": [
					"VpcId"
				],
				"members": {
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					},
					"VpcId": {
						"locationName": "vpcId"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"NetworkAcl": {
						"shape": "S5h",
						"locationName": "networkAcl"
					}
				}
			}
		},
		"CreateNetworkAclEntry": {
			"input": {
				"type": "structure",
				"required": [
					"Egress",
					"NetworkAclId",
					"Protocol",
					"RuleAction",
					"RuleNumber"
				],
				"members": {
					"CidrBlock": {
						"locationName": "cidrBlock"
					},
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					},
					"Egress": {
						"locationName": "egress",
						"type": "boolean"
					},
					"IcmpTypeCode": {
						"shape": "S5m",
						"locationName": "Icmp"
					},
					"Ipv6CidrBlock": {
						"locationName": "ipv6CidrBlock"
					},
					"NetworkAclId": {
						"locationName": "networkAclId"
					},
					"PortRange": {
						"shape": "S5n",
						"locationName": "portRange"
					},
					"Protocol": {
						"locationName": "protocol"
					},
					"RuleAction": {
						"locationName": "ruleAction"
					},
					"RuleNumber": {
						"locationName": "ruleNumber",
						"type": "integer"
					}
				}
			}
		},
		"CreateNetworkInterface": {
			"input": {
				"type": "structure",
				"required": [
					"SubnetId"
				],
				"members": {
					"Description": {
						"locationName": "description"
					},
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					},
					"Groups": {
						"shape": "S5r",
						"locationName": "SecurityGroupId"
					},
					"Ipv6AddressCount": {
						"locationName": "ipv6AddressCount",
						"type": "integer"
					},
					"Ipv6Addresses": {
						"shape": "S5s",
						"locationName": "ipv6Addresses"
					},
					"PrivateIpAddress": {
						"locationName": "privateIpAddress"
					},
					"PrivateIpAddresses": {
						"shape": "S5u",
						"locationName": "privateIpAddresses"
					},
					"SecondaryPrivateIpAddressCount": {
						"locationName": "secondaryPrivateIpAddressCount",
						"type": "integer"
					},
					"SubnetId": {
						"locationName": "subnetId"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"NetworkInterface": {
						"shape": "S5x",
						"locationName": "networkInterface"
					}
				}
			}
		},
		"CreateNetworkInterfacePermission": {
			"input": {
				"type": "structure",
				"required": [
					"NetworkInterfaceId",
					"Permission"
				],
				"members": {
					"NetworkInterfaceId": {},
					"AwsAccountId": {},
					"AwsService": {},
					"Permission": {},
					"DryRun": {
						"type": "boolean"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"InterfacePermission": {
						"shape": "S6b",
						"locationName": "interfacePermission"
					}
				}
			}
		},
		"CreatePlacementGroup": {
			"input": {
				"type": "structure",
				"required": [
					"GroupName",
					"Strategy"
				],
				"members": {
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					},
					"GroupName": {
						"locationName": "groupName"
					},
					"Strategy": {
						"locationName": "strategy"
					}
				}
			}
		},
		"CreateReservedInstancesListing": {
			"input": {
				"type": "structure",
				"required": [
					"ClientToken",
					"InstanceCount",
					"PriceSchedules",
					"ReservedInstancesId"
				],
				"members": {
					"ClientToken": {
						"locationName": "clientToken"
					},
					"InstanceCount": {
						"locationName": "instanceCount",
						"type": "integer"
					},
					"PriceSchedules": {
						"locationName": "priceSchedules",
						"type": "list",
						"member": {
							"locationName": "item",
							"type": "structure",
							"members": {
								"CurrencyCode": {
									"locationName": "currencyCode"
								},
								"Price": {
									"locationName": "price",
									"type": "double"
								},
								"Term": {
									"locationName": "term",
									"type": "long"
								}
							}
						}
					},
					"ReservedInstancesId": {
						"locationName": "reservedInstancesId"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"ReservedInstancesListings": {
						"shape": "S2q",
						"locationName": "reservedInstancesListingsSet"
					}
				}
			}
		},
		"CreateRoute": {
			"input": {
				"type": "structure",
				"required": [
					"RouteTableId"
				],
				"members": {
					"DestinationCidrBlock": {
						"locationName": "destinationCidrBlock"
					},
					"DestinationIpv6CidrBlock": {
						"locationName": "destinationIpv6CidrBlock"
					},
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					},
					"EgressOnlyInternetGatewayId": {
						"locationName": "egressOnlyInternetGatewayId"
					},
					"GatewayId": {
						"locationName": "gatewayId"
					},
					"InstanceId": {
						"locationName": "instanceId"
					},
					"NatGatewayId": {
						"locationName": "natGatewayId"
					},
					"NetworkInterfaceId": {
						"locationName": "networkInterfaceId"
					},
					"RouteTableId": {
						"locationName": "routeTableId"
					},
					"VpcPeeringConnectionId": {
						"locationName": "vpcPeeringConnectionId"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Return": {
						"locationName": "return",
						"type": "boolean"
					}
				}
			}
		},
		"CreateRouteTable": {
			"input": {
				"type": "structure",
				"required": [
					"VpcId"
				],
				"members": {
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					},
					"VpcId": {
						"locationName": "vpcId"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"RouteTable": {
						"shape": "S6o",
						"locationName": "routeTable"
					}
				}
			}
		},
		"CreateSecurityGroup": {
			"input": {
				"type": "structure",
				"required": [
					"Description",
					"GroupName"
				],
				"members": {
					"Description": {
						"locationName": "GroupDescription"
					},
					"GroupName": {},
					"VpcId": {},
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"GroupId": {
						"locationName": "groupId"
					}
				}
			}
		},
		"CreateSnapshot": {
			"input": {
				"type": "structure",
				"required": [
					"VolumeId"
				],
				"members": {
					"Description": {},
					"VolumeId": {},
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					}
				}
			},
			"output": {
				"shape": "S70"
			}
		},
		"CreateSpotDatafeedSubscription": {
			"input": {
				"type": "structure",
				"required": [
					"Bucket"
				],
				"members": {
					"Bucket": {
						"locationName": "bucket"
					},
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					},
					"Prefix": {
						"locationName": "prefix"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"SpotDatafeedSubscription": {
						"shape": "S74",
						"locationName": "spotDatafeedSubscription"
					}
				}
			}
		},
		"CreateSubnet": {
			"input": {
				"type": "structure",
				"required": [
					"CidrBlock",
					"VpcId"
				],
				"members": {
					"AvailabilityZone": {},
					"CidrBlock": {},
					"Ipv6CidrBlock": {},
					"VpcId": {},
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Subnet": {
						"shape": "S79",
						"locationName": "subnet"
					}
				}
			}
		},
		"CreateTags": {
			"input": {
				"type": "structure",
				"required": [
					"Resources",
					"Tags"
				],
				"members": {
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					},
					"Resources": {
						"shape": "S7d",
						"locationName": "ResourceId"
					},
					"Tags": {
						"shape": "Sl",
						"locationName": "Tag"
					}
				}
			}
		},
		"CreateVolume": {
			"input": {
				"type": "structure",
				"required": [
					"AvailabilityZone"
				],
				"members": {
					"AvailabilityZone": {},
					"Encrypted": {
						"locationName": "encrypted",
						"type": "boolean"
					},
					"Iops": {
						"type": "integer"
					},
					"KmsKeyId": {},
					"Size": {
						"type": "integer"
					},
					"SnapshotId": {},
					"VolumeType": {},
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					},
					"TagSpecifications": {
						"shape": "S7f",
						"locationName": "TagSpecification"
					}
				}
			},
			"output": {
				"shape": "S7i"
			}
		},
		"CreateVpc": {
			"input": {
				"type": "structure",
				"required": [
					"CidrBlock"
				],
				"members": {
					"CidrBlock": {},
					"AmazonProvidedIpv6CidrBlock": {
						"locationName": "amazonProvidedIpv6CidrBlock",
						"type": "boolean"
					},
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					},
					"InstanceTenancy": {
						"locationName": "instanceTenancy"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Vpc": {
						"shape": "S3t",
						"locationName": "vpc"
					}
				}
			}
		},
		"CreateVpcEndpoint": {
			"input": {
				"type": "structure",
				"required": [
					"ServiceName",
					"VpcId"
				],
				"members": {
					"ClientToken": {},
					"DryRun": {
						"type": "boolean"
					},
					"PolicyDocument": {},
					"RouteTableIds": {
						"shape": "S32",
						"locationName": "RouteTableId"
					},
					"ServiceName": {},
					"VpcId": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"ClientToken": {
						"locationName": "clientToken"
					},
					"VpcEndpoint": {
						"shape": "S7p",
						"locationName": "vpcEndpoint"
					}
				}
			}
		},
		"CreateVpcPeeringConnection": {
			"input": {
				"type": "structure",
				"members": {
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					},
					"PeerOwnerId": {
						"locationName": "peerOwnerId"
					},
					"PeerVpcId": {
						"locationName": "peerVpcId"
					},
					"VpcId": {
						"locationName": "vpcId"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"VpcPeeringConnection": {
						"shape": "Sb",
						"locationName": "vpcPeeringConnection"
					}
				}
			}
		},
		"CreateVpnConnection": {
			"input": {
				"type": "structure",
				"required": [
					"CustomerGatewayId",
					"Type",
					"VpnGatewayId"
				],
				"members": {
					"CustomerGatewayId": {},
					"Type": {},
					"VpnGatewayId": {},
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					},
					"Options": {
						"locationName": "options",
						"type": "structure",
						"members": {
							"StaticRoutesOnly": {
								"locationName": "staticRoutesOnly",
								"type": "boolean"
							}
						}
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"VpnConnection": {
						"shape": "S7w",
						"locationName": "vpnConnection"
					}
				}
			}
		},
		"CreateVpnConnectionRoute": {
			"input": {
				"type": "structure",
				"required": [
					"DestinationCidrBlock",
					"VpnConnectionId"
				],
				"members": {
					"DestinationCidrBlock": {},
					"VpnConnectionId": {}
				}
			}
		},
		"CreateVpnGateway": {
			"input": {
				"type": "structure",
				"required": [
					"Type"
				],
				"members": {
					"AvailabilityZone": {},
					"Type": {},
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"VpnGateway": {
						"shape": "S88",
						"locationName": "vpnGateway"
					}
				}
			}
		},
		"DeleteCustomerGateway": {
			"input": {
				"type": "structure",
				"required": [
					"CustomerGatewayId"
				],
				"members": {
					"CustomerGatewayId": {},
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					}
				}
			}
		},
		"DeleteDhcpOptions": {
			"input": {
				"type": "structure",
				"required": [
					"DhcpOptionsId"
				],
				"members": {
					"DhcpOptionsId": {},
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					}
				}
			}
		},
		"DeleteEgressOnlyInternetGateway": {
			"input": {
				"type": "structure",
				"required": [
					"EgressOnlyInternetGatewayId"
				],
				"members": {
					"DryRun": {
						"type": "boolean"
					},
					"EgressOnlyInternetGatewayId": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"ReturnCode": {
						"locationName": "returnCode",
						"type": "boolean"
					}
				}
			}
		},
		"DeleteFlowLogs": {
			"input": {
				"type": "structure",
				"required": [
					"FlowLogIds"
				],
				"members": {
					"FlowLogIds": {
						"shape": "S32",
						"locationName": "FlowLogId"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Unsuccessful": {
						"shape": "S4h",
						"locationName": "unsuccessful"
					}
				}
			}
		},
		"DeleteInternetGateway": {
			"input": {
				"type": "structure",
				"required": [
					"InternetGatewayId"
				],
				"members": {
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					},
					"InternetGatewayId": {
						"locationName": "internetGatewayId"
					}
				}
			}
		},
		"DeleteKeyPair": {
			"input": {
				"type": "structure",
				"required": [
					"KeyName"
				],
				"members": {
					"KeyName": {},
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					}
				}
			}
		},
		"DeleteNatGateway": {
			"input": {
				"type": "structure",
				"required": [
					"NatGatewayId"
				],
				"members": {
					"NatGatewayId": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"NatGatewayId": {
						"locationName": "natGatewayId"
					}
				}
			}
		},
		"DeleteNetworkAcl": {
			"input": {
				"type": "structure",
				"required": [
					"NetworkAclId"
				],
				"members": {
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					},
					"NetworkAclId": {
						"locationName": "networkAclId"
					}
				}
			}
		},
		"DeleteNetworkAclEntry": {
			"input": {
				"type": "structure",
				"required": [
					"Egress",
					"NetworkAclId",
					"RuleNumber"
				],
				"members": {
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					},
					"Egress": {
						"locationName": "egress",
						"type": "boolean"
					},
					"NetworkAclId": {
						"locationName": "networkAclId"
					},
					"RuleNumber": {
						"locationName": "ruleNumber",
						"type": "integer"
					}
				}
			}
		},
		"DeleteNetworkInterface": {
			"input": {
				"type": "structure",
				"required": [
					"NetworkInterfaceId"
				],
				"members": {
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					},
					"NetworkInterfaceId": {
						"locationName": "networkInterfaceId"
					}
				}
			}
		},
		"DeleteNetworkInterfacePermission": {
			"input": {
				"type": "structure",
				"required": [
					"NetworkInterfacePermissionId"
				],
				"members": {
					"NetworkInterfacePermissionId": {},
					"Force": {
						"type": "boolean"
					},
					"DryRun": {
						"type": "boolean"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Return": {
						"locationName": "return",
						"type": "boolean"
					}
				}
			}
		},
		"DeletePlacementGroup": {
			"input": {
				"type": "structure",
				"required": [
					"GroupName"
				],
				"members": {
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					},
					"GroupName": {
						"locationName": "groupName"
					}
				}
			}
		},
		"DeleteRoute": {
			"input": {
				"type": "structure",
				"required": [
					"RouteTableId"
				],
				"members": {
					"DestinationCidrBlock": {
						"locationName": "destinationCidrBlock"
					},
					"DestinationIpv6CidrBlock": {
						"locationName": "destinationIpv6CidrBlock"
					},
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					},
					"RouteTableId": {
						"locationName": "routeTableId"
					}
				}
			}
		},
		"DeleteRouteTable": {
			"input": {
				"type": "structure",
				"required": [
					"RouteTableId"
				],
				"members": {
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					},
					"RouteTableId": {
						"locationName": "routeTableId"
					}
				}
			}
		},
		"DeleteSecurityGroup": {
			"input": {
				"type": "structure",
				"members": {
					"GroupId": {},
					"GroupName": {},
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					}
				}
			}
		},
		"DeleteSnapshot": {
			"input": {
				"type": "structure",
				"required": [
					"SnapshotId"
				],
				"members": {
					"SnapshotId": {},
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					}
				}
			}
		},
		"DeleteSpotDatafeedSubscription": {
			"input": {
				"type": "structure",
				"members": {
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					}
				}
			}
		},
		"DeleteSubnet": {
			"input": {
				"type": "structure",
				"required": [
					"SubnetId"
				],
				"members": {
					"SubnetId": {},
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					}
				}
			}
		},
		"DeleteTags": {
			"input": {
				"type": "structure",
				"required": [
					"Resources"
				],
				"members": {
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					},
					"Resources": {
						"shape": "S7d",
						"locationName": "resourceId"
					},
					"Tags": {
						"shape": "Sl",
						"locationName": "tag"
					}
				}
			}
		},
		"DeleteVolume": {
			"input": {
				"type": "structure",
				"required": [
					"VolumeId"
				],
				"members": {
					"VolumeId": {},
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					}
				}
			}
		},
		"DeleteVpc": {
			"input": {
				"type": "structure",
				"required": [
					"VpcId"
				],
				"members": {
					"VpcId": {},
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					}
				}
			}
		},
		"DeleteVpcEndpoints": {
			"input": {
				"type": "structure",
				"required": [
					"VpcEndpointIds"
				],
				"members": {
					"DryRun": {
						"type": "boolean"
					},
					"VpcEndpointIds": {
						"shape": "S32",
						"locationName": "VpcEndpointId"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Unsuccessful": {
						"shape": "S4h",
						"locationName": "unsuccessful"
					}
				}
			}
		},
		"DeleteVpcPeeringConnection": {
			"input": {
				"type": "structure",
				"required": [
					"VpcPeeringConnectionId"
				],
				"members": {
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					},
					"VpcPeeringConnectionId": {
						"locationName": "vpcPeeringConnectionId"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Return": {
						"locationName": "return",
						"type": "boolean"
					}
				}
			}
		},
		"DeleteVpnConnection": {
			"input": {
				"type": "structure",
				"required": [
					"VpnConnectionId"
				],
				"members": {
					"VpnConnectionId": {},
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					}
				}
			}
		},
		"DeleteVpnConnectionRoute": {
			"input": {
				"type": "structure",
				"required": [
					"DestinationCidrBlock",
					"VpnConnectionId"
				],
				"members": {
					"DestinationCidrBlock": {},
					"VpnConnectionId": {}
				}
			}
		},
		"DeleteVpnGateway": {
			"input": {
				"type": "structure",
				"required": [
					"VpnGatewayId"
				],
				"members": {
					"VpnGatewayId": {},
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					}
				}
			}
		},
		"DeregisterImage": {
			"input": {
				"type": "structure",
				"required": [
					"ImageId"
				],
				"members": {
					"ImageId": {},
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					}
				}
			}
		},
		"DescribeAccountAttributes": {
			"input": {
				"type": "structure",
				"members": {
					"AttributeNames": {
						"locationName": "attributeName",
						"type": "list",
						"member": {
							"locationName": "attributeName"
						}
					},
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"AccountAttributes": {
						"locationName": "accountAttributeSet",
						"type": "list",
						"member": {
							"locationName": "item",
							"type": "structure",
							"members": {
								"AttributeName": {
									"locationName": "attributeName"
								},
								"AttributeValues": {
									"locationName": "attributeValueSet",
									"type": "list",
									"member": {
										"locationName": "item",
										"type": "structure",
										"members": {
											"AttributeValue": {
												"locationName": "attributeValue"
											}
										}
									}
								}
							}
						}
					}
				}
			}
		},
		"DescribeAddresses": {
			"input": {
				"type": "structure",
				"members": {
					"Filters": {
						"shape": "S9g",
						"locationName": "Filter"
					},
					"PublicIps": {
						"locationName": "PublicIp",
						"type": "list",
						"member": {
							"locationName": "PublicIp"
						}
					},
					"AllocationIds": {
						"locationName": "AllocationId",
						"type": "list",
						"member": {
							"locationName": "AllocationId"
						}
					},
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Addresses": {
						"locationName": "addressesSet",
						"type": "list",
						"member": {
							"locationName": "item",
							"type": "structure",
							"members": {
								"InstanceId": {
									"locationName": "instanceId"
								},
								"PublicIp": {
									"locationName": "publicIp"
								},
								"AllocationId": {
									"locationName": "allocationId"
								},
								"AssociationId": {
									"locationName": "associationId"
								},
								"Domain": {
									"locationName": "domain"
								},
								"NetworkInterfaceId": {
									"locationName": "networkInterfaceId"
								},
								"NetworkInterfaceOwnerId": {
									"locationName": "networkInterfaceOwnerId"
								},
								"PrivateIpAddress": {
									"locationName": "privateIpAddress"
								}
							}
						}
					}
				}
			}
		},
		"DescribeAvailabilityZones": {
			"input": {
				"type": "structure",
				"members": {
					"Filters": {
						"shape": "S9g",
						"locationName": "Filter"
					},
					"ZoneNames": {
						"locationName": "ZoneName",
						"type": "list",
						"member": {
							"locationName": "ZoneName"
						}
					},
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"AvailabilityZones": {
						"locationName": "availabilityZoneInfo",
						"type": "list",
						"member": {
							"locationName": "item",
							"type": "structure",
							"members": {
								"State": {
									"locationName": "zoneState"
								},
								"Messages": {
									"locationName": "messageSet",
									"type": "list",
									"member": {
										"locationName": "item",
										"type": "structure",
										"members": {
											"Message": {
												"locationName": "message"
											}
										}
									}
								},
								"RegionName": {
									"locationName": "regionName"
								},
								"ZoneName": {
									"locationName": "zoneName"
								}
							}
						}
					}
				}
			}
		},
		"DescribeBundleTasks": {
			"input": {
				"type": "structure",
				"members": {
					"BundleIds": {
						"locationName": "BundleId",
						"type": "list",
						"member": {
							"locationName": "BundleId"
						}
					},
					"Filters": {
						"shape": "S9g",
						"locationName": "Filter"
					},
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"BundleTasks": {
						"locationName": "bundleInstanceTasksSet",
						"type": "list",
						"member": {
							"shape": "S2f",
							"locationName": "item"
						}
					}
				}
			}
		},
		"DescribeClassicLinkInstances": {
			"input": {
				"type": "structure",
				"members": {
					"Filters": {
						"shape": "S9g",
						"locationName": "Filter"
					},
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					},
					"InstanceIds": {
						"shape": "Sa0",
						"locationName": "InstanceId"
					},
					"MaxResults": {
						"locationName": "maxResults",
						"type": "integer"
					},
					"NextToken": {
						"locationName": "nextToken"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Instances": {
						"locationName": "instancesSet",
						"type": "list",
						"member": {
							"locationName": "item",
							"type": "structure",
							"members": {
								"Groups": {
									"shape": "S60",
									"locationName": "groupSet"
								},
								"InstanceId": {
									"locationName": "instanceId"
								},
								"Tags": {
									"shape": "Sl",
									"locationName": "tagSet"
								},
								"VpcId": {
									"locationName": "vpcId"
								}
							}
						}
					},
					"NextToken": {
						"locationName": "nextToken"
					}
				}
			}
		},
		"DescribeConversionTasks": {
			"input": {
				"type": "structure",
				"members": {
					"ConversionTaskIds": {
						"locationName": "conversionTaskId",
						"type": "list",
						"member": {
							"locationName": "item"
						}
					},
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"ConversionTasks": {
						"locationName": "conversionTasks",
						"type": "list",
						"member": {
							"shape": "Sa8",
							"locationName": "item"
						}
					}
				}
			}
		},
		"DescribeCustomerGateways": {
			"input": {
				"type": "structure",
				"members": {
					"CustomerGatewayIds": {
						"locationName": "CustomerGatewayId",
						"type": "list",
						"member": {
							"locationName": "CustomerGatewayId"
						}
					},
					"Filters": {
						"shape": "S9g",
						"locationName": "Filter"
					},
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"CustomerGateways": {
						"locationName": "customerGatewaySet",
						"type": "list",
						"member": {
							"shape": "S3q",
							"locationName": "item"
						}
					}
				}
			}
		},
		"DescribeDhcpOptions": {
			"input": {
				"type": "structure",
				"members": {
					"DhcpOptionsIds": {
						"locationName": "DhcpOptionsId",
						"type": "list",
						"member": {
							"locationName": "DhcpOptionsId"
						}
					},
					"Filters": {
						"shape": "S9g",
						"locationName": "Filter"
					},
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"DhcpOptions": {
						"locationName": "dhcpOptionsSet",
						"type": "list",
						"member": {
							"shape": "S42",
							"locationName": "item"
						}
					}
				}
			}
		},
		"DescribeEgressOnlyInternetGateways": {
			"input": {
				"type": "structure",
				"members": {
					"DryRun": {
						"type": "boolean"
					},
					"EgressOnlyInternetGatewayIds": {
						"locationName": "EgressOnlyInternetGatewayId",
						"type": "list",
						"member": {
							"locationName": "item"
						}
					},
					"MaxResults": {
						"type": "integer"
					},
					"NextToken": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"EgressOnlyInternetGateways": {
						"locationName": "egressOnlyInternetGatewaySet",
						"type": "list",
						"member": {
							"shape": "S49",
							"locationName": "item"
						}
					},
					"NextToken": {
						"locationName": "nextToken"
					}
				}
			}
		},
		"DescribeElasticGpus": {
			"input": {
				"type": "structure",
				"members": {
					"ElasticGpuIds": {
						"locationName": "ElasticGpuId",
						"type": "list",
						"member": {
							"locationName": "item"
						}
					},
					"DryRun": {
						"type": "boolean"
					},
					"Filters": {
						"shape": "S9g",
						"locationName": "Filter"
					},
					"MaxResults": {
						"type": "integer"
					},
					"NextToken": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"ElasticGpuSet": {
						"locationName": "elasticGpuSet",
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"ElasticGpuId": {
									"locationName": "elasticGpuId"
								},
								"AvailabilityZone": {
									"locationName": "availabilityZone"
								},
								"ElasticGpuType": {
									"locationName": "elasticGpuType"
								},
								"ElasticGpuHealth": {
									"locationName": "elasticGpuHealth",
									"type": "structure",
									"members": {
										"Status": {
											"locationName": "status"
										}
									}
								},
								"ElasticGpuState": {
									"locationName": "elasticGpuState"
								},
								"InstanceId": {
									"locationName": "instanceId"
								}
							}
						}
					},
					"MaxResults": {
						"locationName": "maxResults",
						"type": "integer"
					},
					"NextToken": {
						"locationName": "nextToken"
					}
				}
			}
		},
		"DescribeExportTasks": {
			"input": {
				"type": "structure",
				"members": {
					"ExportTaskIds": {
						"locationName": "exportTaskId",
						"type": "list",
						"member": {
							"locationName": "ExportTaskId"
						}
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"ExportTasks": {
						"locationName": "exportTaskSet",
						"type": "list",
						"member": {
							"shape": "S4z",
							"locationName": "item"
						}
					}
				}
			}
		},
		"DescribeFlowLogs": {
			"input": {
				"type": "structure",
				"members": {
					"Filter": {
						"shape": "S9g"
					},
					"FlowLogIds": {
						"shape": "S32",
						"locationName": "FlowLogId"
					},
					"MaxResults": {
						"type": "integer"
					},
					"NextToken": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"FlowLogs": {
						"locationName": "flowLogSet",
						"type": "list",
						"member": {
							"locationName": "item",
							"type": "structure",
							"members": {
								"CreationTime": {
									"locationName": "creationTime",
									"type": "timestamp"
								},
								"DeliverLogsErrorMessage": {
									"locationName": "deliverLogsErrorMessage"
								},
								"DeliverLogsPermissionArn": {
									"locationName": "deliverLogsPermissionArn"
								},
								"DeliverLogsStatus": {
									"locationName": "deliverLogsStatus"
								},
								"FlowLogId": {
									"locationName": "flowLogId"
								},
								"FlowLogStatus": {
									"locationName": "flowLogStatus"
								},
								"LogGroupName": {
									"locationName": "logGroupName"
								},
								"ResourceId": {
									"locationName": "resourceId"
								},
								"TrafficType": {
									"locationName": "trafficType"
								}
							}
						}
					},
					"NextToken": {
						"locationName": "nextToken"
					}
				}
			}
		},
		"DescribeFpgaImages": {
			"input": {
				"type": "structure",
				"members": {
					"DryRun": {
						"type": "boolean"
					},
					"FpgaImageIds": {
						"locationName": "FpgaImageId",
						"type": "list",
						"member": {
							"locationName": "item"
						}
					},
					"Owners": {
						"shape": "Sbb",
						"locationName": "Owner"
					},
					"Filters": {
						"shape": "S9g",
						"locationName": "Filter"
					},
					"NextToken": {},
					"MaxResults": {
						"type": "integer"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"FpgaImages": {
						"locationName": "fpgaImageSet",
						"type": "list",
						"member": {
							"locationName": "item",
							"type": "structure",
							"members": {
								"FpgaImageId": {
									"locationName": "fpgaImageId"
								},
								"FpgaImageGlobalId": {
									"locationName": "fpgaImageGlobalId"
								},
								"Name": {
									"locationName": "name"
								},
								"Description": {
									"locationName": "description"
								},
								"ShellVersion": {
									"locationName": "shellVersion"
								},
								"PciId": {
									"locationName": "pciId",
									"type": "structure",
									"members": {
										"DeviceId": {},
										"VendorId": {},
										"SubsystemId": {},
										"SubsystemVendorId": {}
									}
								},
								"State": {
									"locationName": "state",
									"type": "structure",
									"members": {
										"Code": {
											"locationName": "code"
										},
										"Message": {
											"locationName": "message"
										}
									}
								},
								"CreateTime": {
									"locationName": "createTime",
									"type": "timestamp"
								},
								"UpdateTime": {
									"locationName": "updateTime",
									"type": "timestamp"
								},
								"OwnerId": {
									"locationName": "ownerId"
								},
								"OwnerAlias": {
									"locationName": "ownerAlias"
								},
								"ProductCodes": {
									"shape": "Sbk",
									"locationName": "productCodes"
								},
								"Tags": {
									"shape": "Sl",
									"locationName": "tags"
								}
							}
						}
					},
					"NextToken": {
						"locationName": "nextToken"
					}
				}
			}
		},
		"DescribeHostReservationOfferings": {
			"input": {
				"type": "structure",
				"members": {
					"Filter": {
						"shape": "S9g"
					},
					"MaxDuration": {
						"type": "integer"
					},
					"MaxResults": {
						"type": "integer"
					},
					"MinDuration": {
						"type": "integer"
					},
					"NextToken": {},
					"OfferingId": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"NextToken": {
						"locationName": "nextToken"
					},
					"OfferingSet": {
						"locationName": "offeringSet",
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"CurrencyCode": {
									"locationName": "currencyCode"
								},
								"Duration": {
									"locationName": "duration",
									"type": "integer"
								},
								"HourlyPrice": {
									"locationName": "hourlyPrice"
								},
								"InstanceFamily": {
									"locationName": "instanceFamily"
								},
								"OfferingId": {
									"locationName": "offeringId"
								},
								"PaymentOption": {
									"locationName": "paymentOption"
								},
								"UpfrontPrice": {
									"locationName": "upfrontPrice"
								}
							}
						}
					}
				}
			}
		},
		"DescribeHostReservations": {
			"input": {
				"type": "structure",
				"members": {
					"Filter": {
						"shape": "S9g"
					},
					"HostReservationIdSet": {
						"type": "list",
						"member": {
							"locationName": "item"
						}
					},
					"MaxResults": {
						"type": "integer"
					},
					"NextToken": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"HostReservationSet": {
						"locationName": "hostReservationSet",
						"type": "list",
						"member": {
							"locationName": "item",
							"type": "structure",
							"members": {
								"Count": {
									"locationName": "count",
									"type": "integer"
								},
								"CurrencyCode": {
									"locationName": "currencyCode"
								},
								"Duration": {
									"locationName": "duration",
									"type": "integer"
								},
								"End": {
									"locationName": "end",
									"type": "timestamp"
								},
								"HostIdSet": {
									"shape": "Sbx",
									"locationName": "hostIdSet"
								},
								"HostReservationId": {
									"locationName": "hostReservationId"
								},
								"HourlyPrice": {
									"locationName": "hourlyPrice"
								},
								"InstanceFamily": {
									"locationName": "instanceFamily"
								},
								"OfferingId": {
									"locationName": "offeringId"
								},
								"PaymentOption": {
									"locationName": "paymentOption"
								},
								"Start": {
									"locationName": "start",
									"type": "timestamp"
								},
								"State": {
									"locationName": "state"
								},
								"UpfrontPrice": {
									"locationName": "upfrontPrice"
								}
							}
						}
					},
					"NextToken": {
						"locationName": "nextToken"
					}
				}
			}
		},
		"DescribeHosts": {
			"input": {
				"type": "structure",
				"members": {
					"Filter": {
						"shape": "S9g",
						"locationName": "filter"
					},
					"HostIds": {
						"shape": "Sc0",
						"locationName": "hostId"
					},
					"MaxResults": {
						"locationName": "maxResults",
						"type": "integer"
					},
					"NextToken": {
						"locationName": "nextToken"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Hosts": {
						"locationName": "hostSet",
						"type": "list",
						"member": {
							"locationName": "item",
							"type": "structure",
							"members": {
								"AutoPlacement": {
									"locationName": "autoPlacement"
								},
								"AvailabilityZone": {
									"locationName": "availabilityZone"
								},
								"AvailableCapacity": {
									"locationName": "availableCapacity",
									"type": "structure",
									"members": {
										"AvailableInstanceCapacity": {
											"locationName": "availableInstanceCapacity",
											"type": "list",
											"member": {
												"locationName": "item",
												"type": "structure",
												"members": {
													"AvailableCapacity": {
														"locationName": "availableCapacity",
														"type": "integer"
													},
													"InstanceType": {
														"locationName": "instanceType"
													},
													"TotalCapacity": {
														"locationName": "totalCapacity",
														"type": "integer"
													}
												}
											}
										},
										"AvailableVCpus": {
											"locationName": "availableVCpus",
											"type": "integer"
										}
									}
								},
								"ClientToken": {
									"locationName": "clientToken"
								},
								"HostId": {
									"locationName": "hostId"
								},
								"HostProperties": {
									"locationName": "hostProperties",
									"type": "structure",
									"members": {
										"Cores": {
											"locationName": "cores",
											"type": "integer"
										},
										"InstanceType": {
											"locationName": "instanceType"
										},
										"Sockets": {
											"locationName": "sockets",
											"type": "integer"
										},
										"TotalVCpus": {
											"locationName": "totalVCpus",
											"type": "integer"
										}
									}
								},
								"HostReservationId": {
									"locationName": "hostReservationId"
								},
								"Instances": {
									"locationName": "instances",
									"type": "list",
									"member": {
										"locationName": "item",
										"type": "structure",
										"members": {
											"InstanceId": {
												"locationName": "instanceId"
											},
											"InstanceType": {
												"locationName": "instanceType"
											}
										}
									}
								},
								"State": {
									"locationName": "state"
								}
							}
						}
					},
					"NextToken": {
						"locationName": "nextToken"
					}
				}
			}
		},
		"DescribeIamInstanceProfileAssociations": {
			"input": {
				"type": "structure",
				"members": {
					"AssociationIds": {
						"locationName": "AssociationId",
						"type": "list",
						"member": {
							"locationName": "AssociationId"
						}
					},
					"Filters": {
						"shape": "S9g",
						"locationName": "Filter"
					},
					"MaxResults": {
						"type": "integer"
					},
					"NextToken": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"IamInstanceProfileAssociations": {
						"locationName": "iamInstanceProfileAssociationSet",
						"type": "list",
						"member": {
							"shape": "S15",
							"locationName": "item"
						}
					},
					"NextToken": {
						"locationName": "nextToken"
					}
				}
			}
		},
		"DescribeIdFormat": {
			"input": {
				"type": "structure",
				"members": {
					"Resource": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Statuses": {
						"shape": "Sch",
						"locationName": "statusSet"
					}
				}
			}
		},
		"DescribeIdentityIdFormat": {
			"input": {
				"type": "structure",
				"required": [
					"PrincipalArn"
				],
				"members": {
					"PrincipalArn": {
						"locationName": "principalArn"
					},
					"Resource": {
						"locationName": "resource"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Statuses": {
						"shape": "Sch",
						"locationName": "statusSet"
					}
				}
			}
		},
		"DescribeImageAttribute": {
			"input": {
				"type": "structure",
				"required": [
					"Attribute",
					"ImageId"
				],
				"members": {
					"Attribute": {},
					"ImageId": {},
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"BlockDeviceMappings": {
						"shape": "Sco",
						"locationName": "blockDeviceMapping"
					},
					"ImageId": {
						"locationName": "imageId"
					},
					"LaunchPermissions": {
						"shape": "Scp",
						"locationName": "launchPermission"
					},
					"ProductCodes": {
						"shape": "Sbk",
						"locationName": "productCodes"
					},
					"Description": {
						"shape": "S46",
						"locationName": "description"
					},
					"KernelId": {
						"shape": "S46",
						"locationName": "kernel"
					},
					"RamdiskId": {
						"shape": "S46",
						"locationName": "ramdisk"
					},
					"SriovNetSupport": {
						"shape": "S46",
						"locationName": "sriovNetSupport"
					}
				}
			}
		},
		"DescribeImages": {
			"input": {
				"type": "structure",
				"members": {
					"ExecutableUsers": {
						"locationName": "ExecutableBy",
						"type": "list",
						"member": {
							"locationName": "ExecutableBy"
						}
					},
					"Filters": {
						"shape": "S9g",
						"locationName": "Filter"
					},
					"ImageIds": {
						"locationName": "ImageId",
						"type": "list",
						"member": {
							"locationName": "ImageId"
						}
					},
					"Owners": {
						"shape": "Sbb",
						"locationName": "Owner"
					},
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Images": {
						"locationName": "imagesSet",
						"type": "list",
						"member": {
							"locationName": "item",
							"type": "structure",
							"members": {
								"Architecture": {
									"locationName": "architecture"
								},
								"CreationDate": {
									"locationName": "creationDate"
								},
								"ImageId": {
									"locationName": "imageId"
								},
								"ImageLocation": {
									"locationName": "imageLocation"
								},
								"ImageType": {
									"locationName": "imageType"
								},
								"Public": {
									"locationName": "isPublic",
									"type": "boolean"
								},
								"KernelId": {
									"locationName": "kernelId"
								},
								"OwnerId": {
									"locationName": "imageOwnerId"
								},
								"Platform": {
									"locationName": "platform"
								},
								"ProductCodes": {
									"shape": "Sbk",
									"locationName": "productCodes"
								},
								"RamdiskId": {
									"locationName": "ramdiskId"
								},
								"State": {
									"locationName": "imageState"
								},
								"BlockDeviceMappings": {
									"shape": "Sco",
									"locationName": "blockDeviceMapping"
								},
								"Description": {
									"locationName": "description"
								},
								"EnaSupport": {
									"locationName": "enaSupport",
									"type": "boolean"
								},
								"Hypervisor": {
									"locationName": "hypervisor"
								},
								"ImageOwnerAlias": {
									"locationName": "imageOwnerAlias"
								},
								"Name": {
									"locationName": "name"
								},
								"RootDeviceName": {
									"locationName": "rootDeviceName"
								},
								"RootDeviceType": {
									"locationName": "rootDeviceType"
								},
								"SriovNetSupport": {
									"locationName": "sriovNetSupport"
								},
								"StateReason": {
									"shape": "Sd3",
									"locationName": "stateReason"
								},
								"Tags": {
									"shape": "Sl",
									"locationName": "tagSet"
								},
								"VirtualizationType": {
									"locationName": "virtualizationType"
								}
							}
						}
					}
				}
			}
		},
		"DescribeImportImageTasks": {
			"input": {
				"type": "structure",
				"members": {
					"DryRun": {
						"type": "boolean"
					},
					"Filters": {
						"shape": "S9g"
					},
					"ImportTaskIds": {
						"shape": "Sd6",
						"locationName": "ImportTaskId"
					},
					"MaxResults": {
						"type": "integer"
					},
					"NextToken": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"ImportImageTasks": {
						"locationName": "importImageTaskSet",
						"type": "list",
						"member": {
							"locationName": "item",
							"type": "structure",
							"members": {
								"Architecture": {
									"locationName": "architecture"
								},
								"Description": {
									"locationName": "description"
								},
								"Hypervisor": {
									"locationName": "hypervisor"
								},
								"ImageId": {
									"locationName": "imageId"
								},
								"ImportTaskId": {
									"locationName": "importTaskId"
								},
								"LicenseType": {
									"locationName": "licenseType"
								},
								"Platform": {
									"locationName": "platform"
								},
								"Progress": {
									"locationName": "progress"
								},
								"SnapshotDetails": {
									"shape": "Sda",
									"locationName": "snapshotDetailSet"
								},
								"Status": {
									"locationName": "status"
								},
								"StatusMessage": {
									"locationName": "statusMessage"
								}
							}
						}
					},
					"NextToken": {
						"locationName": "nextToken"
					}
				}
			}
		},
		"DescribeImportSnapshotTasks": {
			"input": {
				"type": "structure",
				"members": {
					"DryRun": {
						"type": "boolean"
					},
					"Filters": {
						"shape": "S9g"
					},
					"ImportTaskIds": {
						"shape": "Sd6",
						"locationName": "ImportTaskId"
					},
					"MaxResults": {
						"type": "integer"
					},
					"NextToken": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"ImportSnapshotTasks": {
						"locationName": "importSnapshotTaskSet",
						"type": "list",
						"member": {
							"locationName": "item",
							"type": "structure",
							"members": {
								"Description": {
									"locationName": "description"
								},
								"ImportTaskId": {
									"locationName": "importTaskId"
								},
								"SnapshotTaskDetail": {
									"shape": "Sdh",
									"locationName": "snapshotTaskDetail"
								}
							}
						}
					},
					"NextToken": {
						"locationName": "nextToken"
					}
				}
			}
		},
		"DescribeInstanceAttribute": {
			"input": {
				"type": "structure",
				"required": [
					"Attribute",
					"InstanceId"
				],
				"members": {
					"Attribute": {
						"locationName": "attribute"
					},
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					},
					"InstanceId": {
						"locationName": "instanceId"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Groups": {
						"shape": "S60",
						"locationName": "groupSet"
					},
					"BlockDeviceMappings": {
						"shape": "Sdl",
						"locationName": "blockDeviceMapping"
					},
					"DisableApiTermination": {
						"shape": "Sdo",
						"locationName": "disableApiTermination"
					},
					"EnaSupport": {
						"shape": "Sdo",
						"locationName": "enaSupport"
					},
					"EbsOptimized": {
						"shape": "Sdo",
						"locationName": "ebsOptimized"
					},
					"InstanceId": {
						"locationName": "instanceId"
					},
					"InstanceInitiatedShutdownBehavior": {
						"shape": "S46",
						"locationName": "instanceInitiatedShutdownBehavior"
					},
					"InstanceType": {
						"shape": "S46",
						"locationName": "instanceType"
					},
					"KernelId": {
						"shape": "S46",
						"locationName": "kernel"
					},
					"ProductCodes": {
						"shape": "Sbk",
						"locationName": "productCodes"
					},
					"RamdiskId": {
						"shape": "S46",
						"locationName": "ramdisk"
					},
					"RootDeviceName": {
						"shape": "S46",
						"locationName": "rootDeviceName"
					},
					"SourceDestCheck": {
						"shape": "Sdo",
						"locationName": "sourceDestCheck"
					},
					"SriovNetSupport": {
						"shape": "S46",
						"locationName": "sriovNetSupport"
					},
					"UserData": {
						"shape": "S46",
						"locationName": "userData"
					}
				}
			}
		},
		"DescribeInstanceStatus": {
			"input": {
				"type": "structure",
				"members": {
					"Filters": {
						"shape": "S9g",
						"locationName": "Filter"
					},
					"InstanceIds": {
						"shape": "Sa0",
						"locationName": "InstanceId"
					},
					"MaxResults": {
						"type": "integer"
					},
					"NextToken": {},
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					},
					"IncludeAllInstances": {
						"locationName": "includeAllInstances",
						"type": "boolean"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"InstanceStatuses": {
						"locationName": "instanceStatusSet",
						"type": "list",
						"member": {
							"locationName": "item",
							"type": "structure",
							"members": {
								"AvailabilityZone": {
									"locationName": "availabilityZone"
								},
								"Events": {
									"locationName": "eventsSet",
									"type": "list",
									"member": {
										"locationName": "item",
										"type": "structure",
										"members": {
											"Code": {
												"locationName": "code"
											},
											"Description": {
												"locationName": "description"
											},
											"NotAfter": {
												"locationName": "notAfter",
												"type": "timestamp"
											},
											"NotBefore": {
												"locationName": "notBefore",
												"type": "timestamp"
											}
										}
									}
								},
								"InstanceId": {
									"locationName": "instanceId"
								},
								"InstanceState": {
									"shape": "Sdw",
									"locationName": "instanceState"
								},
								"InstanceStatus": {
									"shape": "Sdy",
									"locationName": "instanceStatus"
								},
								"SystemStatus": {
									"shape": "Sdy",
									"locationName": "systemStatus"
								}
							}
						}
					},
					"NextToken": {
						"locationName": "nextToken"
					}
				}
			}
		},
		"DescribeInstances": {
			"input": {
				"type": "structure",
				"members": {
					"Filters": {
						"shape": "S9g",
						"locationName": "Filter"
					},
					"InstanceIds": {
						"shape": "Sa0",
						"locationName": "InstanceId"
					},
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					},
					"MaxResults": {
						"locationName": "maxResults",
						"type": "integer"
					},
					"NextToken": {
						"locationName": "nextToken"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Reservations": {
						"locationName": "reservationSet",
						"type": "list",
						"member": {
							"shape": "Se7",
							"locationName": "item"
						}
					},
					"NextToken": {
						"locationName": "nextToken"
					}
				}
			}
		},
		"DescribeInternetGateways": {
			"input": {
				"type": "structure",
				"members": {
					"Filters": {
						"shape": "S9g",
						"locationName": "Filter"
					},
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					},
					"InternetGatewayIds": {
						"shape": "S32",
						"locationName": "internetGatewayId"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"InternetGateways": {
						"locationName": "internetGatewaySet",
						"type": "list",
						"member": {
							"shape": "S55",
							"locationName": "item"
						}
					}
				}
			}
		},
		"DescribeKeyPairs": {
			"input": {
				"type": "structure",
				"members": {
					"Filters": {
						"shape": "S9g",
						"locationName": "Filter"
					},
					"KeyNames": {
						"locationName": "KeyName",
						"type": "list",
						"member": {
							"locationName": "KeyName"
						}
					},
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"KeyPairs": {
						"locationName": "keySet",
						"type": "list",
						"member": {
							"locationName": "item",
							"type": "structure",
							"members": {
								"KeyFingerprint": {
									"locationName": "keyFingerprint"
								},
								"KeyName": {
									"locationName": "keyName"
								}
							}
						}
					}
				}
			}
		},
		"DescribeMovingAddresses": {
			"input": {
				"type": "structure",
				"members": {
					"Filters": {
						"shape": "S9g",
						"locationName": "filter"
					},
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					},
					"MaxResults": {
						"locationName": "maxResults",
						"type": "integer"
					},
					"NextToken": {
						"locationName": "nextToken"
					},
					"PublicIps": {
						"shape": "S32",
						"locationName": "publicIp"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"MovingAddressStatuses": {
						"locationName": "movingAddressStatusSet",
						"type": "list",
						"member": {
							"locationName": "item",
							"type": "structure",
							"members": {
								"MoveStatus": {
									"locationName": "moveStatus"
								},
								"PublicIp": {
									"locationName": "publicIp"
								}
							}
						}
					},
					"NextToken": {
						"locationName": "nextToken"
					}
				}
			}
		},
		"DescribeNatGateways": {
			"input": {
				"type": "structure",
				"members": {
					"Filter": {
						"shape": "S9g"
					},
					"MaxResults": {
						"type": "integer"
					},
					"NatGatewayIds": {
						"shape": "S32",
						"locationName": "NatGatewayId"
					},
					"NextToken": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"NatGateways": {
						"locationName": "natGatewaySet",
						"type": "list",
						"member": {
							"shape": "S5a",
							"locationName": "item"
						}
					},
					"NextToken": {
						"locationName": "nextToken"
					}
				}
			}
		},
		"DescribeNetworkAcls": {
			"input": {
				"type": "structure",
				"members": {
					"Filters": {
						"shape": "S9g",
						"locationName": "Filter"
					},
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					},
					"NetworkAclIds": {
						"shape": "S32",
						"locationName": "NetworkAclId"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"NetworkAcls": {
						"locationName": "networkAclSet",
						"type": "list",
						"member": {
							"shape": "S5h",
							"locationName": "item"
						}
					}
				}
			}
		},
		"DescribeNetworkInterfaceAttribute": {
			"input": {
				"type": "structure",
				"required": [
					"NetworkInterfaceId"
				],
				"members": {
					"Attribute": {
						"locationName": "attribute"
					},
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					},
					"NetworkInterfaceId": {
						"locationName": "networkInterfaceId"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Attachment": {
						"shape": "S5z",
						"locationName": "attachment"
					},
					"Description": {
						"shape": "S46",
						"locationName": "description"
					},
					"Groups": {
						"shape": "S60",
						"locationName": "groupSet"
					},
					"NetworkInterfaceId": {
						"locationName": "networkInterfaceId"
					},
					"SourceDestCheck": {
						"shape": "Sdo",
						"locationName": "sourceDestCheck"
					}
				}
			}
		},
		"DescribeNetworkInterfacePermissions": {
			"input": {
				"type": "structure",
				"members": {
					"NetworkInterfacePermissionIds": {
						"locationName": "NetworkInterfacePermissionId",
						"type": "list",
						"member": {}
					},
					"Filters": {
						"shape": "S9g",
						"locationName": "Filter"
					},
					"NextToken": {},
					"MaxResults": {
						"type": "integer"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"NetworkInterfacePermissions": {
						"locationName": "networkInterfacePermissions",
						"type": "list",
						"member": {
							"shape": "S6b",
							"locationName": "item"
						}
					},
					"NextToken": {
						"locationName": "nextToken"
					}
				}
			}
		},
		"DescribeNetworkInterfaces": {
			"input": {
				"type": "structure",
				"members": {
					"Filters": {
						"shape": "S9g",
						"locationName": "filter"
					},
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					},
					"NetworkInterfaceIds": {
						"locationName": "NetworkInterfaceId",
						"type": "list",
						"member": {
							"locationName": "item"
						}
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"NetworkInterfaces": {
						"locationName": "networkInterfaceSet",
						"type": "list",
						"member": {
							"shape": "S5x",
							"locationName": "item"
						}
					}
				}
			}
		},
		"DescribePlacementGroups": {
			"input": {
				"type": "structure",
				"members": {
					"Filters": {
						"shape": "S9g",
						"locationName": "Filter"
					},
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					},
					"GroupNames": {
						"locationName": "groupName",
						"type": "list",
						"member": {}
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"PlacementGroups": {
						"locationName": "placementGroupSet",
						"type": "list",
						"member": {
							"locationName": "item",
							"type": "structure",
							"members": {
								"GroupName": {
									"locationName": "groupName"
								},
								"State": {
									"locationName": "state"
								},
								"Strategy": {
									"locationName": "strategy"
								}
							}
						}
					}
				}
			}
		},
		"DescribePrefixLists": {
			"input": {
				"type": "structure",
				"members": {
					"DryRun": {
						"type": "boolean"
					},
					"Filters": {
						"shape": "S9g",
						"locationName": "Filter"
					},
					"MaxResults": {
						"type": "integer"
					},
					"NextToken": {},
					"PrefixListIds": {
						"shape": "S32",
						"locationName": "PrefixListId"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"NextToken": {
						"locationName": "nextToken"
					},
					"PrefixLists": {
						"locationName": "prefixListSet",
						"type": "list",
						"member": {
							"locationName": "item",
							"type": "structure",
							"members": {
								"Cidrs": {
									"shape": "S32",
									"locationName": "cidrSet"
								},
								"PrefixListId": {
									"locationName": "prefixListId"
								},
								"PrefixListName": {
									"locationName": "prefixListName"
								}
							}
						}
					}
				}
			}
		},
		"DescribeRegions": {
			"input": {
				"type": "structure",
				"members": {
					"Filters": {
						"shape": "S9g",
						"locationName": "Filter"
					},
					"RegionNames": {
						"locationName": "RegionName",
						"type": "list",
						"member": {
							"locationName": "RegionName"
						}
					},
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Regions": {
						"locationName": "regionInfo",
						"type": "list",
						"member": {
							"locationName": "item",
							"type": "structure",
							"members": {
								"Endpoint": {
									"locationName": "regionEndpoint"
								},
								"RegionName": {
									"locationName": "regionName"
								}
							}
						}
					}
				}
			}
		},
		"DescribeReservedInstances": {
			"input": {
				"type": "structure",
				"members": {
					"Filters": {
						"shape": "S9g",
						"locationName": "Filter"
					},
					"OfferingClass": {},
					"ReservedInstancesIds": {
						"shape": "Sfy",
						"locationName": "ReservedInstancesId"
					},
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					},
					"OfferingType": {
						"locationName": "offeringType"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"ReservedInstances": {
						"locationName": "reservedInstancesSet",
						"type": "list",
						"member": {
							"locationName": "item",
							"type": "structure",
							"members": {
								"AvailabilityZone": {
									"locationName": "availabilityZone"
								},
								"Duration": {
									"locationName": "duration",
									"type": "long"
								},
								"End": {
									"locationName": "end",
									"type": "timestamp"
								},
								"FixedPrice": {
									"locationName": "fixedPrice",
									"type": "float"
								},
								"InstanceCount": {
									"locationName": "instanceCount",
									"type": "integer"
								},
								"InstanceType": {
									"locationName": "instanceType"
								},
								"ProductDescription": {
									"locationName": "productDescription"
								},
								"ReservedInstancesId": {
									"locationName": "reservedInstancesId"
								},
								"Start": {
									"locationName": "start",
									"type": "timestamp"
								},
								"State": {
									"locationName": "state"
								},
								"UsagePrice": {
									"locationName": "usagePrice",
									"type": "float"
								},
								"CurrencyCode": {
									"locationName": "currencyCode"
								},
								"InstanceTenancy": {
									"locationName": "instanceTenancy"
								},
								"OfferingClass": {
									"locationName": "offeringClass"
								},
								"OfferingType": {
									"locationName": "offeringType"
								},
								"RecurringCharges": {
									"shape": "Sg6",
									"locationName": "recurringCharges"
								},
								"Scope": {
									"locationName": "scope"
								},
								"Tags": {
									"shape": "Sl",
									"locationName": "tagSet"
								}
							}
						}
					}
				}
			}
		},
		"DescribeReservedInstancesListings": {
			"input": {
				"type": "structure",
				"members": {
					"Filters": {
						"shape": "S9g",
						"locationName": "Filter"
					},
					"ReservedInstancesId": {
						"locationName": "reservedInstancesId"
					},
					"ReservedInstancesListingId": {
						"locationName": "reservedInstancesListingId"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"ReservedInstancesListings": {
						"shape": "S2q",
						"locationName": "reservedInstancesListingsSet"
					}
				}
			}
		},
		"DescribeReservedInstancesModifications": {
			"input": {
				"type": "structure",
				"members": {
					"Filters": {
						"shape": "S9g",
						"locationName": "Filter"
					},
					"ReservedInstancesModificationIds": {
						"locationName": "ReservedInstancesModificationId",
						"type": "list",
						"member": {
							"locationName": "ReservedInstancesModificationId"
						}
					},
					"NextToken": {
						"locationName": "nextToken"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"NextToken": {
						"locationName": "nextToken"
					},
					"ReservedInstancesModifications": {
						"locationName": "reservedInstancesModificationsSet",
						"type": "list",
						"member": {
							"locationName": "item",
							"type": "structure",
							"members": {
								"ClientToken": {
									"locationName": "clientToken"
								},
								"CreateDate": {
									"locationName": "createDate",
									"type": "timestamp"
								},
								"EffectiveDate": {
									"locationName": "effectiveDate",
									"type": "timestamp"
								},
								"ModificationResults": {
									"locationName": "modificationResultSet",
									"type": "list",
									"member": {
										"locationName": "item",
										"type": "structure",
										"members": {
											"ReservedInstancesId": {
												"locationName": "reservedInstancesId"
											},
											"TargetConfiguration": {
												"shape": "Sgj",
												"locationName": "targetConfiguration"
											}
										}
									}
								},
								"ReservedInstancesIds": {
									"locationName": "reservedInstancesSet",
									"type": "list",
									"member": {
										"locationName": "item",
										"type": "structure",
										"members": {
											"ReservedInstancesId": {
												"locationName": "reservedInstancesId"
											}
										}
									}
								},
								"ReservedInstancesModificationId": {
									"locationName": "reservedInstancesModificationId"
								},
								"Status": {
									"locationName": "status"
								},
								"StatusMessage": {
									"locationName": "statusMessage"
								},
								"UpdateDate": {
									"locationName": "updateDate",
									"type": "timestamp"
								}
							}
						}
					}
				}
			}
		},
		"DescribeReservedInstancesOfferings": {
			"input": {
				"type": "structure",
				"members": {
					"AvailabilityZone": {},
					"Filters": {
						"shape": "S9g",
						"locationName": "Filter"
					},
					"IncludeMarketplace": {
						"type": "boolean"
					},
					"InstanceType": {},
					"MaxDuration": {
						"type": "long"
					},
					"MaxInstanceCount": {
						"type": "integer"
					},
					"MinDuration": {
						"type": "long"
					},
					"OfferingClass": {},
					"ProductDescription": {},
					"ReservedInstancesOfferingIds": {
						"locationName": "ReservedInstancesOfferingId",
						"type": "list",
						"member": {}
					},
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					},
					"InstanceTenancy": {
						"locationName": "instanceTenancy"
					},
					"MaxResults": {
						"locationName": "maxResults",
						"type": "integer"
					},
					"NextToken": {
						"locationName": "nextToken"
					},
					"OfferingType": {
						"locationName": "offeringType"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"ReservedInstancesOfferings": {
						"locationName": "reservedInstancesOfferingsSet",
						"type": "list",
						"member": {
							"locationName": "item",
							"type": "structure",
							"members": {
								"AvailabilityZone": {
									"locationName": "availabilityZone"
								},
								"Duration": {
									"locationName": "duration",
									"type": "long"
								},
								"FixedPrice": {
									"locationName": "fixedPrice",
									"type": "float"
								},
								"InstanceType": {
									"locationName": "instanceType"
								},
								"ProductDescription": {
									"locationName": "productDescription"
								},
								"ReservedInstancesOfferingId": {
									"locationName": "reservedInstancesOfferingId"
								},
								"UsagePrice": {
									"locationName": "usagePrice",
									"type": "float"
								},
								"CurrencyCode": {
									"locationName": "currencyCode"
								},
								"InstanceTenancy": {
									"locationName": "instanceTenancy"
								},
								"Marketplace": {
									"locationName": "marketplace",
									"type": "boolean"
								},
								"OfferingClass": {
									"locationName": "offeringClass"
								},
								"OfferingType": {
									"locationName": "offeringType"
								},
								"PricingDetails": {
									"locationName": "pricingDetailsSet",
									"type": "list",
									"member": {
										"locationName": "item",
										"type": "structure",
										"members": {
											"Count": {
												"locationName": "count",
												"type": "integer"
											},
											"Price": {
												"locationName": "price",
												"type": "double"
											}
										}
									}
								},
								"RecurringCharges": {
									"shape": "Sg6",
									"locationName": "recurringCharges"
								},
								"Scope": {
									"locationName": "scope"
								}
							}
						}
					},
					"NextToken": {
						"locationName": "nextToken"
					}
				}
			}
		},
		"DescribeRouteTables": {
			"input": {
				"type": "structure",
				"members": {
					"Filters": {
						"shape": "S9g",
						"locationName": "Filter"
					},
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					},
					"RouteTableIds": {
						"shape": "S32",
						"locationName": "RouteTableId"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"RouteTables": {
						"locationName": "routeTableSet",
						"type": "list",
						"member": {
							"shape": "S6o",
							"locationName": "item"
						}
					}
				}
			}
		},
		"DescribeScheduledInstanceAvailability": {
			"input": {
				"type": "structure",
				"required": [
					"FirstSlotStartTimeRange",
					"Recurrence"
				],
				"members": {
					"DryRun": {
						"type": "boolean"
					},
					"Filters": {
						"shape": "S9g",
						"locationName": "Filter"
					},
					"FirstSlotStartTimeRange": {
						"type": "structure",
						"required": [
							"EarliestTime",
							"LatestTime"
						],
						"members": {
							"EarliestTime": {
								"type": "timestamp"
							},
							"LatestTime": {
								"type": "timestamp"
							}
						}
					},
					"MaxResults": {
						"type": "integer"
					},
					"MaxSlotDurationInHours": {
						"type": "integer"
					},
					"MinSlotDurationInHours": {
						"type": "integer"
					},
					"NextToken": {},
					"Recurrence": {
						"type": "structure",
						"members": {
							"Frequency": {},
							"Interval": {
								"type": "integer"
							},
							"OccurrenceDays": {
								"locationName": "OccurrenceDay",
								"type": "list",
								"member": {
									"locationName": "OccurenceDay",
									"type": "integer"
								}
							},
							"OccurrenceRelativeToEnd": {
								"type": "boolean"
							},
							"OccurrenceUnit": {}
						}
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"NextToken": {
						"locationName": "nextToken"
					},
					"ScheduledInstanceAvailabilitySet": {
						"locationName": "scheduledInstanceAvailabilitySet",
						"type": "list",
						"member": {
							"locationName": "item",
							"type": "structure",
							"members": {
								"AvailabilityZone": {
									"locationName": "availabilityZone"
								},
								"AvailableInstanceCount": {
									"locationName": "availableInstanceCount",
									"type": "integer"
								},
								"FirstSlotStartTime": {
									"locationName": "firstSlotStartTime",
									"type": "timestamp"
								},
								"HourlyPrice": {
									"locationName": "hourlyPrice"
								},
								"InstanceType": {
									"locationName": "instanceType"
								},
								"MaxTermDurationInDays": {
									"locationName": "maxTermDurationInDays",
									"type": "integer"
								},
								"MinTermDurationInDays": {
									"locationName": "minTermDurationInDays",
									"type": "integer"
								},
								"NetworkPlatform": {
									"locationName": "networkPlatform"
								},
								"Platform": {
									"locationName": "platform"
								},
								"PurchaseToken": {
									"locationName": "purchaseToken"
								},
								"Recurrence": {
									"shape": "Sh3",
									"locationName": "recurrence"
								},
								"SlotDurationInHours": {
									"locationName": "slotDurationInHours",
									"type": "integer"
								},
								"TotalScheduledInstanceHours": {
									"locationName": "totalScheduledInstanceHours",
									"type": "integer"
								}
							}
						}
					}
				}
			}
		},
		"DescribeScheduledInstances": {
			"input": {
				"type": "structure",
				"members": {
					"DryRun": {
						"type": "boolean"
					},
					"Filters": {
						"shape": "S9g",
						"locationName": "Filter"
					},
					"MaxResults": {
						"type": "integer"
					},
					"NextToken": {},
					"ScheduledInstanceIds": {
						"locationName": "ScheduledInstanceId",
						"type": "list",
						"member": {
							"locationName": "ScheduledInstanceId"
						}
					},
					"SlotStartTimeRange": {
						"type": "structure",
						"members": {
							"EarliestTime": {
								"type": "timestamp"
							},
							"LatestTime": {
								"type": "timestamp"
							}
						}
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"NextToken": {
						"locationName": "nextToken"
					},
					"ScheduledInstanceSet": {
						"locationName": "scheduledInstanceSet",
						"type": "list",
						"member": {
							"shape": "Sha",
							"locationName": "item"
						}
					}
				}
			}
		},
		"DescribeSecurityGroupReferences": {
			"input": {
				"type": "structure",
				"required": [
					"GroupId"
				],
				"members": {
					"DryRun": {
						"type": "boolean"
					},
					"GroupId": {
						"type": "list",
						"member": {
							"locationName": "item"
						}
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"SecurityGroupReferenceSet": {
						"locationName": "securityGroupReferenceSet",
						"type": "list",
						"member": {
							"locationName": "item",
							"type": "structure",
							"required": [
								"GroupId",
								"ReferencingVpcId"
							],
							"members": {
								"GroupId": {
									"locationName": "groupId"
								},
								"ReferencingVpcId": {
									"locationName": "referencingVpcId"
								},
								"VpcPeeringConnectionId": {
									"locationName": "vpcPeeringConnectionId"
								}
							}
						}
					}
				}
			}
		},
		"DescribeSecurityGroups": {
			"input": {
				"type": "structure",
				"members": {
					"Filters": {
						"shape": "S9g",
						"locationName": "Filter"
					},
					"GroupIds": {
						"shape": "S1m",
						"locationName": "GroupId"
					},
					"GroupNames": {
						"shape": "Shh",
						"locationName": "GroupName"
					},
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"SecurityGroups": {
						"locationName": "securityGroupInfo",
						"type": "list",
						"member": {
							"locationName": "item",
							"type": "structure",
							"members": {
								"Description": {
									"locationName": "groupDescription"
								},
								"GroupName": {
									"locationName": "groupName"
								},
								"IpPermissions": {
									"shape": "S1z",
									"locationName": "ipPermissions"
								},
								"OwnerId": {
									"locationName": "ownerId"
								},
								"GroupId": {
									"locationName": "groupId"
								},
								"IpPermissionsEgress": {
									"shape": "S1z",
									"locationName": "ipPermissionsEgress"
								},
								"Tags": {
									"shape": "Sl",
									"locationName": "tagSet"
								},
								"VpcId": {
									"locationName": "vpcId"
								}
							}
						}
					}
				}
			}
		},
		"DescribeSnapshotAttribute": {
			"input": {
				"type": "structure",
				"required": [
					"Attribute",
					"SnapshotId"
				],
				"members": {
					"Attribute": {},
					"SnapshotId": {},
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"CreateVolumePermissions": {
						"shape": "Sho",
						"locationName": "createVolumePermission"
					},
					"ProductCodes": {
						"shape": "Sbk",
						"locationName": "productCodes"
					},
					"SnapshotId": {
						"locationName": "snapshotId"
					}
				}
			}
		},
		"DescribeSnapshots": {
			"input": {
				"type": "structure",
				"members": {
					"Filters": {
						"shape": "S9g",
						"locationName": "Filter"
					},
					"MaxResults": {
						"type": "integer"
					},
					"NextToken": {},
					"OwnerIds": {
						"shape": "Sbb",
						"locationName": "Owner"
					},
					"RestorableByUserIds": {
						"locationName": "RestorableBy",
						"type": "list",
						"member": {}
					},
					"SnapshotIds": {
						"locationName": "SnapshotId",
						"type": "list",
						"member": {
							"locationName": "SnapshotId"
						}
					},
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Snapshots": {
						"locationName": "snapshotSet",
						"type": "list",
						"member": {
							"shape": "S70",
							"locationName": "item"
						}
					},
					"NextToken": {
						"locationName": "nextToken"
					}
				}
			}
		},
		"DescribeSpotDatafeedSubscription": {
			"input": {
				"type": "structure",
				"members": {
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"SpotDatafeedSubscription": {
						"shape": "S74",
						"locationName": "spotDatafeedSubscription"
					}
				}
			}
		},
		"DescribeSpotFleetInstances": {
			"input": {
				"type": "structure",
				"required": [
					"SpotFleetRequestId"
				],
				"members": {
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					},
					"MaxResults": {
						"locationName": "maxResults",
						"type": "integer"
					},
					"NextToken": {
						"locationName": "nextToken"
					},
					"SpotFleetRequestId": {
						"locationName": "spotFleetRequestId"
					}
				}
			},
			"output": {
				"type": "structure",
				"required": [
					"ActiveInstances",
					"SpotFleetRequestId"
				],
				"members": {
					"ActiveInstances": {
						"locationName": "activeInstanceSet",
						"type": "list",
						"member": {
							"locationName": "item",
							"type": "structure",
							"members": {
								"InstanceId": {
									"locationName": "instanceId"
								},
								"InstanceType": {
									"locationName": "instanceType"
								},
								"SpotInstanceRequestId": {
									"locationName": "spotInstanceRequestId"
								},
								"InstanceHealth": {
									"locationName": "instanceHealth"
								}
							}
						}
					},
					"NextToken": {
						"locationName": "nextToken"
					},
					"SpotFleetRequestId": {
						"locationName": "spotFleetRequestId"
					}
				}
			}
		},
		"DescribeSpotFleetRequestHistory": {
			"input": {
				"type": "structure",
				"required": [
					"SpotFleetRequestId",
					"StartTime"
				],
				"members": {
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					},
					"EventType": {
						"locationName": "eventType"
					},
					"MaxResults": {
						"locationName": "maxResults",
						"type": "integer"
					},
					"NextToken": {
						"locationName": "nextToken"
					},
					"SpotFleetRequestId": {
						"locationName": "spotFleetRequestId"
					},
					"StartTime": {
						"locationName": "startTime",
						"type": "timestamp"
					}
				}
			},
			"output": {
				"type": "structure",
				"required": [
					"HistoryRecords",
					"LastEvaluatedTime",
					"SpotFleetRequestId",
					"StartTime"
				],
				"members": {
					"HistoryRecords": {
						"locationName": "historyRecordSet",
						"type": "list",
						"member": {
							"locationName": "item",
							"type": "structure",
							"required": [
								"EventInformation",
								"EventType",
								"Timestamp"
							],
							"members": {
								"EventInformation": {
									"locationName": "eventInformation",
									"type": "structure",
									"members": {
										"EventDescription": {
											"locationName": "eventDescription"
										},
										"EventSubType": {
											"locationName": "eventSubType"
										},
										"InstanceId": {
											"locationName": "instanceId"
										}
									}
								},
								"EventType": {
									"locationName": "eventType"
								},
								"Timestamp": {
									"locationName": "timestamp",
									"type": "timestamp"
								}
							}
						}
					},
					"LastEvaluatedTime": {
						"locationName": "lastEvaluatedTime",
						"type": "timestamp"
					},
					"NextToken": {
						"locationName": "nextToken"
					},
					"SpotFleetRequestId": {
						"locationName": "spotFleetRequestId"
					},
					"StartTime": {
						"locationName": "startTime",
						"type": "timestamp"
					}
				}
			}
		},
		"DescribeSpotFleetRequests": {
			"input": {
				"type": "structure",
				"members": {
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					},
					"MaxResults": {
						"locationName": "maxResults",
						"type": "integer"
					},
					"NextToken": {
						"locationName": "nextToken"
					},
					"SpotFleetRequestIds": {
						"shape": "S32",
						"locationName": "spotFleetRequestId"
					}
				}
			},
			"output": {
				"type": "structure",
				"required": [
					"SpotFleetRequestConfigs"
				],
				"members": {
					"NextToken": {
						"locationName": "nextToken"
					},
					"SpotFleetRequestConfigs": {
						"locationName": "spotFleetRequestConfigSet",
						"type": "list",
						"member": {
							"locationName": "item",
							"type": "structure",
							"required": [
								"CreateTime",
								"SpotFleetRequestConfig",
								"SpotFleetRequestId",
								"SpotFleetRequestState"
							],
							"members": {
								"ActivityStatus": {
									"locationName": "activityStatus"
								},
								"CreateTime": {
									"locationName": "createTime",
									"type": "timestamp"
								},
								"SpotFleetRequestConfig": {
									"shape": "Sid",
									"locationName": "spotFleetRequestConfig"
								},
								"SpotFleetRequestId": {
									"locationName": "spotFleetRequestId"
								},
								"SpotFleetRequestState": {
									"locationName": "spotFleetRequestState"
								}
							}
						}
					}
				}
			}
		},
		"DescribeSpotInstanceRequests": {
			"input": {
				"type": "structure",
				"members": {
					"Filters": {
						"shape": "S9g",
						"locationName": "Filter"
					},
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					},
					"SpotInstanceRequestIds": {
						"shape": "S3c",
						"locationName": "SpotInstanceRequestId"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"SpotInstanceRequests": {
						"shape": "Sir",
						"locationName": "spotInstanceRequestSet"
					}
				}
			}
		},
		"DescribeSpotPriceHistory": {
			"input": {
				"type": "structure",
				"members": {
					"Filters": {
						"shape": "S9g",
						"locationName": "Filter"
					},
					"AvailabilityZone": {
						"locationName": "availabilityZone"
					},
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					},
					"EndTime": {
						"locationName": "endTime",
						"type": "timestamp"
					},
					"InstanceTypes": {
						"locationName": "InstanceType",
						"type": "list",
						"member": {}
					},
					"MaxResults": {
						"locationName": "maxResults",
						"type": "integer"
					},
					"NextToken": {
						"locationName": "nextToken"
					},
					"ProductDescriptions": {
						"locationName": "ProductDescription",
						"type": "list",
						"member": {}
					},
					"StartTime": {
						"locationName": "startTime",
						"type": "timestamp"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"NextToken": {
						"locationName": "nextToken"
					},
					"SpotPriceHistory": {
						"locationName": "spotPriceHistorySet",
						"type": "list",
						"member": {
							"locationName": "item",
							"type": "structure",
							"members": {
								"AvailabilityZone": {
									"locationName": "availabilityZone"
								},
								"InstanceType": {
									"locationName": "instanceType"
								},
								"ProductDescription": {
									"locationName": "productDescription"
								},
								"SpotPrice": {
									"locationName": "spotPrice"
								},
								"Timestamp": {
									"locationName": "timestamp",
									"type": "timestamp"
								}
							}
						}
					}
				}
			}
		},
		"DescribeStaleSecurityGroups": {
			"input": {
				"type": "structure",
				"required": [
					"VpcId"
				],
				"members": {
					"DryRun": {
						"type": "boolean"
					},
					"MaxResults": {
						"type": "integer"
					},
					"NextToken": {},
					"VpcId": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"NextToken": {
						"locationName": "nextToken"
					},
					"StaleSecurityGroupSet": {
						"locationName": "staleSecurityGroupSet",
						"type": "list",
						"member": {
							"locationName": "item",
							"type": "structure",
							"required": [
								"GroupId"
							],
							"members": {
								"Description": {
									"locationName": "description"
								},
								"GroupId": {
									"locationName": "groupId"
								},
								"GroupName": {
									"locationName": "groupName"
								},
								"StaleIpPermissions": {
									"shape": "Sj8",
									"locationName": "staleIpPermissions"
								},
								"StaleIpPermissionsEgress": {
									"shape": "Sj8",
									"locationName": "staleIpPermissionsEgress"
								},
								"VpcId": {
									"locationName": "vpcId"
								}
							}
						}
					}
				}
			}
		},
		"DescribeSubnets": {
			"input": {
				"type": "structure",
				"members": {
					"Filters": {
						"shape": "S9g",
						"locationName": "Filter"
					},
					"SubnetIds": {
						"locationName": "SubnetId",
						"type": "list",
						"member": {
							"locationName": "SubnetId"
						}
					},
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Subnets": {
						"locationName": "subnetSet",
						"type": "list",
						"member": {
							"shape": "S79",
							"locationName": "item"
						}
					}
				}
			}
		},
		"DescribeTags": {
			"input": {
				"type": "structure",
				"members": {
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					},
					"Filters": {
						"shape": "S9g",
						"locationName": "Filter"
					},
					"MaxResults": {
						"locationName": "maxResults",
						"type": "integer"
					},
					"NextToken": {
						"locationName": "nextToken"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"NextToken": {
						"locationName": "nextToken"
					},
					"Tags": {
						"locationName": "tagSet",
						"type": "list",
						"member": {
							"locationName": "item",
							"type": "structure",
							"members": {
								"Key": {
									"locationName": "key"
								},
								"ResourceId": {
									"locationName": "resourceId"
								},
								"ResourceType": {
									"locationName": "resourceType"
								},
								"Value": {
									"locationName": "value"
								}
							}
						}
					}
				}
			}
		},
		"DescribeVolumeAttribute": {
			"input": {
				"type": "structure",
				"required": [
					"VolumeId"
				],
				"members": {
					"Attribute": {},
					"VolumeId": {},
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"AutoEnableIO": {
						"shape": "Sdo",
						"locationName": "autoEnableIO"
					},
					"ProductCodes": {
						"shape": "Sbk",
						"locationName": "productCodes"
					},
					"VolumeId": {
						"locationName": "volumeId"
					}
				}
			}
		},
		"DescribeVolumeStatus": {
			"input": {
				"type": "structure",
				"members": {
					"Filters": {
						"shape": "S9g",
						"locationName": "Filter"
					},
					"MaxResults": {
						"type": "integer"
					},
					"NextToken": {},
					"VolumeIds": {
						"shape": "Sjp",
						"locationName": "VolumeId"
					},
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"NextToken": {
						"locationName": "nextToken"
					},
					"VolumeStatuses": {
						"locationName": "volumeStatusSet",
						"type": "list",
						"member": {
							"locationName": "item",
							"type": "structure",
							"members": {
								"Actions": {
									"locationName": "actionsSet",
									"type": "list",
									"member": {
										"locationName": "item",
										"type": "structure",
										"members": {
											"Code": {
												"locationName": "code"
											},
											"Description": {
												"locationName": "description"
											},
											"EventId": {
												"locationName": "eventId"
											},
											"EventType": {
												"locationName": "eventType"
											}
										}
									}
								},
								"AvailabilityZone": {
									"locationName": "availabilityZone"
								},
								"Events": {
									"locationName": "eventsSet",
									"type": "list",
									"member": {
										"locationName": "item",
										"type": "structure",
										"members": {
											"Description": {
												"locationName": "description"
											},
											"EventId": {
												"locationName": "eventId"
											},
											"EventType": {
												"locationName": "eventType"
											},
											"NotAfter": {
												"locationName": "notAfter",
												"type": "timestamp"
											},
											"NotBefore": {
												"locationName": "notBefore",
												"type": "timestamp"
											}
										}
									}
								},
								"VolumeId": {
									"locationName": "volumeId"
								},
								"VolumeStatus": {
									"locationName": "volumeStatus",
									"type": "structure",
									"members": {
										"Details": {
											"locationName": "details",
											"type": "list",
											"member": {
												"locationName": "item",
												"type": "structure",
												"members": {
													"Name": {
														"locationName": "name"
													},
													"Status": {
														"locationName": "status"
													}
												}
											}
										},
										"Status": {
											"locationName": "status"
										}
									}
								}
							}
						}
					}
				}
			}
		},
		"DescribeVolumes": {
			"input": {
				"type": "structure",
				"members": {
					"Filters": {
						"shape": "S9g",
						"locationName": "Filter"
					},
					"VolumeIds": {
						"shape": "Sjp",
						"locationName": "VolumeId"
					},
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					},
					"MaxResults": {
						"locationName": "maxResults",
						"type": "integer"
					},
					"NextToken": {
						"locationName": "nextToken"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Volumes": {
						"locationName": "volumeSet",
						"type": "list",
						"member": {
							"shape": "S7i",
							"locationName": "item"
						}
					},
					"NextToken": {
						"locationName": "nextToken"
					}
				}
			}
		},
		"DescribeVolumesModifications": {
			"input": {
				"type": "structure",
				"members": {
					"DryRun": {
						"type": "boolean"
					},
					"VolumeIds": {
						"shape": "Sjp",
						"locationName": "VolumeId"
					},
					"Filters": {
						"shape": "S9g",
						"locationName": "Filter"
					},
					"NextToken": {},
					"MaxResults": {
						"type": "integer"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"VolumesModifications": {
						"locationName": "volumeModificationSet",
						"type": "list",
						"member": {
							"shape": "Sk8",
							"locationName": "item"
						}
					},
					"NextToken": {
						"locationName": "nextToken"
					}
				}
			}
		},
		"DescribeVpcAttribute": {
			"input": {
				"type": "structure",
				"required": [
					"Attribute",
					"VpcId"
				],
				"members": {
					"Attribute": {},
					"VpcId": {},
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"VpcId": {
						"locationName": "vpcId"
					},
					"EnableDnsHostnames": {
						"shape": "Sdo",
						"locationName": "enableDnsHostnames"
					},
					"EnableDnsSupport": {
						"shape": "Sdo",
						"locationName": "enableDnsSupport"
					}
				}
			}
		},
		"DescribeVpcClassicLink": {
			"input": {
				"type": "structure",
				"members": {
					"Filters": {
						"shape": "S9g",
						"locationName": "Filter"
					},
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					},
					"VpcIds": {
						"shape": "Ske",
						"locationName": "VpcId"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Vpcs": {
						"locationName": "vpcSet",
						"type": "list",
						"member": {
							"locationName": "item",
							"type": "structure",
							"members": {
								"ClassicLinkEnabled": {
									"locationName": "classicLinkEnabled",
									"type": "boolean"
								},
								"Tags": {
									"shape": "Sl",
									"locationName": "tagSet"
								},
								"VpcId": {
									"locationName": "vpcId"
								}
							}
						}
					}
				}
			}
		},
		"DescribeVpcClassicLinkDnsSupport": {
			"input": {
				"type": "structure",
				"members": {
					"MaxResults": {
						"locationName": "maxResults",
						"type": "integer"
					},
					"NextToken": {
						"locationName": "nextToken"
					},
					"VpcIds": {
						"shape": "Ske"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"NextToken": {
						"locationName": "nextToken"
					},
					"Vpcs": {
						"locationName": "vpcs",
						"type": "list",
						"member": {
							"locationName": "item",
							"type": "structure",
							"members": {
								"ClassicLinkDnsSupported": {
									"locationName": "classicLinkDnsSupported",
									"type": "boolean"
								},
								"VpcId": {
									"locationName": "vpcId"
								}
							}
						}
					}
				}
			}
		},
		"DescribeVpcEndpointServices": {
			"input": {
				"type": "structure",
				"members": {
					"DryRun": {
						"type": "boolean"
					},
					"MaxResults": {
						"type": "integer"
					},
					"NextToken": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"NextToken": {
						"locationName": "nextToken"
					},
					"ServiceNames": {
						"shape": "S32",
						"locationName": "serviceNameSet"
					}
				}
			}
		},
		"DescribeVpcEndpoints": {
			"input": {
				"type": "structure",
				"members": {
					"DryRun": {
						"type": "boolean"
					},
					"Filters": {
						"shape": "S9g",
						"locationName": "Filter"
					},
					"MaxResults": {
						"type": "integer"
					},
					"NextToken": {},
					"VpcEndpointIds": {
						"shape": "S32",
						"locationName": "VpcEndpointId"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"NextToken": {
						"locationName": "nextToken"
					},
					"VpcEndpoints": {
						"locationName": "vpcEndpointSet",
						"type": "list",
						"member": {
							"shape": "S7p",
							"locationName": "item"
						}
					}
				}
			}
		},
		"DescribeVpcPeeringConnections": {
			"input": {
				"type": "structure",
				"members": {
					"Filters": {
						"shape": "S9g",
						"locationName": "Filter"
					},
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					},
					"VpcPeeringConnectionIds": {
						"shape": "S32",
						"locationName": "VpcPeeringConnectionId"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"VpcPeeringConnections": {
						"locationName": "vpcPeeringConnectionSet",
						"type": "list",
						"member": {
							"shape": "Sb",
							"locationName": "item"
						}
					}
				}
			}
		},
		"DescribeVpcs": {
			"input": {
				"type": "structure",
				"members": {
					"Filters": {
						"shape": "S9g",
						"locationName": "Filter"
					},
					"VpcIds": {
						"locationName": "VpcId",
						"type": "list",
						"member": {
							"locationName": "VpcId"
						}
					},
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Vpcs": {
						"locationName": "vpcSet",
						"type": "list",
						"member": {
							"shape": "S3t",
							"locationName": "item"
						}
					}
				}
			}
		},
		"DescribeVpnConnections": {
			"input": {
				"type": "structure",
				"members": {
					"Filters": {
						"shape": "S9g",
						"locationName": "Filter"
					},
					"VpnConnectionIds": {
						"locationName": "VpnConnectionId",
						"type": "list",
						"member": {
							"locationName": "VpnConnectionId"
						}
					},
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"VpnConnections": {
						"locationName": "vpnConnectionSet",
						"type": "list",
						"member": {
							"shape": "S7w",
							"locationName": "item"
						}
					}
				}
			}
		},
		"DescribeVpnGateways": {
			"input": {
				"type": "structure",
				"members": {
					"Filters": {
						"shape": "S9g",
						"locationName": "Filter"
					},
					"VpnGatewayIds": {
						"locationName": "VpnGatewayId",
						"type": "list",
						"member": {
							"locationName": "VpnGatewayId"
						}
					},
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"VpnGateways": {
						"locationName": "vpnGatewaySet",
						"type": "list",
						"member": {
							"shape": "S88",
							"locationName": "item"
						}
					}
				}
			}
		},
		"DetachClassicLinkVpc": {
			"input": {
				"type": "structure",
				"required": [
					"InstanceId",
					"VpcId"
				],
				"members": {
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					},
					"InstanceId": {
						"locationName": "instanceId"
					},
					"VpcId": {
						"locationName": "vpcId"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Return": {
						"locationName": "return",
						"type": "boolean"
					}
				}
			}
		},
		"DetachInternetGateway": {
			"input": {
				"type": "structure",
				"required": [
					"InternetGatewayId",
					"VpcId"
				],
				"members": {
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					},
					"InternetGatewayId": {
						"locationName": "internetGatewayId"
					},
					"VpcId": {
						"locationName": "vpcId"
					}
				}
			}
		},
		"DetachNetworkInterface": {
			"input": {
				"type": "structure",
				"required": [
					"AttachmentId"
				],
				"members": {
					"AttachmentId": {
						"locationName": "attachmentId"
					},
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					},
					"Force": {
						"locationName": "force",
						"type": "boolean"
					}
				}
			}
		},
		"DetachVolume": {
			"input": {
				"type": "structure",
				"required": [
					"VolumeId"
				],
				"members": {
					"Device": {},
					"Force": {
						"type": "boolean"
					},
					"InstanceId": {},
					"VolumeId": {},
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					}
				}
			},
			"output": {
				"shape": "S1s"
			}
		},
		"DetachVpnGateway": {
			"input": {
				"type": "structure",
				"required": [
					"VpcId",
					"VpnGatewayId"
				],
				"members": {
					"VpcId": {},
					"VpnGatewayId": {},
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					}
				}
			}
		},
		"DisableVgwRoutePropagation": {
			"input": {
				"type": "structure",
				"required": [
					"GatewayId",
					"RouteTableId"
				],
				"members": {
					"GatewayId": {},
					"RouteTableId": {}
				}
			}
		},
		"DisableVpcClassicLink": {
			"input": {
				"type": "structure",
				"required": [
					"VpcId"
				],
				"members": {
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					},
					"VpcId": {
						"locationName": "vpcId"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Return": {
						"locationName": "return",
						"type": "boolean"
					}
				}
			}
		},
		"DisableVpcClassicLinkDnsSupport": {
			"input": {
				"type": "structure",
				"members": {
					"VpcId": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Return": {
						"locationName": "return",
						"type": "boolean"
					}
				}
			}
		},
		"DisassociateAddress": {
			"input": {
				"type": "structure",
				"members": {
					"AssociationId": {},
					"PublicIp": {},
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					}
				}
			}
		},
		"DisassociateIamInstanceProfile": {
			"input": {
				"type": "structure",
				"required": [
					"AssociationId"
				],
				"members": {
					"AssociationId": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"IamInstanceProfileAssociation": {
						"shape": "S15",
						"locationName": "iamInstanceProfileAssociation"
					}
				}
			}
		},
		"DisassociateRouteTable": {
			"input": {
				"type": "structure",
				"required": [
					"AssociationId"
				],
				"members": {
					"AssociationId": {
						"locationName": "associationId"
					},
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					}
				}
			}
		},
		"DisassociateSubnetCidrBlock": {
			"input": {
				"type": "structure",
				"required": [
					"AssociationId"
				],
				"members": {
					"AssociationId": {
						"locationName": "associationId"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Ipv6CidrBlockAssociation": {
						"shape": "S1c",
						"locationName": "ipv6CidrBlockAssociation"
					},
					"SubnetId": {
						"locationName": "subnetId"
					}
				}
			}
		},
		"DisassociateVpcCidrBlock": {
			"input": {
				"type": "structure",
				"required": [
					"AssociationId"
				],
				"members": {
					"AssociationId": {
						"locationName": "associationId"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Ipv6CidrBlockAssociation": {
						"shape": "S1h",
						"locationName": "ipv6CidrBlockAssociation"
					},
					"CidrBlockAssociation": {
						"shape": "S1k",
						"locationName": "cidrBlockAssociation"
					},
					"VpcId": {
						"locationName": "vpcId"
					}
				}
			}
		},
		"EnableVgwRoutePropagation": {
			"input": {
				"type": "structure",
				"required": [
					"GatewayId",
					"RouteTableId"
				],
				"members": {
					"GatewayId": {},
					"RouteTableId": {}
				}
			}
		},
		"EnableVolumeIO": {
			"input": {
				"type": "structure",
				"required": [
					"VolumeId"
				],
				"members": {
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					},
					"VolumeId": {
						"locationName": "volumeId"
					}
				}
			}
		},
		"EnableVpcClassicLink": {
			"input": {
				"type": "structure",
				"required": [
					"VpcId"
				],
				"members": {
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					},
					"VpcId": {
						"locationName": "vpcId"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Return": {
						"locationName": "return",
						"type": "boolean"
					}
				}
			}
		},
		"EnableVpcClassicLinkDnsSupport": {
			"input": {
				"type": "structure",
				"members": {
					"VpcId": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Return": {
						"locationName": "return",
						"type": "boolean"
					}
				}
			}
		},
		"GetConsoleOutput": {
			"input": {
				"type": "structure",
				"required": [
					"InstanceId"
				],
				"members": {
					"InstanceId": {},
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"InstanceId": {
						"locationName": "instanceId"
					},
					"Output": {
						"locationName": "output"
					},
					"Timestamp": {
						"locationName": "timestamp",
						"type": "timestamp"
					}
				}
			}
		},
		"GetConsoleScreenshot": {
			"input": {
				"type": "structure",
				"required": [
					"InstanceId"
				],
				"members": {
					"DryRun": {
						"type": "boolean"
					},
					"InstanceId": {},
					"WakeUp": {
						"type": "boolean"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"ImageData": {
						"locationName": "imageData"
					},
					"InstanceId": {
						"locationName": "instanceId"
					}
				}
			}
		},
		"GetHostReservationPurchasePreview": {
			"input": {
				"type": "structure",
				"required": [
					"HostIdSet",
					"OfferingId"
				],
				"members": {
					"HostIdSet": {
						"shape": "Sm0"
					},
					"OfferingId": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"CurrencyCode": {
						"locationName": "currencyCode"
					},
					"Purchase": {
						"shape": "Sm2",
						"locationName": "purchase"
					},
					"TotalHourlyPrice": {
						"locationName": "totalHourlyPrice"
					},
					"TotalUpfrontPrice": {
						"locationName": "totalUpfrontPrice"
					}
				}
			}
		},
		"GetPasswordData": {
			"input": {
				"type": "structure",
				"required": [
					"InstanceId"
				],
				"members": {
					"InstanceId": {},
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"InstanceId": {
						"locationName": "instanceId"
					},
					"PasswordData": {
						"locationName": "passwordData"
					},
					"Timestamp": {
						"locationName": "timestamp",
						"type": "timestamp"
					}
				}
			}
		},
		"GetReservedInstancesExchangeQuote": {
			"input": {
				"type": "structure",
				"required": [
					"ReservedInstanceIds"
				],
				"members": {
					"DryRun": {
						"type": "boolean"
					},
					"ReservedInstanceIds": {
						"shape": "S3",
						"locationName": "ReservedInstanceId"
					},
					"TargetConfigurations": {
						"shape": "S5",
						"locationName": "TargetConfiguration"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"CurrencyCode": {
						"locationName": "currencyCode"
					},
					"IsValidExchange": {
						"locationName": "isValidExchange",
						"type": "boolean"
					},
					"OutputReservedInstancesWillExpireAt": {
						"locationName": "outputReservedInstancesWillExpireAt",
						"type": "timestamp"
					},
					"PaymentDue": {
						"locationName": "paymentDue"
					},
					"ReservedInstanceValueRollup": {
						"shape": "Sm8",
						"locationName": "reservedInstanceValueRollup"
					},
					"ReservedInstanceValueSet": {
						"locationName": "reservedInstanceValueSet",
						"type": "list",
						"member": {
							"locationName": "item",
							"type": "structure",
							"members": {
								"ReservationValue": {
									"shape": "Sm8",
									"locationName": "reservationValue"
								},
								"ReservedInstanceId": {
									"locationName": "reservedInstanceId"
								}
							}
						}
					},
					"TargetConfigurationValueRollup": {
						"shape": "Sm8",
						"locationName": "targetConfigurationValueRollup"
					},
					"TargetConfigurationValueSet": {
						"locationName": "targetConfigurationValueSet",
						"type": "list",
						"member": {
							"locationName": "item",
							"type": "structure",
							"members": {
								"ReservationValue": {
									"shape": "Sm8",
									"locationName": "reservationValue"
								},
								"TargetConfiguration": {
									"locationName": "targetConfiguration",
									"type": "structure",
									"members": {
										"InstanceCount": {
											"locationName": "instanceCount",
											"type": "integer"
										},
										"OfferingId": {
											"locationName": "offeringId"
										}
									}
								}
							}
						}
					},
					"ValidationFailureReason": {
						"locationName": "validationFailureReason"
					}
				}
			}
		},
		"ImportImage": {
			"input": {
				"type": "structure",
				"members": {
					"Architecture": {},
					"ClientData": {
						"shape": "Smf"
					},
					"ClientToken": {},
					"Description": {},
					"DiskContainers": {
						"locationName": "DiskContainer",
						"type": "list",
						"member": {
							"locationName": "item",
							"type": "structure",
							"members": {
								"Description": {},
								"DeviceName": {},
								"Format": {},
								"SnapshotId": {},
								"Url": {},
								"UserBucket": {
									"shape": "Smi"
								}
							}
						}
					},
					"DryRun": {
						"type": "boolean"
					},
					"Hypervisor": {},
					"LicenseType": {},
					"Platform": {},
					"RoleName": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Architecture": {
						"locationName": "architecture"
					},
					"Description": {
						"locationName": "description"
					},
					"Hypervisor": {
						"locationName": "hypervisor"
					},
					"ImageId": {
						"locationName": "imageId"
					},
					"ImportTaskId": {
						"locationName": "importTaskId"
					},
					"LicenseType": {
						"locationName": "licenseType"
					},
					"Platform": {
						"locationName": "platform"
					},
					"Progress": {
						"locationName": "progress"
					},
					"SnapshotDetails": {
						"shape": "Sda",
						"locationName": "snapshotDetailSet"
					},
					"Status": {
						"locationName": "status"
					},
					"StatusMessage": {
						"locationName": "statusMessage"
					}
				}
			}
		},
		"ImportInstance": {
			"input": {
				"type": "structure",
				"required": [
					"Platform"
				],
				"members": {
					"Description": {
						"locationName": "description"
					},
					"DiskImages": {
						"locationName": "diskImage",
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"Description": {},
								"Image": {
									"shape": "Smn"
								},
								"Volume": {
									"shape": "Smo"
								}
							}
						}
					},
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					},
					"LaunchSpecification": {
						"locationName": "launchSpecification",
						"type": "structure",
						"members": {
							"AdditionalInfo": {
								"locationName": "additionalInfo"
							},
							"Architecture": {
								"locationName": "architecture"
							},
							"GroupIds": {
								"shape": "S5r",
								"locationName": "GroupId"
							},
							"GroupNames": {
								"shape": "Smq",
								"locationName": "GroupName"
							},
							"InstanceInitiatedShutdownBehavior": {
								"locationName": "instanceInitiatedShutdownBehavior"
							},
							"InstanceType": {
								"locationName": "instanceType"
							},
							"Monitoring": {
								"locationName": "monitoring",
								"type": "boolean"
							},
							"Placement": {
								"shape": "Sed",
								"locationName": "placement"
							},
							"PrivateIpAddress": {
								"locationName": "privateIpAddress"
							},
							"SubnetId": {
								"locationName": "subnetId"
							},
							"UserData": {
								"locationName": "userData",
								"type": "structure",
								"members": {
									"Data": {
										"locationName": "data"
									}
								}
							}
						}
					},
					"Platform": {
						"locationName": "platform"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"ConversionTask": {
						"shape": "Sa8",
						"locationName": "conversionTask"
					}
				}
			}
		},
		"ImportKeyPair": {
			"input": {
				"type": "structure",
				"required": [
					"KeyName",
					"PublicKeyMaterial"
				],
				"members": {
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					},
					"KeyName": {
						"locationName": "keyName"
					},
					"PublicKeyMaterial": {
						"locationName": "publicKeyMaterial",
						"type": "blob"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"KeyFingerprint": {
						"locationName": "keyFingerprint"
					},
					"KeyName": {
						"locationName": "keyName"
					}
				}
			}
		},
		"ImportSnapshot": {
			"input": {
				"type": "structure",
				"members": {
					"ClientData": {
						"shape": "Smf"
					},
					"ClientToken": {},
					"Description": {},
					"DiskContainer": {
						"type": "structure",
						"members": {
							"Description": {},
							"Format": {},
							"Url": {},
							"UserBucket": {
								"shape": "Smi"
							}
						}
					},
					"DryRun": {
						"type": "boolean"
					},
					"RoleName": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Description": {
						"locationName": "description"
					},
					"ImportTaskId": {
						"locationName": "importTaskId"
					},
					"SnapshotTaskDetail": {
						"shape": "Sdh",
						"locationName": "snapshotTaskDetail"
					}
				}
			}
		},
		"ImportVolume": {
			"input": {
				"type": "structure",
				"required": [
					"AvailabilityZone",
					"Image",
					"Volume"
				],
				"members": {
					"AvailabilityZone": {
						"locationName": "availabilityZone"
					},
					"Description": {
						"locationName": "description"
					},
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					},
					"Image": {
						"shape": "Smn",
						"locationName": "image"
					},
					"Volume": {
						"shape": "Smo",
						"locationName": "volume"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"ConversionTask": {
						"shape": "Sa8",
						"locationName": "conversionTask"
					}
				}
			}
		},
		"ModifyHosts": {
			"input": {
				"type": "structure",
				"required": [
					"AutoPlacement",
					"HostIds"
				],
				"members": {
					"AutoPlacement": {
						"locationName": "autoPlacement"
					},
					"HostIds": {
						"shape": "Sc0",
						"locationName": "hostId"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Successful": {
						"shape": "St",
						"locationName": "successful"
					},
					"Unsuccessful": {
						"shape": "Sn3",
						"locationName": "unsuccessful"
					}
				}
			}
		},
		"ModifyIdFormat": {
			"input": {
				"type": "structure",
				"required": [
					"Resource",
					"UseLongIds"
				],
				"members": {
					"Resource": {},
					"UseLongIds": {
						"type": "boolean"
					}
				}
			}
		},
		"ModifyIdentityIdFormat": {
			"input": {
				"type": "structure",
				"required": [
					"PrincipalArn",
					"Resource",
					"UseLongIds"
				],
				"members": {
					"PrincipalArn": {
						"locationName": "principalArn"
					},
					"Resource": {
						"locationName": "resource"
					},
					"UseLongIds": {
						"locationName": "useLongIds",
						"type": "boolean"
					}
				}
			}
		},
		"ModifyImageAttribute": {
			"input": {
				"type": "structure",
				"required": [
					"ImageId"
				],
				"members": {
					"Attribute": {},
					"Description": {
						"shape": "S46"
					},
					"ImageId": {},
					"LaunchPermission": {
						"type": "structure",
						"members": {
							"Add": {
								"shape": "Scp"
							},
							"Remove": {
								"shape": "Scp"
							}
						}
					},
					"OperationType": {},
					"ProductCodes": {
						"locationName": "ProductCode",
						"type": "list",
						"member": {
							"locationName": "ProductCode"
						}
					},
					"UserGroups": {
						"locationName": "UserGroup",
						"type": "list",
						"member": {
							"locationName": "UserGroup"
						}
					},
					"UserIds": {
						"shape": "Snb",
						"locationName": "UserId"
					},
					"Value": {},
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					}
				}
			}
		},
		"ModifyInstanceAttribute": {
			"input": {
				"type": "structure",
				"required": [
					"InstanceId"
				],
				"members": {
					"SourceDestCheck": {
						"shape": "Sdo"
					},
					"Attribute": {
						"locationName": "attribute"
					},
					"BlockDeviceMappings": {
						"locationName": "blockDeviceMapping",
						"type": "list",
						"member": {
							"locationName": "item",
							"type": "structure",
							"members": {
								"DeviceName": {
									"locationName": "deviceName"
								},
								"Ebs": {
									"locationName": "ebs",
									"type": "structure",
									"members": {
										"DeleteOnTermination": {
											"locationName": "deleteOnTermination",
											"type": "boolean"
										},
										"VolumeId": {
											"locationName": "volumeId"
										}
									}
								},
								"NoDevice": {
									"locationName": "noDevice"
								},
								"VirtualName": {
									"locationName": "virtualName"
								}
							}
						}
					},
					"DisableApiTermination": {
						"shape": "Sdo",
						"locationName": "disableApiTermination"
					},
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					},
					"EbsOptimized": {
						"shape": "Sdo",
						"locationName": "ebsOptimized"
					},
					"EnaSupport": {
						"shape": "Sdo",
						"locationName": "enaSupport"
					},
					"Groups": {
						"shape": "S1m",
						"locationName": "GroupId"
					},
					"InstanceId": {
						"locationName": "instanceId"
					},
					"InstanceInitiatedShutdownBehavior": {
						"shape": "S46",
						"locationName": "instanceInitiatedShutdownBehavior"
					},
					"InstanceType": {
						"shape": "S46",
						"locationName": "instanceType"
					},
					"Kernel": {
						"shape": "S46",
						"locationName": "kernel"
					},
					"Ramdisk": {
						"shape": "S46",
						"locationName": "ramdisk"
					},
					"SriovNetSupport": {
						"shape": "S46",
						"locationName": "sriovNetSupport"
					},
					"UserData": {
						"locationName": "userData",
						"type": "structure",
						"members": {
							"Value": {
								"locationName": "value",
								"type": "blob"
							}
						}
					},
					"Value": {
						"locationName": "value"
					}
				}
			}
		},
		"ModifyInstancePlacement": {
			"input": {
				"type": "structure",
				"required": [
					"InstanceId"
				],
				"members": {
					"Affinity": {
						"locationName": "affinity"
					},
					"HostId": {
						"locationName": "hostId"
					},
					"InstanceId": {
						"locationName": "instanceId"
					},
					"Tenancy": {
						"locationName": "tenancy"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Return": {
						"locationName": "return",
						"type": "boolean"
					}
				}
			}
		},
		"ModifyNetworkInterfaceAttribute": {
			"input": {
				"type": "structure",
				"required": [
					"NetworkInterfaceId"
				],
				"members": {
					"Attachment": {
						"locationName": "attachment",
						"type": "structure",
						"members": {
							"AttachmentId": {
								"locationName": "attachmentId"
							},
							"DeleteOnTermination": {
								"locationName": "deleteOnTermination",
								"type": "boolean"
							}
						}
					},
					"Description": {
						"shape": "S46",
						"locationName": "description"
					},
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					},
					"Groups": {
						"shape": "S5r",
						"locationName": "SecurityGroupId"
					},
					"NetworkInterfaceId": {
						"locationName": "networkInterfaceId"
					},
					"SourceDestCheck": {
						"shape": "Sdo",
						"locationName": "sourceDestCheck"
					}
				}
			}
		},
		"ModifyReservedInstances": {
			"input": {
				"type": "structure",
				"required": [
					"ReservedInstancesIds",
					"TargetConfigurations"
				],
				"members": {
					"ReservedInstancesIds": {
						"shape": "Sfy",
						"locationName": "ReservedInstancesId"
					},
					"ClientToken": {
						"locationName": "clientToken"
					},
					"TargetConfigurations": {
						"locationName": "ReservedInstancesConfigurationSetItemType",
						"type": "list",
						"member": {
							"shape": "Sgj",
							"locationName": "item"
						}
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"ReservedInstancesModificationId": {
						"locationName": "reservedInstancesModificationId"
					}
				}
			}
		},
		"ModifySnapshotAttribute": {
			"input": {
				"type": "structure",
				"required": [
					"SnapshotId"
				],
				"members": {
					"Attribute": {},
					"CreateVolumePermission": {
						"type": "structure",
						"members": {
							"Add": {
								"shape": "Sho"
							},
							"Remove": {
								"shape": "Sho"
							}
						}
					},
					"GroupNames": {
						"shape": "Shh",
						"locationName": "UserGroup"
					},
					"OperationType": {},
					"SnapshotId": {},
					"UserIds": {
						"shape": "Snb",
						"locationName": "UserId"
					},
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					}
				}
			}
		},
		"ModifySpotFleetRequest": {
			"input": {
				"type": "structure",
				"required": [
					"SpotFleetRequestId"
				],
				"members": {
					"ExcessCapacityTerminationPolicy": {
						"locationName": "excessCapacityTerminationPolicy"
					},
					"SpotFleetRequestId": {
						"locationName": "spotFleetRequestId"
					},
					"TargetCapacity": {
						"locationName": "targetCapacity",
						"type": "integer"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Return": {
						"locationName": "return",
						"type": "boolean"
					}
				}
			}
		},
		"ModifySubnetAttribute": {
			"input": {
				"type": "structure",
				"required": [
					"SubnetId"
				],
				"members": {
					"AssignIpv6AddressOnCreation": {
						"shape": "Sdo"
					},
					"MapPublicIpOnLaunch": {
						"shape": "Sdo"
					},
					"SubnetId": {
						"locationName": "subnetId"
					}
				}
			}
		},
		"ModifyVolume": {
			"input": {
				"type": "structure",
				"required": [
					"VolumeId"
				],
				"members": {
					"DryRun": {
						"type": "boolean"
					},
					"VolumeId": {},
					"Size": {
						"type": "integer"
					},
					"VolumeType": {},
					"Iops": {
						"type": "integer"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"VolumeModification": {
						"shape": "Sk8",
						"locationName": "volumeModification"
					}
				}
			}
		},
		"ModifyVolumeAttribute": {
			"input": {
				"type": "structure",
				"required": [
					"VolumeId"
				],
				"members": {
					"AutoEnableIO": {
						"shape": "Sdo"
					},
					"VolumeId": {},
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					}
				}
			}
		},
		"ModifyVpcAttribute": {
			"input": {
				"type": "structure",
				"required": [
					"VpcId"
				],
				"members": {
					"EnableDnsHostnames": {
						"shape": "Sdo"
					},
					"EnableDnsSupport": {
						"shape": "Sdo"
					},
					"VpcId": {
						"locationName": "vpcId"
					}
				}
			}
		},
		"ModifyVpcEndpoint": {
			"input": {
				"type": "structure",
				"required": [
					"VpcEndpointId"
				],
				"members": {
					"AddRouteTableIds": {
						"shape": "S32",
						"locationName": "AddRouteTableId"
					},
					"DryRun": {
						"type": "boolean"
					},
					"PolicyDocument": {},
					"RemoveRouteTableIds": {
						"shape": "S32",
						"locationName": "RemoveRouteTableId"
					},
					"ResetPolicy": {
						"type": "boolean"
					},
					"VpcEndpointId": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Return": {
						"locationName": "return",
						"type": "boolean"
					}
				}
			}
		},
		"ModifyVpcPeeringConnectionOptions": {
			"input": {
				"type": "structure",
				"required": [
					"VpcPeeringConnectionId"
				],
				"members": {
					"AccepterPeeringConnectionOptions": {
						"shape": "So2"
					},
					"DryRun": {
						"type": "boolean"
					},
					"RequesterPeeringConnectionOptions": {
						"shape": "So2"
					},
					"VpcPeeringConnectionId": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"AccepterPeeringConnectionOptions": {
						"shape": "So4",
						"locationName": "accepterPeeringConnectionOptions"
					},
					"RequesterPeeringConnectionOptions": {
						"shape": "So4",
						"locationName": "requesterPeeringConnectionOptions"
					}
				}
			}
		},
		"MonitorInstances": {
			"input": {
				"type": "structure",
				"required": [
					"InstanceIds"
				],
				"members": {
					"InstanceIds": {
						"shape": "Sa0",
						"locationName": "InstanceId"
					},
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"InstanceMonitorings": {
						"shape": "So7",
						"locationName": "instancesSet"
					}
				}
			}
		},
		"MoveAddressToVpc": {
			"input": {
				"type": "structure",
				"required": [
					"PublicIp"
				],
				"members": {
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					},
					"PublicIp": {
						"locationName": "publicIp"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"AllocationId": {
						"locationName": "allocationId"
					},
					"Status": {
						"locationName": "status"
					}
				}
			}
		},
		"PurchaseHostReservation": {
			"input": {
				"type": "structure",
				"required": [
					"HostIdSet",
					"OfferingId"
				],
				"members": {
					"ClientToken": {},
					"CurrencyCode": {},
					"HostIdSet": {
						"shape": "Sm0"
					},
					"LimitPrice": {},
					"OfferingId": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"ClientToken": {
						"locationName": "clientToken"
					},
					"CurrencyCode": {
						"locationName": "currencyCode"
					},
					"Purchase": {
						"shape": "Sm2",
						"locationName": "purchase"
					},
					"TotalHourlyPrice": {
						"locationName": "totalHourlyPrice"
					},
					"TotalUpfrontPrice": {
						"locationName": "totalUpfrontPrice"
					}
				}
			}
		},
		"PurchaseReservedInstancesOffering": {
			"input": {
				"type": "structure",
				"required": [
					"InstanceCount",
					"ReservedInstancesOfferingId"
				],
				"members": {
					"InstanceCount": {
						"type": "integer"
					},
					"ReservedInstancesOfferingId": {},
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					},
					"LimitPrice": {
						"locationName": "limitPrice",
						"type": "structure",
						"members": {
							"Amount": {
								"locationName": "amount",
								"type": "double"
							},
							"CurrencyCode": {
								"locationName": "currencyCode"
							}
						}
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"ReservedInstancesId": {
						"locationName": "reservedInstancesId"
					}
				}
			}
		},
		"PurchaseScheduledInstances": {
			"input": {
				"type": "structure",
				"required": [
					"PurchaseRequests"
				],
				"members": {
					"ClientToken": {
						"idempotencyToken": true
					},
					"DryRun": {
						"type": "boolean"
					},
					"PurchaseRequests": {
						"locationName": "PurchaseRequest",
						"type": "list",
						"member": {
							"locationName": "PurchaseRequest",
							"type": "structure",
							"required": [
								"InstanceCount",
								"PurchaseToken"
							],
							"members": {
								"InstanceCount": {
									"type": "integer"
								},
								"PurchaseToken": {}
							}
						}
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"ScheduledInstanceSet": {
						"locationName": "scheduledInstanceSet",
						"type": "list",
						"member": {
							"shape": "Sha",
							"locationName": "item"
						}
					}
				}
			}
		},
		"RebootInstances": {
			"input": {
				"type": "structure",
				"required": [
					"InstanceIds"
				],
				"members": {
					"InstanceIds": {
						"shape": "Sa0",
						"locationName": "InstanceId"
					},
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					}
				}
			}
		},
		"RegisterImage": {
			"input": {
				"type": "structure",
				"required": [
					"Name"
				],
				"members": {
					"ImageLocation": {},
					"Architecture": {
						"locationName": "architecture"
					},
					"BlockDeviceMappings": {
						"shape": "S4o",
						"locationName": "BlockDeviceMapping"
					},
					"Description": {
						"locationName": "description"
					},
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					},
					"EnaSupport": {
						"locationName": "enaSupport",
						"type": "boolean"
					},
					"KernelId": {
						"locationName": "kernelId"
					},
					"Name": {
						"locationName": "name"
					},
					"BillingProducts": {
						"locationName": "BillingProduct",
						"type": "list",
						"member": {
							"locationName": "item"
						}
					},
					"RamdiskId": {
						"locationName": "ramdiskId"
					},
					"RootDeviceName": {
						"locationName": "rootDeviceName"
					},
					"SriovNetSupport": {
						"locationName": "sriovNetSupport"
					},
					"VirtualizationType": {
						"locationName": "virtualizationType"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"ImageId": {
						"locationName": "imageId"
					}
				}
			}
		},
		"RejectVpcPeeringConnection": {
			"input": {
				"type": "structure",
				"required": [
					"VpcPeeringConnectionId"
				],
				"members": {
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					},
					"VpcPeeringConnectionId": {
						"locationName": "vpcPeeringConnectionId"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Return": {
						"locationName": "return",
						"type": "boolean"
					}
				}
			}
		},
		"ReleaseAddress": {
			"input": {
				"type": "structure",
				"members": {
					"AllocationId": {},
					"PublicIp": {},
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					}
				}
			}
		},
		"ReleaseHosts": {
			"input": {
				"type": "structure",
				"required": [
					"HostIds"
				],
				"members": {
					"HostIds": {
						"shape": "Sc0",
						"locationName": "hostId"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Successful": {
						"shape": "St",
						"locationName": "successful"
					},
					"Unsuccessful": {
						"shape": "Sn3",
						"locationName": "unsuccessful"
					}
				}
			}
		},
		"ReplaceIamInstanceProfileAssociation": {
			"input": {
				"type": "structure",
				"required": [
					"IamInstanceProfile",
					"AssociationId"
				],
				"members": {
					"IamInstanceProfile": {
						"shape": "S13"
					},
					"AssociationId": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"IamInstanceProfileAssociation": {
						"shape": "S15",
						"locationName": "iamInstanceProfileAssociation"
					}
				}
			}
		},
		"ReplaceNetworkAclAssociation": {
			"input": {
				"type": "structure",
				"required": [
					"AssociationId",
					"NetworkAclId"
				],
				"members": {
					"AssociationId": {
						"locationName": "associationId"
					},
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					},
					"NetworkAclId": {
						"locationName": "networkAclId"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"NewAssociationId": {
						"locationName": "newAssociationId"
					}
				}
			}
		},
		"ReplaceNetworkAclEntry": {
			"input": {
				"type": "structure",
				"required": [
					"Egress",
					"NetworkAclId",
					"Protocol",
					"RuleAction",
					"RuleNumber"
				],
				"members": {
					"CidrBlock": {
						"locationName": "cidrBlock"
					},
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					},
					"Egress": {
						"locationName": "egress",
						"type": "boolean"
					},
					"IcmpTypeCode": {
						"shape": "S5m",
						"locationName": "Icmp"
					},
					"Ipv6CidrBlock": {
						"locationName": "ipv6CidrBlock"
					},
					"NetworkAclId": {
						"locationName": "networkAclId"
					},
					"PortRange": {
						"shape": "S5n",
						"locationName": "portRange"
					},
					"Protocol": {
						"locationName": "protocol"
					},
					"RuleAction": {
						"locationName": "ruleAction"
					},
					"RuleNumber": {
						"locationName": "ruleNumber",
						"type": "integer"
					}
				}
			}
		},
		"ReplaceRoute": {
			"input": {
				"type": "structure",
				"required": [
					"RouteTableId"
				],
				"members": {
					"DestinationCidrBlock": {
						"locationName": "destinationCidrBlock"
					},
					"DestinationIpv6CidrBlock": {
						"locationName": "destinationIpv6CidrBlock"
					},
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					},
					"EgressOnlyInternetGatewayId": {
						"locationName": "egressOnlyInternetGatewayId"
					},
					"GatewayId": {
						"locationName": "gatewayId"
					},
					"InstanceId": {
						"locationName": "instanceId"
					},
					"NatGatewayId": {
						"locationName": "natGatewayId"
					},
					"NetworkInterfaceId": {
						"locationName": "networkInterfaceId"
					},
					"RouteTableId": {
						"locationName": "routeTableId"
					},
					"VpcPeeringConnectionId": {
						"locationName": "vpcPeeringConnectionId"
					}
				}
			}
		},
		"ReplaceRouteTableAssociation": {
			"input": {
				"type": "structure",
				"required": [
					"AssociationId",
					"RouteTableId"
				],
				"members": {
					"AssociationId": {
						"locationName": "associationId"
					},
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					},
					"RouteTableId": {
						"locationName": "routeTableId"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"NewAssociationId": {
						"locationName": "newAssociationId"
					}
				}
			}
		},
		"ReportInstanceStatus": {
			"input": {
				"type": "structure",
				"required": [
					"Instances",
					"ReasonCodes",
					"Status"
				],
				"members": {
					"Description": {
						"locationName": "description"
					},
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					},
					"EndTime": {
						"locationName": "endTime",
						"type": "timestamp"
					},
					"Instances": {
						"shape": "Sa0",
						"locationName": "instanceId"
					},
					"ReasonCodes": {
						"locationName": "reasonCode",
						"type": "list",
						"member": {
							"locationName": "item"
						}
					},
					"StartTime": {
						"locationName": "startTime",
						"type": "timestamp"
					},
					"Status": {
						"locationName": "status"
					}
				}
			}
		},
		"RequestSpotFleet": {
			"input": {
				"type": "structure",
				"required": [
					"SpotFleetRequestConfig"
				],
				"members": {
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					},
					"SpotFleetRequestConfig": {
						"shape": "Sid",
						"locationName": "spotFleetRequestConfig"
					}
				}
			},
			"output": {
				"type": "structure",
				"required": [
					"SpotFleetRequestId"
				],
				"members": {
					"SpotFleetRequestId": {
						"locationName": "spotFleetRequestId"
					}
				}
			}
		},
		"RequestSpotInstances": {
			"input": {
				"type": "structure",
				"required": [
					"SpotPrice"
				],
				"members": {
					"AvailabilityZoneGroup": {
						"locationName": "availabilityZoneGroup"
					},
					"BlockDurationMinutes": {
						"locationName": "blockDurationMinutes",
						"type": "integer"
					},
					"ClientToken": {
						"locationName": "clientToken"
					},
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					},
					"InstanceCount": {
						"locationName": "instanceCount",
						"type": "integer"
					},
					"LaunchGroup": {
						"locationName": "launchGroup"
					},
					"LaunchSpecification": {
						"type": "structure",
						"members": {
							"SecurityGroupIds": {
								"shape": "S32",
								"locationName": "SecurityGroupId"
							},
							"SecurityGroups": {
								"shape": "S32",
								"locationName": "SecurityGroup"
							},
							"AddressingType": {
								"locationName": "addressingType"
							},
							"BlockDeviceMappings": {
								"shape": "Sco",
								"locationName": "blockDeviceMapping"
							},
							"EbsOptimized": {
								"locationName": "ebsOptimized",
								"type": "boolean"
							},
							"IamInstanceProfile": {
								"shape": "S13",
								"locationName": "iamInstanceProfile"
							},
							"ImageId": {
								"locationName": "imageId"
							},
							"InstanceType": {
								"locationName": "instanceType"
							},
							"KernelId": {
								"locationName": "kernelId"
							},
							"KeyName": {
								"locationName": "keyName"
							},
							"Monitoring": {
								"shape": "Siu",
								"locationName": "monitoring"
							},
							"NetworkInterfaces": {
								"shape": "Sij",
								"locationName": "NetworkInterface"
							},
							"Placement": {
								"shape": "Sil",
								"locationName": "placement"
							},
							"RamdiskId": {
								"locationName": "ramdiskId"
							},
							"SubnetId": {
								"locationName": "subnetId"
							},
							"UserData": {
								"locationName": "userData"
							}
						}
					},
					"SpotPrice": {
						"locationName": "spotPrice"
					},
					"Type": {
						"locationName": "type"
					},
					"ValidFrom": {
						"locationName": "validFrom",
						"type": "timestamp"
					},
					"ValidUntil": {
						"locationName": "validUntil",
						"type": "timestamp"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"SpotInstanceRequests": {
						"shape": "Sir",
						"locationName": "spotInstanceRequestSet"
					}
				}
			}
		},
		"ResetImageAttribute": {
			"input": {
				"type": "structure",
				"required": [
					"Attribute",
					"ImageId"
				],
				"members": {
					"Attribute": {},
					"ImageId": {},
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					}
				}
			}
		},
		"ResetInstanceAttribute": {
			"input": {
				"type": "structure",
				"required": [
					"Attribute",
					"InstanceId"
				],
				"members": {
					"Attribute": {
						"locationName": "attribute"
					},
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					},
					"InstanceId": {
						"locationName": "instanceId"
					}
				}
			}
		},
		"ResetNetworkInterfaceAttribute": {
			"input": {
				"type": "structure",
				"required": [
					"NetworkInterfaceId"
				],
				"members": {
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					},
					"NetworkInterfaceId": {
						"locationName": "networkInterfaceId"
					},
					"SourceDestCheck": {
						"locationName": "sourceDestCheck"
					}
				}
			}
		},
		"ResetSnapshotAttribute": {
			"input": {
				"type": "structure",
				"required": [
					"Attribute",
					"SnapshotId"
				],
				"members": {
					"Attribute": {},
					"SnapshotId": {},
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					}
				}
			}
		},
		"RestoreAddressToClassic": {
			"input": {
				"type": "structure",
				"required": [
					"PublicIp"
				],
				"members": {
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					},
					"PublicIp": {
						"locationName": "publicIp"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"PublicIp": {
						"locationName": "publicIp"
					},
					"Status": {
						"locationName": "status"
					}
				}
			}
		},
		"RevokeSecurityGroupEgress": {
			"input": {
				"type": "structure",
				"required": [
					"GroupId"
				],
				"members": {
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					},
					"GroupId": {
						"locationName": "groupId"
					},
					"IpPermissions": {
						"shape": "S1z",
						"locationName": "ipPermissions"
					},
					"CidrIp": {
						"locationName": "cidrIp"
					},
					"FromPort": {
						"locationName": "fromPort",
						"type": "integer"
					},
					"IpProtocol": {
						"locationName": "ipProtocol"
					},
					"ToPort": {
						"locationName": "toPort",
						"type": "integer"
					},
					"SourceSecurityGroupName": {
						"locationName": "sourceSecurityGroupName"
					},
					"SourceSecurityGroupOwnerId": {
						"locationName": "sourceSecurityGroupOwnerId"
					}
				}
			}
		},
		"RevokeSecurityGroupIngress": {
			"input": {
				"type": "structure",
				"members": {
					"CidrIp": {},
					"FromPort": {
						"type": "integer"
					},
					"GroupId": {},
					"GroupName": {},
					"IpPermissions": {
						"shape": "S1z"
					},
					"IpProtocol": {},
					"SourceSecurityGroupName": {},
					"SourceSecurityGroupOwnerId": {},
					"ToPort": {
						"type": "integer"
					},
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					}
				}
			}
		},
		"RunInstances": {
			"input": {
				"type": "structure",
				"required": [
					"ImageId",
					"MaxCount",
					"MinCount"
				],
				"members": {
					"BlockDeviceMappings": {
						"shape": "S4o",
						"locationName": "BlockDeviceMapping"
					},
					"ImageId": {},
					"InstanceType": {},
					"Ipv6AddressCount": {
						"type": "integer"
					},
					"Ipv6Addresses": {
						"shape": "S5s",
						"locationName": "Ipv6Address"
					},
					"KernelId": {},
					"KeyName": {},
					"MaxCount": {
						"type": "integer"
					},
					"MinCount": {
						"type": "integer"
					},
					"Monitoring": {
						"shape": "Siu"
					},
					"Placement": {
						"shape": "Sed"
					},
					"RamdiskId": {},
					"SecurityGroupIds": {
						"shape": "S5r",
						"locationName": "SecurityGroupId"
					},
					"SecurityGroups": {
						"shape": "Smq",
						"locationName": "SecurityGroup"
					},
					"SubnetId": {},
					"UserData": {},
					"AdditionalInfo": {
						"locationName": "additionalInfo"
					},
					"ClientToken": {
						"locationName": "clientToken"
					},
					"DisableApiTermination": {
						"locationName": "disableApiTermination",
						"type": "boolean"
					},
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					},
					"EbsOptimized": {
						"locationName": "ebsOptimized",
						"type": "boolean"
					},
					"IamInstanceProfile": {
						"shape": "S13",
						"locationName": "iamInstanceProfile"
					},
					"InstanceInitiatedShutdownBehavior": {
						"locationName": "instanceInitiatedShutdownBehavior"
					},
					"NetworkInterfaces": {
						"shape": "Sij",
						"locationName": "networkInterface"
					},
					"PrivateIpAddress": {
						"locationName": "privateIpAddress"
					},
					"ElasticGpuSpecification": {
						"type": "list",
						"member": {
							"locationName": "item",
							"type": "structure",
							"required": [
								"Type"
							],
							"members": {
								"Type": {}
							}
						}
					},
					"TagSpecifications": {
						"shape": "S7f",
						"locationName": "TagSpecification"
					}
				}
			},
			"output": {
				"shape": "Se7"
			}
		},
		"RunScheduledInstances": {
			"input": {
				"type": "structure",
				"required": [
					"LaunchSpecification",
					"ScheduledInstanceId"
				],
				"members": {
					"ClientToken": {
						"idempotencyToken": true
					},
					"DryRun": {
						"type": "boolean"
					},
					"InstanceCount": {
						"type": "integer"
					},
					"LaunchSpecification": {
						"type": "structure",
						"required": [
							"ImageId"
						],
						"members": {
							"BlockDeviceMappings": {
								"locationName": "BlockDeviceMapping",
								"type": "list",
								"member": {
									"locationName": "BlockDeviceMapping",
									"type": "structure",
									"members": {
										"DeviceName": {},
										"Ebs": {
											"type": "structure",
											"members": {
												"DeleteOnTermination": {
													"type": "boolean"
												},
												"Encrypted": {
													"type": "boolean"
												},
												"Iops": {
													"type": "integer"
												},
												"SnapshotId": {},
												"VolumeSize": {
													"type": "integer"
												},
												"VolumeType": {}
											}
										},
										"NoDevice": {},
										"VirtualName": {}
									}
								}
							},
							"EbsOptimized": {
								"type": "boolean"
							},
							"IamInstanceProfile": {
								"type": "structure",
								"members": {
									"Arn": {},
									"Name": {}
								}
							},
							"ImageId": {},
							"InstanceType": {},
							"KernelId": {},
							"KeyName": {},
							"Monitoring": {
								"type": "structure",
								"members": {
									"Enabled": {
										"type": "boolean"
									}
								}
							},
							"NetworkInterfaces": {
								"locationName": "NetworkInterface",
								"type": "list",
								"member": {
									"locationName": "NetworkInterface",
									"type": "structure",
									"members": {
										"AssociatePublicIpAddress": {
											"type": "boolean"
										},
										"DeleteOnTermination": {
											"type": "boolean"
										},
										"Description": {},
										"DeviceIndex": {
											"type": "integer"
										},
										"Groups": {
											"shape": "Spx",
											"locationName": "Group"
										},
										"Ipv6AddressCount": {
											"type": "integer"
										},
										"Ipv6Addresses": {
											"locationName": "Ipv6Address",
											"type": "list",
											"member": {
												"locationName": "Ipv6Address",
												"type": "structure",
												"members": {
													"Ipv6Address": {}
												}
											}
										},
										"NetworkInterfaceId": {},
										"PrivateIpAddress": {},
										"PrivateIpAddressConfigs": {
											"locationName": "PrivateIpAddressConfig",
											"type": "list",
											"member": {
												"locationName": "PrivateIpAddressConfigSet",
												"type": "structure",
												"members": {
													"Primary": {
														"type": "boolean"
													},
													"PrivateIpAddress": {}
												}
											}
										},
										"SecondaryPrivateIpAddressCount": {
											"type": "integer"
										},
										"SubnetId": {}
									}
								}
							},
							"Placement": {
								"type": "structure",
								"members": {
									"AvailabilityZone": {},
									"GroupName": {}
								}
							},
							"RamdiskId": {},
							"SecurityGroupIds": {
								"shape": "Spx",
								"locationName": "SecurityGroupId"
							},
							"SubnetId": {},
							"UserData": {}
						}
					},
					"ScheduledInstanceId": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"InstanceIdSet": {
						"locationName": "instanceIdSet",
						"type": "list",
						"member": {
							"locationName": "item"
						}
					}
				}
			}
		},
		"StartInstances": {
			"input": {
				"type": "structure",
				"required": [
					"InstanceIds"
				],
				"members": {
					"InstanceIds": {
						"shape": "Sa0",
						"locationName": "InstanceId"
					},
					"AdditionalInfo": {
						"locationName": "additionalInfo"
					},
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"StartingInstances": {
						"shape": "Sq8",
						"locationName": "instancesSet"
					}
				}
			}
		},
		"StopInstances": {
			"input": {
				"type": "structure",
				"required": [
					"InstanceIds"
				],
				"members": {
					"InstanceIds": {
						"shape": "Sa0",
						"locationName": "InstanceId"
					},
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					},
					"Force": {
						"locationName": "force",
						"type": "boolean"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"StoppingInstances": {
						"shape": "Sq8",
						"locationName": "instancesSet"
					}
				}
			}
		},
		"TerminateInstances": {
			"input": {
				"type": "structure",
				"required": [
					"InstanceIds"
				],
				"members": {
					"InstanceIds": {
						"shape": "Sa0",
						"locationName": "InstanceId"
					},
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"TerminatingInstances": {
						"shape": "Sq8",
						"locationName": "instancesSet"
					}
				}
			}
		},
		"UnassignIpv6Addresses": {
			"input": {
				"type": "structure",
				"required": [
					"Ipv6Addresses",
					"NetworkInterfaceId"
				],
				"members": {
					"Ipv6Addresses": {
						"shape": "Sv",
						"locationName": "ipv6Addresses"
					},
					"NetworkInterfaceId": {
						"locationName": "networkInterfaceId"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"NetworkInterfaceId": {
						"locationName": "networkInterfaceId"
					},
					"UnassignedIpv6Addresses": {
						"shape": "Sv",
						"locationName": "unassignedIpv6Addresses"
					}
				}
			}
		},
		"UnassignPrivateIpAddresses": {
			"input": {
				"type": "structure",
				"required": [
					"NetworkInterfaceId",
					"PrivateIpAddresses"
				],
				"members": {
					"NetworkInterfaceId": {
						"locationName": "networkInterfaceId"
					},
					"PrivateIpAddresses": {
						"shape": "Sy",
						"locationName": "privateIpAddress"
					}
				}
			}
		},
		"UnmonitorInstances": {
			"input": {
				"type": "structure",
				"required": [
					"InstanceIds"
				],
				"members": {
					"InstanceIds": {
						"shape": "Sa0",
						"locationName": "InstanceId"
					},
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"InstanceMonitorings": {
						"shape": "So7",
						"locationName": "instancesSet"
					}
				}
			}
		}
	},
	"shapes": {
		"S3": {
			"type": "list",
			"member": {
				"locationName": "ReservedInstanceId"
			}
		},
		"S5": {
			"type": "list",
			"member": {
				"locationName": "TargetConfigurationRequest",
				"type": "structure",
				"required": [
					"OfferingId"
				],
				"members": {
					"InstanceCount": {
						"type": "integer"
					},
					"OfferingId": {}
				}
			}
		},
		"Sb": {
			"type": "structure",
			"members": {
				"AccepterVpcInfo": {
					"shape": "Sc",
					"locationName": "accepterVpcInfo"
				},
				"ExpirationTime": {
					"locationName": "expirationTime",
					"type": "timestamp"
				},
				"RequesterVpcInfo": {
					"shape": "Sc",
					"locationName": "requesterVpcInfo"
				},
				"Status": {
					"locationName": "status",
					"type": "structure",
					"members": {
						"Code": {
							"locationName": "code"
						},
						"Message": {
							"locationName": "message"
						}
					}
				},
				"Tags": {
					"shape": "Sl",
					"locationName": "tagSet"
				},
				"VpcPeeringConnectionId": {
					"locationName": "vpcPeeringConnectionId"
				}
			}
		},
		"Sc": {
			"type": "structure",
			"members": {
				"CidrBlock": {
					"locationName": "cidrBlock"
				},
				"Ipv6CidrBlockSet": {
					"locationName": "ipv6CidrBlockSet",
					"type": "list",
					"member": {
						"locationName": "item",
						"type": "structure",
						"members": {
							"Ipv6CidrBlock": {
								"locationName": "ipv6CidrBlock"
							}
						}
					}
				},
				"CidrBlockSet": {
					"locationName": "cidrBlockSet",
					"type": "list",
					"member": {
						"locationName": "item",
						"type": "structure",
						"members": {
							"CidrBlock": {
								"locationName": "cidrBlock"
							}
						}
					}
				},
				"OwnerId": {
					"locationName": "ownerId"
				},
				"PeeringOptions": {
					"locationName": "peeringOptions",
					"type": "structure",
					"members": {
						"AllowDnsResolutionFromRemoteVpc": {
							"locationName": "allowDnsResolutionFromRemoteVpc",
							"type": "boolean"
						},
						"AllowEgressFromLocalClassicLinkToRemoteVpc": {
							"locationName": "allowEgressFromLocalClassicLinkToRemoteVpc",
							"type": "boolean"
						},
						"AllowEgressFromLocalVpcToRemoteClassicLink": {
							"locationName": "allowEgressFromLocalVpcToRemoteClassicLink",
							"type": "boolean"
						}
					}
				},
				"VpcId": {
					"locationName": "vpcId"
				}
			}
		},
		"Sl": {
			"type": "list",
			"member": {
				"locationName": "item",
				"type": "structure",
				"members": {
					"Key": {
						"locationName": "key"
					},
					"Value": {
						"locationName": "value"
					}
				}
			}
		},
		"St": {
			"type": "list",
			"member": {
				"locationName": "item"
			}
		},
		"Sv": {
			"type": "list",
			"member": {
				"locationName": "item"
			}
		},
		"Sy": {
			"type": "list",
			"member": {
				"locationName": "PrivateIpAddress"
			}
		},
		"S13": {
			"type": "structure",
			"members": {
				"Arn": {
					"locationName": "arn"
				},
				"Name": {
					"locationName": "name"
				}
			}
		},
		"S15": {
			"type": "structure",
			"members": {
				"AssociationId": {
					"locationName": "associationId"
				},
				"InstanceId": {
					"locationName": "instanceId"
				},
				"IamInstanceProfile": {
					"shape": "S16",
					"locationName": "iamInstanceProfile"
				},
				"State": {
					"locationName": "state"
				},
				"Timestamp": {
					"locationName": "timestamp",
					"type": "timestamp"
				}
			}
		},
		"S16": {
			"type": "structure",
			"members": {
				"Arn": {
					"locationName": "arn"
				},
				"Id": {
					"locationName": "id"
				}
			}
		},
		"S1c": {
			"type": "structure",
			"members": {
				"AssociationId": {
					"locationName": "associationId"
				},
				"Ipv6CidrBlock": {
					"locationName": "ipv6CidrBlock"
				},
				"Ipv6CidrBlockState": {
					"locationName": "ipv6CidrBlockState",
					"type": "structure",
					"members": {
						"State": {
							"locationName": "state"
						},
						"StatusMessage": {
							"locationName": "statusMessage"
						}
					}
				}
			}
		},
		"S1h": {
			"type": "structure",
			"members": {
				"AssociationId": {
					"locationName": "associationId"
				},
				"Ipv6CidrBlock": {
					"locationName": "ipv6CidrBlock"
				},
				"Ipv6CidrBlockState": {
					"shape": "S1i",
					"locationName": "ipv6CidrBlockState"
				}
			}
		},
		"S1i": {
			"type": "structure",
			"members": {
				"State": {
					"locationName": "state"
				},
				"StatusMessage": {
					"locationName": "statusMessage"
				}
			}
		},
		"S1k": {
			"type": "structure",
			"members": {
				"AssociationId": {
					"locationName": "associationId"
				},
				"CidrBlock": {
					"locationName": "cidrBlock"
				},
				"CidrBlockState": {
					"shape": "S1i",
					"locationName": "cidrBlockState"
				}
			}
		},
		"S1m": {
			"type": "list",
			"member": {
				"locationName": "groupId"
			}
		},
		"S1s": {
			"type": "structure",
			"members": {
				"AttachTime": {
					"locationName": "attachTime",
					"type": "timestamp"
				},
				"Device": {
					"locationName": "device"
				},
				"InstanceId": {
					"locationName": "instanceId"
				},
				"State": {
					"locationName": "status"
				},
				"VolumeId": {
					"locationName": "volumeId"
				},
				"DeleteOnTermination": {
					"locationName": "deleteOnTermination",
					"type": "boolean"
				}
			}
		},
		"S1w": {
			"type": "structure",
			"members": {
				"State": {
					"locationName": "state"
				},
				"VpcId": {
					"locationName": "vpcId"
				}
			}
		},
		"S1z": {
			"type": "list",
			"member": {
				"locationName": "item",
				"type": "structure",
				"members": {
					"FromPort": {
						"locationName": "fromPort",
						"type": "integer"
					},
					"IpProtocol": {
						"locationName": "ipProtocol"
					},
					"IpRanges": {
						"locationName": "ipRanges",
						"type": "list",
						"member": {
							"locationName": "item",
							"type": "structure",
							"members": {
								"CidrIp": {
									"locationName": "cidrIp"
								}
							}
						}
					},
					"Ipv6Ranges": {
						"locationName": "ipv6Ranges",
						"type": "list",
						"member": {
							"locationName": "item",
							"type": "structure",
							"members": {
								"CidrIpv6": {
									"locationName": "cidrIpv6"
								}
							}
						}
					},
					"PrefixListIds": {
						"locationName": "prefixListIds",
						"type": "list",
						"member": {
							"locationName": "item",
							"type": "structure",
							"members": {
								"PrefixListId": {
									"locationName": "prefixListId"
								}
							}
						}
					},
					"ToPort": {
						"locationName": "toPort",
						"type": "integer"
					},
					"UserIdGroupPairs": {
						"locationName": "groups",
						"type": "list",
						"member": {
							"shape": "S28",
							"locationName": "item"
						}
					}
				}
			}
		},
		"S28": {
			"type": "structure",
			"members": {
				"GroupId": {
					"locationName": "groupId"
				},
				"GroupName": {
					"locationName": "groupName"
				},
				"PeeringStatus": {
					"locationName": "peeringStatus"
				},
				"UserId": {
					"locationName": "userId"
				},
				"VpcId": {
					"locationName": "vpcId"
				},
				"VpcPeeringConnectionId": {
					"locationName": "vpcPeeringConnectionId"
				}
			}
		},
		"S2b": {
			"type": "structure",
			"members": {
				"S3": {
					"type": "structure",
					"members": {
						"AWSAccessKeyId": {},
						"Bucket": {
							"locationName": "bucket"
						},
						"Prefix": {
							"locationName": "prefix"
						},
						"UploadPolicy": {
							"locationName": "uploadPolicy",
							"type": "blob"
						},
						"UploadPolicySignature": {
							"locationName": "uploadPolicySignature"
						}
					}
				}
			}
		},
		"S2f": {
			"type": "structure",
			"members": {
				"BundleId": {
					"locationName": "bundleId"
				},
				"BundleTaskError": {
					"locationName": "error",
					"type": "structure",
					"members": {
						"Code": {
							"locationName": "code"
						},
						"Message": {
							"locationName": "message"
						}
					}
				},
				"InstanceId": {
					"locationName": "instanceId"
				},
				"Progress": {
					"locationName": "progress"
				},
				"StartTime": {
					"locationName": "startTime",
					"type": "timestamp"
				},
				"State": {
					"locationName": "state"
				},
				"Storage": {
					"shape": "S2b",
					"locationName": "storage"
				},
				"UpdateTime": {
					"locationName": "updateTime",
					"type": "timestamp"
				}
			}
		},
		"S2q": {
			"type": "list",
			"member": {
				"locationName": "item",
				"type": "structure",
				"members": {
					"ClientToken": {
						"locationName": "clientToken"
					},
					"CreateDate": {
						"locationName": "createDate",
						"type": "timestamp"
					},
					"InstanceCounts": {
						"locationName": "instanceCounts",
						"type": "list",
						"member": {
							"locationName": "item",
							"type": "structure",
							"members": {
								"InstanceCount": {
									"locationName": "instanceCount",
									"type": "integer"
								},
								"State": {
									"locationName": "state"
								}
							}
						}
					},
					"PriceSchedules": {
						"locationName": "priceSchedules",
						"type": "list",
						"member": {
							"locationName": "item",
							"type": "structure",
							"members": {
								"Active": {
									"locationName": "active",
									"type": "boolean"
								},
								"CurrencyCode": {
									"locationName": "currencyCode"
								},
								"Price": {
									"locationName": "price",
									"type": "double"
								},
								"Term": {
									"locationName": "term",
									"type": "long"
								}
							}
						}
					},
					"ReservedInstancesId": {
						"locationName": "reservedInstancesId"
					},
					"ReservedInstancesListingId": {
						"locationName": "reservedInstancesListingId"
					},
					"Status": {
						"locationName": "status"
					},
					"StatusMessage": {
						"locationName": "statusMessage"
					},
					"Tags": {
						"shape": "Sl",
						"locationName": "tagSet"
					},
					"UpdateDate": {
						"locationName": "updateDate",
						"type": "timestamp"
					}
				}
			}
		},
		"S32": {
			"type": "list",
			"member": {
				"locationName": "item"
			}
		},
		"S3c": {
			"type": "list",
			"member": {
				"locationName": "SpotInstanceRequestId"
			}
		},
		"S3q": {
			"type": "structure",
			"members": {
				"BgpAsn": {
					"locationName": "bgpAsn"
				},
				"CustomerGatewayId": {
					"locationName": "customerGatewayId"
				},
				"IpAddress": {
					"locationName": "ipAddress"
				},
				"State": {
					"locationName": "state"
				},
				"Type": {
					"locationName": "type"
				},
				"Tags": {
					"shape": "Sl",
					"locationName": "tagSet"
				}
			}
		},
		"S3t": {
			"type": "structure",
			"members": {
				"CidrBlock": {
					"locationName": "cidrBlock"
				},
				"DhcpOptionsId": {
					"locationName": "dhcpOptionsId"
				},
				"State": {
					"locationName": "state"
				},
				"VpcId": {
					"locationName": "vpcId"
				},
				"InstanceTenancy": {
					"locationName": "instanceTenancy"
				},
				"Ipv6CidrBlockAssociationSet": {
					"locationName": "ipv6CidrBlockAssociationSet",
					"type": "list",
					"member": {
						"shape": "S1h",
						"locationName": "item"
					}
				},
				"CidrBlockAssociationSet": {
					"locationName": "cidrBlockAssociationSet",
					"type": "list",
					"member": {
						"shape": "S1k",
						"locationName": "item"
					}
				},
				"IsDefault": {
					"locationName": "isDefault",
					"type": "boolean"
				},
				"Tags": {
					"shape": "Sl",
					"locationName": "tagSet"
				}
			}
		},
		"S42": {
			"type": "structure",
			"members": {
				"DhcpConfigurations": {
					"locationName": "dhcpConfigurationSet",
					"type": "list",
					"member": {
						"locationName": "item",
						"type": "structure",
						"members": {
							"Key": {
								"locationName": "key"
							},
							"Values": {
								"locationName": "valueSet",
								"type": "list",
								"member": {
									"shape": "S46",
									"locationName": "item"
								}
							}
						}
					}
				},
				"DhcpOptionsId": {
					"locationName": "dhcpOptionsId"
				},
				"Tags": {
					"shape": "Sl",
					"locationName": "tagSet"
				}
			}
		},
		"S46": {
			"type": "structure",
			"members": {
				"Value": {
					"locationName": "value"
				}
			}
		},
		"S49": {
			"type": "structure",
			"members": {
				"Attachments": {
					"shape": "S4a",
					"locationName": "attachmentSet"
				},
				"EgressOnlyInternetGatewayId": {
					"locationName": "egressOnlyInternetGatewayId"
				}
			}
		},
		"S4a": {
			"type": "list",
			"member": {
				"locationName": "item",
				"type": "structure",
				"members": {
					"State": {
						"locationName": "state"
					},
					"VpcId": {
						"locationName": "vpcId"
					}
				}
			}
		},
		"S4h": {
			"type": "list",
			"member": {
				"shape": "S4i",
				"locationName": "item"
			}
		},
		"S4i": {
			"type": "structure",
			"required": [
				"Error"
			],
			"members": {
				"Error": {
					"locationName": "error",
					"type": "structure",
					"required": [
						"Code",
						"Message"
					],
					"members": {
						"Code": {
							"locationName": "code"
						},
						"Message": {
							"locationName": "message"
						}
					}
				},
				"ResourceId": {
					"locationName": "resourceId"
				}
			}
		},
		"S4l": {
			"type": "structure",
			"members": {
				"Bucket": {},
				"Key": {}
			}
		},
		"S4o": {
			"type": "list",
			"member": {
				"shape": "S4p",
				"locationName": "BlockDeviceMapping"
			}
		},
		"S4p": {
			"type": "structure",
			"members": {
				"DeviceName": {
					"locationName": "deviceName"
				},
				"VirtualName": {
					"locationName": "virtualName"
				},
				"Ebs": {
					"locationName": "ebs",
					"type": "structure",
					"members": {
						"Encrypted": {
							"locationName": "encrypted",
							"type": "boolean"
						},
						"DeleteOnTermination": {
							"locationName": "deleteOnTermination",
							"type": "boolean"
						},
						"Iops": {
							"locationName": "iops",
							"type": "integer"
						},
						"SnapshotId": {
							"locationName": "snapshotId"
						},
						"VolumeSize": {
							"locationName": "volumeSize",
							"type": "integer"
						},
						"VolumeType": {
							"locationName": "volumeType"
						}
					}
				},
				"NoDevice": {
					"locationName": "noDevice"
				}
			}
		},
		"S4z": {
			"type": "structure",
			"members": {
				"Description": {
					"locationName": "description"
				},
				"ExportTaskId": {
					"locationName": "exportTaskId"
				},
				"ExportToS3Task": {
					"locationName": "exportToS3",
					"type": "structure",
					"members": {
						"ContainerFormat": {
							"locationName": "containerFormat"
						},
						"DiskImageFormat": {
							"locationName": "diskImageFormat"
						},
						"S3Bucket": {
							"locationName": "s3Bucket"
						},
						"S3Key": {
							"locationName": "s3Key"
						}
					}
				},
				"InstanceExportDetails": {
					"locationName": "instanceExport",
					"type": "structure",
					"members": {
						"InstanceId": {
							"locationName": "instanceId"
						},
						"TargetEnvironment": {
							"locationName": "targetEnvironment"
						}
					}
				},
				"State": {
					"locationName": "state"
				},
				"StatusMessage": {
					"locationName": "statusMessage"
				}
			}
		},
		"S55": {
			"type": "structure",
			"members": {
				"Attachments": {
					"shape": "S4a",
					"locationName": "attachmentSet"
				},
				"InternetGatewayId": {
					"locationName": "internetGatewayId"
				},
				"Tags": {
					"shape": "Sl",
					"locationName": "tagSet"
				}
			}
		},
		"S5a": {
			"type": "structure",
			"members": {
				"CreateTime": {
					"locationName": "createTime",
					"type": "timestamp"
				},
				"DeleteTime": {
					"locationName": "deleteTime",
					"type": "timestamp"
				},
				"FailureCode": {
					"locationName": "failureCode"
				},
				"FailureMessage": {
					"locationName": "failureMessage"
				},
				"NatGatewayAddresses": {
					"locationName": "natGatewayAddressSet",
					"type": "list",
					"member": {
						"locationName": "item",
						"type": "structure",
						"members": {
							"AllocationId": {
								"locationName": "allocationId"
							},
							"NetworkInterfaceId": {
								"locationName": "networkInterfaceId"
							},
							"PrivateIp": {
								"locationName": "privateIp"
							},
							"PublicIp": {
								"locationName": "publicIp"
							}
						}
					}
				},
				"NatGatewayId": {
					"locationName": "natGatewayId"
				},
				"ProvisionedBandwidth": {
					"locationName": "provisionedBandwidth",
					"type": "structure",
					"members": {
						"ProvisionTime": {
							"locationName": "provisionTime",
							"type": "timestamp"
						},
						"Provisioned": {
							"locationName": "provisioned"
						},
						"RequestTime": {
							"locationName": "requestTime",
							"type": "timestamp"
						},
						"Requested": {
							"locationName": "requested"
						},
						"Status": {
							"locationName": "status"
						}
					}
				},
				"State": {
					"locationName": "state"
				},
				"SubnetId": {
					"locationName": "subnetId"
				},
				"VpcId": {
					"locationName": "vpcId"
				}
			}
		},
		"S5h": {
			"type": "structure",
			"members": {
				"Associations": {
					"locationName": "associationSet",
					"type": "list",
					"member": {
						"locationName": "item",
						"type": "structure",
						"members": {
							"NetworkAclAssociationId": {
								"locationName": "networkAclAssociationId"
							},
							"NetworkAclId": {
								"locationName": "networkAclId"
							},
							"SubnetId": {
								"locationName": "subnetId"
							}
						}
					}
				},
				"Entries": {
					"locationName": "entrySet",
					"type": "list",
					"member": {
						"locationName": "item",
						"type": "structure",
						"members": {
							"CidrBlock": {
								"locationName": "cidrBlock"
							},
							"Egress": {
								"locationName": "egress",
								"type": "boolean"
							},
							"IcmpTypeCode": {
								"shape": "S5m",
								"locationName": "icmpTypeCode"
							},
							"Ipv6CidrBlock": {
								"locationName": "ipv6CidrBlock"
							},
							"PortRange": {
								"shape": "S5n",
								"locationName": "portRange"
							},
							"Protocol": {
								"locationName": "protocol"
							},
							"RuleAction": {
								"locationName": "ruleAction"
							},
							"RuleNumber": {
								"locationName": "ruleNumber",
								"type": "integer"
							}
						}
					}
				},
				"IsDefault": {
					"locationName": "default",
					"type": "boolean"
				},
				"NetworkAclId": {
					"locationName": "networkAclId"
				},
				"Tags": {
					"shape": "Sl",
					"locationName": "tagSet"
				},
				"VpcId": {
					"locationName": "vpcId"
				}
			}
		},
		"S5m": {
			"type": "structure",
			"members": {
				"Code": {
					"locationName": "code",
					"type": "integer"
				},
				"Type": {
					"locationName": "type",
					"type": "integer"
				}
			}
		},
		"S5n": {
			"type": "structure",
			"members": {
				"From": {
					"locationName": "from",
					"type": "integer"
				},
				"To": {
					"locationName": "to",
					"type": "integer"
				}
			}
		},
		"S5r": {
			"type": "list",
			"member": {
				"locationName": "SecurityGroupId"
			}
		},
		"S5s": {
			"type": "list",
			"member": {
				"locationName": "item",
				"type": "structure",
				"members": {
					"Ipv6Address": {
						"locationName": "ipv6Address"
					}
				}
			}
		},
		"S5u": {
			"type": "list",
			"member": {
				"locationName": "item",
				"type": "structure",
				"required": [
					"PrivateIpAddress"
				],
				"members": {
					"Primary": {
						"locationName": "primary",
						"type": "boolean"
					},
					"PrivateIpAddress": {
						"locationName": "privateIpAddress"
					}
				}
			}
		},
		"S5x": {
			"type": "structure",
			"members": {
				"Association": {
					"shape": "S5y",
					"locationName": "association"
				},
				"Attachment": {
					"shape": "S5z",
					"locationName": "attachment"
				},
				"AvailabilityZone": {
					"locationName": "availabilityZone"
				},
				"Description": {
					"locationName": "description"
				},
				"Groups": {
					"shape": "S60",
					"locationName": "groupSet"
				},
				"InterfaceType": {
					"locationName": "interfaceType"
				},
				"Ipv6Addresses": {
					"locationName": "ipv6AddressesSet",
					"type": "list",
					"member": {
						"locationName": "item",
						"type": "structure",
						"members": {
							"Ipv6Address": {
								"locationName": "ipv6Address"
							}
						}
					}
				},
				"MacAddress": {
					"locationName": "macAddress"
				},
				"NetworkInterfaceId": {
					"locationName": "networkInterfaceId"
				},
				"OwnerId": {
					"locationName": "ownerId"
				},
				"PrivateDnsName": {
					"locationName": "privateDnsName"
				},
				"PrivateIpAddress": {
					"locationName": "privateIpAddress"
				},
				"PrivateIpAddresses": {
					"locationName": "privateIpAddressesSet",
					"type": "list",
					"member": {
						"locationName": "item",
						"type": "structure",
						"members": {
							"Association": {
								"shape": "S5y",
								"locationName": "association"
							},
							"Primary": {
								"locationName": "primary",
								"type": "boolean"
							},
							"PrivateDnsName": {
								"locationName": "privateDnsName"
							},
							"PrivateIpAddress": {
								"locationName": "privateIpAddress"
							}
						}
					}
				},
				"RequesterId": {
					"locationName": "requesterId"
				},
				"RequesterManaged": {
					"locationName": "requesterManaged",
					"type": "boolean"
				},
				"SourceDestCheck": {
					"locationName": "sourceDestCheck",
					"type": "boolean"
				},
				"Status": {
					"locationName": "status"
				},
				"SubnetId": {
					"locationName": "subnetId"
				},
				"TagSet": {
					"shape": "Sl",
					"locationName": "tagSet"
				},
				"VpcId": {
					"locationName": "vpcId"
				}
			}
		},
		"S5y": {
			"type": "structure",
			"members": {
				"AllocationId": {
					"locationName": "allocationId"
				},
				"AssociationId": {
					"locationName": "associationId"
				},
				"IpOwnerId": {
					"locationName": "ipOwnerId"
				},
				"PublicDnsName": {
					"locationName": "publicDnsName"
				},
				"PublicIp": {
					"locationName": "publicIp"
				}
			}
		},
		"S5z": {
			"type": "structure",
			"members": {
				"AttachTime": {
					"locationName": "attachTime",
					"type": "timestamp"
				},
				"AttachmentId": {
					"locationName": "attachmentId"
				},
				"DeleteOnTermination": {
					"locationName": "deleteOnTermination",
					"type": "boolean"
				},
				"DeviceIndex": {
					"locationName": "deviceIndex",
					"type": "integer"
				},
				"InstanceId": {
					"locationName": "instanceId"
				},
				"InstanceOwnerId": {
					"locationName": "instanceOwnerId"
				},
				"Status": {
					"locationName": "status"
				}
			}
		},
		"S60": {
			"type": "list",
			"member": {
				"locationName": "item",
				"type": "structure",
				"members": {
					"GroupName": {
						"locationName": "groupName"
					},
					"GroupId": {
						"locationName": "groupId"
					}
				}
			}
		},
		"S6b": {
			"type": "structure",
			"members": {
				"NetworkInterfacePermissionId": {
					"locationName": "networkInterfacePermissionId"
				},
				"NetworkInterfaceId": {
					"locationName": "networkInterfaceId"
				},
				"AwsAccountId": {
					"locationName": "awsAccountId"
				},
				"AwsService": {
					"locationName": "awsService"
				},
				"Permission": {
					"locationName": "permission"
				},
				"PermissionState": {
					"locationName": "permissionState",
					"type": "structure",
					"members": {
						"State": {
							"locationName": "state"
						},
						"StatusMessage": {
							"locationName": "statusMessage"
						}
					}
				}
			}
		},
		"S6o": {
			"type": "structure",
			"members": {
				"Associations": {
					"locationName": "associationSet",
					"type": "list",
					"member": {
						"locationName": "item",
						"type": "structure",
						"members": {
							"Main": {
								"locationName": "main",
								"type": "boolean"
							},
							"RouteTableAssociationId": {
								"locationName": "routeTableAssociationId"
							},
							"RouteTableId": {
								"locationName": "routeTableId"
							},
							"SubnetId": {
								"locationName": "subnetId"
							}
						}
					}
				},
				"PropagatingVgws": {
					"locationName": "propagatingVgwSet",
					"type": "list",
					"member": {
						"locationName": "item",
						"type": "structure",
						"members": {
							"GatewayId": {
								"locationName": "gatewayId"
							}
						}
					}
				},
				"RouteTableId": {
					"locationName": "routeTableId"
				},
				"Routes": {
					"locationName": "routeSet",
					"type": "list",
					"member": {
						"locationName": "item",
						"type": "structure",
						"members": {
							"DestinationCidrBlock": {
								"locationName": "destinationCidrBlock"
							},
							"DestinationIpv6CidrBlock": {
								"locationName": "destinationIpv6CidrBlock"
							},
							"DestinationPrefixListId": {
								"locationName": "destinationPrefixListId"
							},
							"EgressOnlyInternetGatewayId": {
								"locationName": "egressOnlyInternetGatewayId"
							},
							"GatewayId": {
								"locationName": "gatewayId"
							},
							"InstanceId": {
								"locationName": "instanceId"
							},
							"InstanceOwnerId": {
								"locationName": "instanceOwnerId"
							},
							"NatGatewayId": {
								"locationName": "natGatewayId"
							},
							"NetworkInterfaceId": {
								"locationName": "networkInterfaceId"
							},
							"Origin": {
								"locationName": "origin"
							},
							"State": {
								"locationName": "state"
							},
							"VpcPeeringConnectionId": {
								"locationName": "vpcPeeringConnectionId"
							}
						}
					}
				},
				"Tags": {
					"shape": "Sl",
					"locationName": "tagSet"
				},
				"VpcId": {
					"locationName": "vpcId"
				}
			}
		},
		"S70": {
			"type": "structure",
			"members": {
				"DataEncryptionKeyId": {
					"locationName": "dataEncryptionKeyId"
				},
				"Description": {
					"locationName": "description"
				},
				"Encrypted": {
					"locationName": "encrypted",
					"type": "boolean"
				},
				"KmsKeyId": {
					"locationName": "kmsKeyId"
				},
				"OwnerId": {
					"locationName": "ownerId"
				},
				"Progress": {
					"locationName": "progress"
				},
				"SnapshotId": {
					"locationName": "snapshotId"
				},
				"StartTime": {
					"locationName": "startTime",
					"type": "timestamp"
				},
				"State": {
					"locationName": "status"
				},
				"StateMessage": {
					"locationName": "statusMessage"
				},
				"VolumeId": {
					"locationName": "volumeId"
				},
				"VolumeSize": {
					"locationName": "volumeSize",
					"type": "integer"
				},
				"OwnerAlias": {
					"locationName": "ownerAlias"
				},
				"Tags": {
					"shape": "Sl",
					"locationName": "tagSet"
				}
			}
		},
		"S74": {
			"type": "structure",
			"members": {
				"Bucket": {
					"locationName": "bucket"
				},
				"Fault": {
					"shape": "S75",
					"locationName": "fault"
				},
				"OwnerId": {
					"locationName": "ownerId"
				},
				"Prefix": {
					"locationName": "prefix"
				},
				"State": {
					"locationName": "state"
				}
			}
		},
		"S75": {
			"type": "structure",
			"members": {
				"Code": {
					"locationName": "code"
				},
				"Message": {
					"locationName": "message"
				}
			}
		},
		"S79": {
			"type": "structure",
			"members": {
				"AvailabilityZone": {
					"locationName": "availabilityZone"
				},
				"AvailableIpAddressCount": {
					"locationName": "availableIpAddressCount",
					"type": "integer"
				},
				"CidrBlock": {
					"locationName": "cidrBlock"
				},
				"DefaultForAz": {
					"locationName": "defaultForAz",
					"type": "boolean"
				},
				"MapPublicIpOnLaunch": {
					"locationName": "mapPublicIpOnLaunch",
					"type": "boolean"
				},
				"State": {
					"locationName": "state"
				},
				"SubnetId": {
					"locationName": "subnetId"
				},
				"VpcId": {
					"locationName": "vpcId"
				},
				"AssignIpv6AddressOnCreation": {
					"locationName": "assignIpv6AddressOnCreation",
					"type": "boolean"
				},
				"Ipv6CidrBlockAssociationSet": {
					"locationName": "ipv6CidrBlockAssociationSet",
					"type": "list",
					"member": {
						"shape": "S1c",
						"locationName": "item"
					}
				},
				"Tags": {
					"shape": "Sl",
					"locationName": "tagSet"
				}
			}
		},
		"S7d": {
			"type": "list",
			"member": {}
		},
		"S7f": {
			"type": "list",
			"member": {
				"locationName": "item",
				"type": "structure",
				"members": {
					"ResourceType": {
						"locationName": "resourceType"
					},
					"Tags": {
						"shape": "Sl",
						"locationName": "Tag"
					}
				}
			}
		},
		"S7i": {
			"type": "structure",
			"members": {
				"Attachments": {
					"locationName": "attachmentSet",
					"type": "list",
					"member": {
						"shape": "S1s",
						"locationName": "item"
					}
				},
				"AvailabilityZone": {
					"locationName": "availabilityZone"
				},
				"CreateTime": {
					"locationName": "createTime",
					"type": "timestamp"
				},
				"Encrypted": {
					"locationName": "encrypted",
					"type": "boolean"
				},
				"KmsKeyId": {
					"locationName": "kmsKeyId"
				},
				"Size": {
					"locationName": "size",
					"type": "integer"
				},
				"SnapshotId": {
					"locationName": "snapshotId"
				},
				"State": {
					"locationName": "status"
				},
				"VolumeId": {
					"locationName": "volumeId"
				},
				"Iops": {
					"locationName": "iops",
					"type": "integer"
				},
				"Tags": {
					"shape": "Sl",
					"locationName": "tagSet"
				},
				"VolumeType": {
					"locationName": "volumeType"
				}
			}
		},
		"S7p": {
			"type": "structure",
			"members": {
				"CreationTimestamp": {
					"locationName": "creationTimestamp",
					"type": "timestamp"
				},
				"PolicyDocument": {
					"locationName": "policyDocument"
				},
				"RouteTableIds": {
					"shape": "S32",
					"locationName": "routeTableIdSet"
				},
				"ServiceName": {
					"locationName": "serviceName"
				},
				"State": {
					"locationName": "state"
				},
				"VpcEndpointId": {
					"locationName": "vpcEndpointId"
				},
				"VpcId": {
					"locationName": "vpcId"
				}
			}
		},
		"S7w": {
			"type": "structure",
			"members": {
				"CustomerGatewayConfiguration": {
					"locationName": "customerGatewayConfiguration"
				},
				"CustomerGatewayId": {
					"locationName": "customerGatewayId"
				},
				"State": {
					"locationName": "state"
				},
				"Type": {
					"locationName": "type"
				},
				"VpnConnectionId": {
					"locationName": "vpnConnectionId"
				},
				"VpnGatewayId": {
					"locationName": "vpnGatewayId"
				},
				"Options": {
					"locationName": "options",
					"type": "structure",
					"members": {
						"StaticRoutesOnly": {
							"locationName": "staticRoutesOnly",
							"type": "boolean"
						}
					}
				},
				"Routes": {
					"locationName": "routes",
					"type": "list",
					"member": {
						"locationName": "item",
						"type": "structure",
						"members": {
							"DestinationCidrBlock": {
								"locationName": "destinationCidrBlock"
							},
							"Source": {
								"locationName": "source"
							},
							"State": {
								"locationName": "state"
							}
						}
					}
				},
				"Tags": {
					"shape": "Sl",
					"locationName": "tagSet"
				},
				"VgwTelemetry": {
					"locationName": "vgwTelemetry",
					"type": "list",
					"member": {
						"locationName": "item",
						"type": "structure",
						"members": {
							"AcceptedRouteCount": {
								"locationName": "acceptedRouteCount",
								"type": "integer"
							},
							"LastStatusChange": {
								"locationName": "lastStatusChange",
								"type": "timestamp"
							},
							"OutsideIpAddress": {
								"locationName": "outsideIpAddress"
							},
							"Status": {
								"locationName": "status"
							},
							"StatusMessage": {
								"locationName": "statusMessage"
							}
						}
					}
				}
			}
		},
		"S88": {
			"type": "structure",
			"members": {
				"AvailabilityZone": {
					"locationName": "availabilityZone"
				},
				"State": {
					"locationName": "state"
				},
				"Type": {
					"locationName": "type"
				},
				"VpcAttachments": {
					"locationName": "attachments",
					"type": "list",
					"member": {
						"shape": "S1w",
						"locationName": "item"
					}
				},
				"VpnGatewayId": {
					"locationName": "vpnGatewayId"
				},
				"Tags": {
					"shape": "Sl",
					"locationName": "tagSet"
				}
			}
		},
		"S9g": {
			"type": "list",
			"member": {
				"locationName": "Filter",
				"type": "structure",
				"members": {
					"Name": {},
					"Values": {
						"shape": "S32",
						"locationName": "Value"
					}
				}
			}
		},
		"Sa0": {
			"type": "list",
			"member": {
				"locationName": "InstanceId"
			}
		},
		"Sa8": {
			"type": "structure",
			"required": [
				"ConversionTaskId",
				"State"
			],
			"members": {
				"ConversionTaskId": {
					"locationName": "conversionTaskId"
				},
				"ExpirationTime": {
					"locationName": "expirationTime"
				},
				"ImportInstance": {
					"locationName": "importInstance",
					"type": "structure",
					"required": [
						"Volumes"
					],
					"members": {
						"Description": {
							"locationName": "description"
						},
						"InstanceId": {
							"locationName": "instanceId"
						},
						"Platform": {
							"locationName": "platform"
						},
						"Volumes": {
							"locationName": "volumes",
							"type": "list",
							"member": {
								"locationName": "item",
								"type": "structure",
								"required": [
									"AvailabilityZone",
									"BytesConverted",
									"Image",
									"Status",
									"Volume"
								],
								"members": {
									"AvailabilityZone": {
										"locationName": "availabilityZone"
									},
									"BytesConverted": {
										"locationName": "bytesConverted",
										"type": "long"
									},
									"Description": {
										"locationName": "description"
									},
									"Image": {
										"shape": "Sad",
										"locationName": "image"
									},
									"Status": {
										"locationName": "status"
									},
									"StatusMessage": {
										"locationName": "statusMessage"
									},
									"Volume": {
										"shape": "Sae",
										"locationName": "volume"
									}
								}
							}
						}
					}
				},
				"ImportVolume": {
					"locationName": "importVolume",
					"type": "structure",
					"required": [
						"AvailabilityZone",
						"BytesConverted",
						"Image",
						"Volume"
					],
					"members": {
						"AvailabilityZone": {
							"locationName": "availabilityZone"
						},
						"BytesConverted": {
							"locationName": "bytesConverted",
							"type": "long"
						},
						"Description": {
							"locationName": "description"
						},
						"Image": {
							"shape": "Sad",
							"locationName": "image"
						},
						"Volume": {
							"shape": "Sae",
							"locationName": "volume"
						}
					}
				},
				"State": {
					"locationName": "state"
				},
				"StatusMessage": {
					"locationName": "statusMessage"
				},
				"Tags": {
					"shape": "Sl",
					"locationName": "tagSet"
				}
			}
		},
		"Sad": {
			"type": "structure",
			"required": [
				"Format",
				"ImportManifestUrl",
				"Size"
			],
			"members": {
				"Checksum": {
					"locationName": "checksum"
				},
				"Format": {
					"locationName": "format"
				},
				"ImportManifestUrl": {
					"locationName": "importManifestUrl"
				},
				"Size": {
					"locationName": "size",
					"type": "long"
				}
			}
		},
		"Sae": {
			"type": "structure",
			"required": [
				"Id"
			],
			"members": {
				"Id": {
					"locationName": "id"
				},
				"Size": {
					"locationName": "size",
					"type": "long"
				}
			}
		},
		"Sbb": {
			"type": "list",
			"member": {
				"locationName": "Owner"
			}
		},
		"Sbk": {
			"type": "list",
			"member": {
				"locationName": "item",
				"type": "structure",
				"members": {
					"ProductCodeId": {
						"locationName": "productCode"
					},
					"ProductCodeType": {
						"locationName": "type"
					}
				}
			}
		},
		"Sbx": {
			"type": "list",
			"member": {
				"locationName": "item"
			}
		},
		"Sc0": {
			"type": "list",
			"member": {
				"locationName": "item"
			}
		},
		"Sch": {
			"type": "list",
			"member": {
				"locationName": "item",
				"type": "structure",
				"members": {
					"Deadline": {
						"locationName": "deadline",
						"type": "timestamp"
					},
					"Resource": {
						"locationName": "resource"
					},
					"UseLongIds": {
						"locationName": "useLongIds",
						"type": "boolean"
					}
				}
			}
		},
		"Sco": {
			"type": "list",
			"member": {
				"shape": "S4p",
				"locationName": "item"
			}
		},
		"Scp": {
			"type": "list",
			"member": {
				"locationName": "item",
				"type": "structure",
				"members": {
					"Group": {
						"locationName": "group"
					},
					"UserId": {
						"locationName": "userId"
					}
				}
			}
		},
		"Sd3": {
			"type": "structure",
			"members": {
				"Code": {
					"locationName": "code"
				},
				"Message": {
					"locationName": "message"
				}
			}
		},
		"Sd6": {
			"type": "list",
			"member": {
				"locationName": "ImportTaskId"
			}
		},
		"Sda": {
			"type": "list",
			"member": {
				"locationName": "item",
				"type": "structure",
				"members": {
					"Description": {
						"locationName": "description"
					},
					"DeviceName": {
						"locationName": "deviceName"
					},
					"DiskImageSize": {
						"locationName": "diskImageSize",
						"type": "double"
					},
					"Format": {
						"locationName": "format"
					},
					"Progress": {
						"locationName": "progress"
					},
					"SnapshotId": {
						"locationName": "snapshotId"
					},
					"Status": {
						"locationName": "status"
					},
					"StatusMessage": {
						"locationName": "statusMessage"
					},
					"Url": {
						"locationName": "url"
					},
					"UserBucket": {
						"shape": "Sdc",
						"locationName": "userBucket"
					}
				}
			}
		},
		"Sdc": {
			"type": "structure",
			"members": {
				"S3Bucket": {
					"locationName": "s3Bucket"
				},
				"S3Key": {
					"locationName": "s3Key"
				}
			}
		},
		"Sdh": {
			"type": "structure",
			"members": {
				"Description": {
					"locationName": "description"
				},
				"DiskImageSize": {
					"locationName": "diskImageSize",
					"type": "double"
				},
				"Format": {
					"locationName": "format"
				},
				"Progress": {
					"locationName": "progress"
				},
				"SnapshotId": {
					"locationName": "snapshotId"
				},
				"Status": {
					"locationName": "status"
				},
				"StatusMessage": {
					"locationName": "statusMessage"
				},
				"Url": {
					"locationName": "url"
				},
				"UserBucket": {
					"shape": "Sdc",
					"locationName": "userBucket"
				}
			}
		},
		"Sdl": {
			"type": "list",
			"member": {
				"locationName": "item",
				"type": "structure",
				"members": {
					"DeviceName": {
						"locationName": "deviceName"
					},
					"Ebs": {
						"locationName": "ebs",
						"type": "structure",
						"members": {
							"AttachTime": {
								"locationName": "attachTime",
								"type": "timestamp"
							},
							"DeleteOnTermination": {
								"locationName": "deleteOnTermination",
								"type": "boolean"
							},
							"Status": {
								"locationName": "status"
							},
							"VolumeId": {
								"locationName": "volumeId"
							}
						}
					}
				}
			}
		},
		"Sdo": {
			"type": "structure",
			"members": {
				"Value": {
					"locationName": "value",
					"type": "boolean"
				}
			}
		},
		"Sdw": {
			"type": "structure",
			"members": {
				"Code": {
					"locationName": "code",
					"type": "integer"
				},
				"Name": {
					"locationName": "name"
				}
			}
		},
		"Sdy": {
			"type": "structure",
			"members": {
				"Details": {
					"locationName": "details",
					"type": "list",
					"member": {
						"locationName": "item",
						"type": "structure",
						"members": {
							"ImpairedSince": {
								"locationName": "impairedSince",
								"type": "timestamp"
							},
							"Name": {
								"locationName": "name"
							},
							"Status": {
								"locationName": "status"
							}
						}
					}
				},
				"Status": {
					"locationName": "status"
				}
			}
		},
		"Se7": {
			"type": "structure",
			"members": {
				"Groups": {
					"shape": "S60",
					"locationName": "groupSet"
				},
				"Instances": {
					"locationName": "instancesSet",
					"type": "list",
					"member": {
						"locationName": "item",
						"type": "structure",
						"members": {
							"AmiLaunchIndex": {
								"locationName": "amiLaunchIndex",
								"type": "integer"
							},
							"ImageId": {
								"locationName": "imageId"
							},
							"InstanceId": {
								"locationName": "instanceId"
							},
							"InstanceType": {
								"locationName": "instanceType"
							},
							"KernelId": {
								"locationName": "kernelId"
							},
							"KeyName": {
								"locationName": "keyName"
							},
							"LaunchTime": {
								"locationName": "launchTime",
								"type": "timestamp"
							},
							"Monitoring": {
								"shape": "Seb",
								"locationName": "monitoring"
							},
							"Placement": {
								"shape": "Sed",
								"locationName": "placement"
							},
							"Platform": {
								"locationName": "platform"
							},
							"PrivateDnsName": {
								"locationName": "privateDnsName"
							},
							"PrivateIpAddress": {
								"locationName": "privateIpAddress"
							},
							"ProductCodes": {
								"shape": "Sbk",
								"locationName": "productCodes"
							},
							"PublicDnsName": {
								"locationName": "dnsName"
							},
							"PublicIpAddress": {
								"locationName": "ipAddress"
							},
							"RamdiskId": {
								"locationName": "ramdiskId"
							},
							"State": {
								"shape": "Sdw",
								"locationName": "instanceState"
							},
							"StateTransitionReason": {
								"locationName": "reason"
							},
							"SubnetId": {
								"locationName": "subnetId"
							},
							"VpcId": {
								"locationName": "vpcId"
							},
							"Architecture": {
								"locationName": "architecture"
							},
							"BlockDeviceMappings": {
								"shape": "Sdl",
								"locationName": "blockDeviceMapping"
							},
							"ClientToken": {
								"locationName": "clientToken"
							},
							"EbsOptimized": {
								"locationName": "ebsOptimized",
								"type": "boolean"
							},
							"EnaSupport": {
								"locationName": "enaSupport",
								"type": "boolean"
							},
							"Hypervisor": {
								"locationName": "hypervisor"
							},
							"IamInstanceProfile": {
								"shape": "S16",
								"locationName": "iamInstanceProfile"
							},
							"InstanceLifecycle": {
								"locationName": "instanceLifecycle"
							},
							"ElasticGpuAssociations": {
								"locationName": "elasticGpuAssociationSet",
								"type": "list",
								"member": {
									"locationName": "item",
									"type": "structure",
									"members": {
										"ElasticGpuId": {
											"locationName": "elasticGpuId"
										},
										"ElasticGpuAssociationId": {
											"locationName": "elasticGpuAssociationId"
										},
										"ElasticGpuAssociationState": {
											"locationName": "elasticGpuAssociationState"
										},
										"ElasticGpuAssociationTime": {
											"locationName": "elasticGpuAssociationTime"
										}
									}
								}
							},
							"NetworkInterfaces": {
								"locationName": "networkInterfaceSet",
								"type": "list",
								"member": {
									"locationName": "item",
									"type": "structure",
									"members": {
										"Association": {
											"shape": "Sej",
											"locationName": "association"
										},
										"Attachment": {
											"locationName": "attachment",
											"type": "structure",
											"members": {
												"AttachTime": {
													"locationName": "attachTime",
													"type": "timestamp"
												},
												"AttachmentId": {
													"locationName": "attachmentId"
												},
												"DeleteOnTermination": {
													"locationName": "deleteOnTermination",
													"type": "boolean"
												},
												"DeviceIndex": {
													"locationName": "deviceIndex",
													"type": "integer"
												},
												"Status": {
													"locationName": "status"
												}
											}
										},
										"Description": {
											"locationName": "description"
										},
										"Groups": {
											"shape": "S60",
											"locationName": "groupSet"
										},
										"Ipv6Addresses": {
											"shape": "S5s",
											"locationName": "ipv6AddressesSet"
										},
										"MacAddress": {
											"locationName": "macAddress"
										},
										"NetworkInterfaceId": {
											"locationName": "networkInterfaceId"
										},
										"OwnerId": {
											"locationName": "ownerId"
										},
										"PrivateDnsName": {
											"locationName": "privateDnsName"
										},
										"PrivateIpAddress": {
											"locationName": "privateIpAddress"
										},
										"PrivateIpAddresses": {
											"locationName": "privateIpAddressesSet",
											"type": "list",
											"member": {
												"locationName": "item",
												"type": "structure",
												"members": {
													"Association": {
														"shape": "Sej",
														"locationName": "association"
													},
													"Primary": {
														"locationName": "primary",
														"type": "boolean"
													},
													"PrivateDnsName": {
														"locationName": "privateDnsName"
													},
													"PrivateIpAddress": {
														"locationName": "privateIpAddress"
													}
												}
											}
										},
										"SourceDestCheck": {
											"locationName": "sourceDestCheck",
											"type": "boolean"
										},
										"Status": {
											"locationName": "status"
										},
										"SubnetId": {
											"locationName": "subnetId"
										},
										"VpcId": {
											"locationName": "vpcId"
										}
									}
								}
							},
							"RootDeviceName": {
								"locationName": "rootDeviceName"
							},
							"RootDeviceType": {
								"locationName": "rootDeviceType"
							},
							"SecurityGroups": {
								"shape": "S60",
								"locationName": "groupSet"
							},
							"SourceDestCheck": {
								"locationName": "sourceDestCheck",
								"type": "boolean"
							},
							"SpotInstanceRequestId": {
								"locationName": "spotInstanceRequestId"
							},
							"SriovNetSupport": {
								"locationName": "sriovNetSupport"
							},
							"StateReason": {
								"shape": "Sd3",
								"locationName": "stateReason"
							},
							"Tags": {
								"shape": "Sl",
								"locationName": "tagSet"
							},
							"VirtualizationType": {
								"locationName": "virtualizationType"
							}
						}
					}
				},
				"OwnerId": {
					"locationName": "ownerId"
				},
				"RequesterId": {
					"locationName": "requesterId"
				},
				"ReservationId": {
					"locationName": "reservationId"
				}
			}
		},
		"Seb": {
			"type": "structure",
			"members": {
				"State": {
					"locationName": "state"
				}
			}
		},
		"Sed": {
			"type": "structure",
			"members": {
				"AvailabilityZone": {
					"locationName": "availabilityZone"
				},
				"Affinity": {
					"locationName": "affinity"
				},
				"GroupName": {
					"locationName": "groupName"
				},
				"HostId": {
					"locationName": "hostId"
				},
				"Tenancy": {
					"locationName": "tenancy"
				},
				"SpreadDomain": {
					"locationName": "spreadDomain"
				}
			}
		},
		"Sej": {
			"type": "structure",
			"members": {
				"IpOwnerId": {
					"locationName": "ipOwnerId"
				},
				"PublicDnsName": {
					"locationName": "publicDnsName"
				},
				"PublicIp": {
					"locationName": "publicIp"
				}
			}
		},
		"Sfy": {
			"type": "list",
			"member": {
				"locationName": "ReservedInstancesId"
			}
		},
		"Sg6": {
			"type": "list",
			"member": {
				"locationName": "item",
				"type": "structure",
				"members": {
					"Amount": {
						"locationName": "amount",
						"type": "double"
					},
					"Frequency": {
						"locationName": "frequency"
					}
				}
			}
		},
		"Sgj": {
			"type": "structure",
			"members": {
				"AvailabilityZone": {
					"locationName": "availabilityZone"
				},
				"InstanceCount": {
					"locationName": "instanceCount",
					"type": "integer"
				},
				"InstanceType": {
					"locationName": "instanceType"
				},
				"Platform": {
					"locationName": "platform"
				},
				"Scope": {
					"locationName": "scope"
				}
			}
		},
		"Sh3": {
			"type": "structure",
			"members": {
				"Frequency": {
					"locationName": "frequency"
				},
				"Interval": {
					"locationName": "interval",
					"type": "integer"
				},
				"OccurrenceDaySet": {
					"locationName": "occurrenceDaySet",
					"type": "list",
					"member": {
						"locationName": "item",
						"type": "integer"
					}
				},
				"OccurrenceRelativeToEnd": {
					"locationName": "occurrenceRelativeToEnd",
					"type": "boolean"
				},
				"OccurrenceUnit": {
					"locationName": "occurrenceUnit"
				}
			}
		},
		"Sha": {
			"type": "structure",
			"members": {
				"AvailabilityZone": {
					"locationName": "availabilityZone"
				},
				"CreateDate": {
					"locationName": "createDate",
					"type": "timestamp"
				},
				"HourlyPrice": {
					"locationName": "hourlyPrice"
				},
				"InstanceCount": {
					"locationName": "instanceCount",
					"type": "integer"
				},
				"InstanceType": {
					"locationName": "instanceType"
				},
				"NetworkPlatform": {
					"locationName": "networkPlatform"
				},
				"NextSlotStartTime": {
					"locationName": "nextSlotStartTime",
					"type": "timestamp"
				},
				"Platform": {
					"locationName": "platform"
				},
				"PreviousSlotEndTime": {
					"locationName": "previousSlotEndTime",
					"type": "timestamp"
				},
				"Recurrence": {
					"shape": "Sh3",
					"locationName": "recurrence"
				},
				"ScheduledInstanceId": {
					"locationName": "scheduledInstanceId"
				},
				"SlotDurationInHours": {
					"locationName": "slotDurationInHours",
					"type": "integer"
				},
				"TermEndDate": {
					"locationName": "termEndDate",
					"type": "timestamp"
				},
				"TermStartDate": {
					"locationName": "termStartDate",
					"type": "timestamp"
				},
				"TotalScheduledInstanceHours": {
					"locationName": "totalScheduledInstanceHours",
					"type": "integer"
				}
			}
		},
		"Shh": {
			"type": "list",
			"member": {
				"locationName": "GroupName"
			}
		},
		"Sho": {
			"type": "list",
			"member": {
				"locationName": "item",
				"type": "structure",
				"members": {
					"Group": {
						"locationName": "group"
					},
					"UserId": {
						"locationName": "userId"
					}
				}
			}
		},
		"Sid": {
			"type": "structure",
			"required": [
				"IamFleetRole",
				"LaunchSpecifications",
				"SpotPrice",
				"TargetCapacity"
			],
			"members": {
				"AllocationStrategy": {
					"locationName": "allocationStrategy"
				},
				"ClientToken": {
					"locationName": "clientToken"
				},
				"ExcessCapacityTerminationPolicy": {
					"locationName": "excessCapacityTerminationPolicy"
				},
				"FulfilledCapacity": {
					"locationName": "fulfilledCapacity",
					"type": "double"
				},
				"IamFleetRole": {
					"locationName": "iamFleetRole"
				},
				"LaunchSpecifications": {
					"locationName": "launchSpecifications",
					"type": "list",
					"member": {
						"locationName": "item",
						"type": "structure",
						"members": {
							"SecurityGroups": {
								"shape": "S60",
								"locationName": "groupSet"
							},
							"AddressingType": {
								"locationName": "addressingType"
							},
							"BlockDeviceMappings": {
								"shape": "Sco",
								"locationName": "blockDeviceMapping"
							},
							"EbsOptimized": {
								"locationName": "ebsOptimized",
								"type": "boolean"
							},
							"IamInstanceProfile": {
								"shape": "S13",
								"locationName": "iamInstanceProfile"
							},
							"ImageId": {
								"locationName": "imageId"
							},
							"InstanceType": {
								"locationName": "instanceType"
							},
							"KernelId": {
								"locationName": "kernelId"
							},
							"KeyName": {
								"locationName": "keyName"
							},
							"Monitoring": {
								"locationName": "monitoring",
								"type": "structure",
								"members": {
									"Enabled": {
										"locationName": "enabled",
										"type": "boolean"
									}
								}
							},
							"NetworkInterfaces": {
								"shape": "Sij",
								"locationName": "networkInterfaceSet"
							},
							"Placement": {
								"shape": "Sil",
								"locationName": "placement"
							},
							"RamdiskId": {
								"locationName": "ramdiskId"
							},
							"SpotPrice": {
								"locationName": "spotPrice"
							},
							"SubnetId": {
								"locationName": "subnetId"
							},
							"UserData": {
								"locationName": "userData"
							},
							"WeightedCapacity": {
								"locationName": "weightedCapacity",
								"type": "double"
							},
							"TagSpecifications": {
								"locationName": "tagSpecificationSet",
								"type": "list",
								"member": {
									"locationName": "item",
									"type": "structure",
									"members": {
										"ResourceType": {
											"locationName": "resourceType"
										},
										"Tags": {
											"shape": "Sl",
											"locationName": "tag"
										}
									}
								}
							}
						}
					}
				},
				"SpotPrice": {
					"locationName": "spotPrice"
				},
				"TargetCapacity": {
					"locationName": "targetCapacity",
					"type": "integer"
				},
				"TerminateInstancesWithExpiration": {
					"locationName": "terminateInstancesWithExpiration",
					"type": "boolean"
				},
				"Type": {
					"locationName": "type"
				},
				"ValidFrom": {
					"locationName": "validFrom",
					"type": "timestamp"
				},
				"ValidUntil": {
					"locationName": "validUntil",
					"type": "timestamp"
				},
				"ReplaceUnhealthyInstances": {
					"locationName": "replaceUnhealthyInstances",
					"type": "boolean"
				}
			}
		},
		"Sij": {
			"type": "list",
			"member": {
				"locationName": "item",
				"type": "structure",
				"members": {
					"AssociatePublicIpAddress": {
						"locationName": "associatePublicIpAddress",
						"type": "boolean"
					},
					"DeleteOnTermination": {
						"locationName": "deleteOnTermination",
						"type": "boolean"
					},
					"Description": {
						"locationName": "description"
					},
					"DeviceIndex": {
						"locationName": "deviceIndex",
						"type": "integer"
					},
					"Groups": {
						"shape": "S5r",
						"locationName": "SecurityGroupId"
					},
					"Ipv6AddressCount": {
						"locationName": "ipv6AddressCount",
						"type": "integer"
					},
					"Ipv6Addresses": {
						"shape": "S5s",
						"locationName": "ipv6AddressesSet",
						"queryName": "Ipv6Addresses"
					},
					"NetworkInterfaceId": {
						"locationName": "networkInterfaceId"
					},
					"PrivateIpAddress": {
						"locationName": "privateIpAddress"
					},
					"PrivateIpAddresses": {
						"shape": "S5u",
						"locationName": "privateIpAddressesSet",
						"queryName": "PrivateIpAddresses"
					},
					"SecondaryPrivateIpAddressCount": {
						"locationName": "secondaryPrivateIpAddressCount",
						"type": "integer"
					},
					"SubnetId": {
						"locationName": "subnetId"
					}
				}
			}
		},
		"Sil": {
			"type": "structure",
			"members": {
				"AvailabilityZone": {
					"locationName": "availabilityZone"
				},
				"GroupName": {
					"locationName": "groupName"
				},
				"Tenancy": {
					"locationName": "tenancy"
				}
			}
		},
		"Sir": {
			"type": "list",
			"member": {
				"locationName": "item",
				"type": "structure",
				"members": {
					"ActualBlockHourlyPrice": {
						"locationName": "actualBlockHourlyPrice"
					},
					"AvailabilityZoneGroup": {
						"locationName": "availabilityZoneGroup"
					},
					"BlockDurationMinutes": {
						"locationName": "blockDurationMinutes",
						"type": "integer"
					},
					"CreateTime": {
						"locationName": "createTime",
						"type": "timestamp"
					},
					"Fault": {
						"shape": "S75",
						"locationName": "fault"
					},
					"InstanceId": {
						"locationName": "instanceId"
					},
					"LaunchGroup": {
						"locationName": "launchGroup"
					},
					"LaunchSpecification": {
						"locationName": "launchSpecification",
						"type": "structure",
						"members": {
							"UserData": {
								"locationName": "userData"
							},
							"SecurityGroups": {
								"shape": "S60",
								"locationName": "groupSet"
							},
							"AddressingType": {
								"locationName": "addressingType"
							},
							"BlockDeviceMappings": {
								"shape": "Sco",
								"locationName": "blockDeviceMapping"
							},
							"EbsOptimized": {
								"locationName": "ebsOptimized",
								"type": "boolean"
							},
							"IamInstanceProfile": {
								"shape": "S13",
								"locationName": "iamInstanceProfile"
							},
							"ImageId": {
								"locationName": "imageId"
							},
							"InstanceType": {
								"locationName": "instanceType"
							},
							"KernelId": {
								"locationName": "kernelId"
							},
							"KeyName": {
								"locationName": "keyName"
							},
							"NetworkInterfaces": {
								"shape": "Sij",
								"locationName": "networkInterfaceSet"
							},
							"Placement": {
								"shape": "Sil",
								"locationName": "placement"
							},
							"RamdiskId": {
								"locationName": "ramdiskId"
							},
							"SubnetId": {
								"locationName": "subnetId"
							},
							"Monitoring": {
								"shape": "Siu",
								"locationName": "monitoring"
							}
						}
					},
					"LaunchedAvailabilityZone": {
						"locationName": "launchedAvailabilityZone"
					},
					"ProductDescription": {
						"locationName": "productDescription"
					},
					"SpotInstanceRequestId": {
						"locationName": "spotInstanceRequestId"
					},
					"SpotPrice": {
						"locationName": "spotPrice"
					},
					"State": {
						"locationName": "state"
					},
					"Status": {
						"locationName": "status",
						"type": "structure",
						"members": {
							"Code": {
								"locationName": "code"
							},
							"Message": {
								"locationName": "message"
							},
							"UpdateTime": {
								"locationName": "updateTime",
								"type": "timestamp"
							}
						}
					},
					"Tags": {
						"shape": "Sl",
						"locationName": "tagSet"
					},
					"Type": {
						"locationName": "type"
					},
					"ValidFrom": {
						"locationName": "validFrom",
						"type": "timestamp"
					},
					"ValidUntil": {
						"locationName": "validUntil",
						"type": "timestamp"
					}
				}
			}
		},
		"Siu": {
			"type": "structure",
			"required": [
				"Enabled"
			],
			"members": {
				"Enabled": {
					"locationName": "enabled",
					"type": "boolean"
				}
			}
		},
		"Sj8": {
			"type": "list",
			"member": {
				"locationName": "item",
				"type": "structure",
				"members": {
					"FromPort": {
						"locationName": "fromPort",
						"type": "integer"
					},
					"IpProtocol": {
						"locationName": "ipProtocol"
					},
					"IpRanges": {
						"locationName": "ipRanges",
						"type": "list",
						"member": {
							"locationName": "item"
						}
					},
					"PrefixListIds": {
						"locationName": "prefixListIds",
						"type": "list",
						"member": {
							"locationName": "item"
						}
					},
					"ToPort": {
						"locationName": "toPort",
						"type": "integer"
					},
					"UserIdGroupPairs": {
						"locationName": "groups",
						"type": "list",
						"member": {
							"shape": "S28",
							"locationName": "item"
						}
					}
				}
			}
		},
		"Sjp": {
			"type": "list",
			"member": {
				"locationName": "VolumeId"
			}
		},
		"Sk8": {
			"type": "structure",
			"members": {
				"VolumeId": {
					"locationName": "volumeId"
				},
				"ModificationState": {
					"locationName": "modificationState"
				},
				"StatusMessage": {
					"locationName": "statusMessage"
				},
				"TargetSize": {
					"locationName": "targetSize",
					"type": "integer"
				},
				"TargetIops": {
					"locationName": "targetIops",
					"type": "integer"
				},
				"TargetVolumeType": {
					"locationName": "targetVolumeType"
				},
				"OriginalSize": {
					"locationName": "originalSize",
					"type": "integer"
				},
				"OriginalIops": {
					"locationName": "originalIops",
					"type": "integer"
				},
				"OriginalVolumeType": {
					"locationName": "originalVolumeType"
				},
				"Progress": {
					"locationName": "progress",
					"type": "long"
				},
				"StartTime": {
					"locationName": "startTime",
					"type": "timestamp"
				},
				"EndTime": {
					"locationName": "endTime",
					"type": "timestamp"
				}
			}
		},
		"Ske": {
			"type": "list",
			"member": {
				"locationName": "VpcId"
			}
		},
		"Sm0": {
			"type": "list",
			"member": {
				"locationName": "item"
			}
		},
		"Sm2": {
			"type": "list",
			"member": {
				"type": "structure",
				"members": {
					"CurrencyCode": {
						"locationName": "currencyCode"
					},
					"Duration": {
						"locationName": "duration",
						"type": "integer"
					},
					"HostIdSet": {
						"shape": "Sbx",
						"locationName": "hostIdSet"
					},
					"HostReservationId": {
						"locationName": "hostReservationId"
					},
					"HourlyPrice": {
						"locationName": "hourlyPrice"
					},
					"InstanceFamily": {
						"locationName": "instanceFamily"
					},
					"PaymentOption": {
						"locationName": "paymentOption"
					},
					"UpfrontPrice": {
						"locationName": "upfrontPrice"
					}
				}
			}
		},
		"Sm8": {
			"type": "structure",
			"members": {
				"HourlyPrice": {
					"locationName": "hourlyPrice"
				},
				"RemainingTotalValue": {
					"locationName": "remainingTotalValue"
				},
				"RemainingUpfrontValue": {
					"locationName": "remainingUpfrontValue"
				}
			}
		},
		"Smf": {
			"type": "structure",
			"members": {
				"Comment": {},
				"UploadEnd": {
					"type": "timestamp"
				},
				"UploadSize": {
					"type": "double"
				},
				"UploadStart": {
					"type": "timestamp"
				}
			}
		},
		"Smi": {
			"type": "structure",
			"members": {
				"S3Bucket": {},
				"S3Key": {}
			}
		},
		"Smn": {
			"type": "structure",
			"required": [
				"Bytes",
				"Format",
				"ImportManifestUrl"
			],
			"members": {
				"Bytes": {
					"locationName": "bytes",
					"type": "long"
				},
				"Format": {
					"locationName": "format"
				},
				"ImportManifestUrl": {
					"locationName": "importManifestUrl"
				}
			}
		},
		"Smo": {
			"type": "structure",
			"required": [
				"Size"
			],
			"members": {
				"Size": {
					"locationName": "size",
					"type": "long"
				}
			}
		},
		"Smq": {
			"type": "list",
			"member": {
				"locationName": "SecurityGroup"
			}
		},
		"Sn3": {
			"type": "list",
			"member": {
				"shape": "S4i",
				"locationName": "item"
			}
		},
		"Snb": {
			"type": "list",
			"member": {
				"locationName": "UserId"
			}
		},
		"So2": {
			"type": "structure",
			"members": {
				"AllowDnsResolutionFromRemoteVpc": {
					"type": "boolean"
				},
				"AllowEgressFromLocalClassicLinkToRemoteVpc": {
					"type": "boolean"
				},
				"AllowEgressFromLocalVpcToRemoteClassicLink": {
					"type": "boolean"
				}
			}
		},
		"So4": {
			"type": "structure",
			"members": {
				"AllowDnsResolutionFromRemoteVpc": {
					"locationName": "allowDnsResolutionFromRemoteVpc",
					"type": "boolean"
				},
				"AllowEgressFromLocalClassicLinkToRemoteVpc": {
					"locationName": "allowEgressFromLocalClassicLinkToRemoteVpc",
					"type": "boolean"
				},
				"AllowEgressFromLocalVpcToRemoteClassicLink": {
					"locationName": "allowEgressFromLocalVpcToRemoteClassicLink",
					"type": "boolean"
				}
			}
		},
		"So7": {
			"type": "list",
			"member": {
				"locationName": "item",
				"type": "structure",
				"members": {
					"InstanceId": {
						"locationName": "instanceId"
					},
					"Monitoring": {
						"shape": "Seb",
						"locationName": "monitoring"
					}
				}
			}
		},
		"Spx": {
			"type": "list",
			"member": {
				"locationName": "SecurityGroupId"
			}
		},
		"Sq8": {
			"type": "list",
			"member": {
				"locationName": "item",
				"type": "structure",
				"members": {
					"CurrentState": {
						"shape": "Sdw",
						"locationName": "currentState"
					},
					"InstanceId": {
						"locationName": "instanceId"
					},
					"PreviousState": {
						"shape": "Sdw",
						"locationName": "previousState"
					}
				}
			}
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./~/aws-sdk/apis/ec2-2016-11-15.min.json
// module id = 596
// module chunks = 0